import { UploadIdentificationCommandResultStatus } from "Api/Api";
import {
  AddressType,
  Bank,
  BankEnvironment,
  LicenseCode,
  LoyaltyEventCode,
  PartyType,
  TransactionStatus,
  UploadIdentificationCommandResultStatus2,
  VatStatus,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "./Resources";

export const VietnameseResourcesDictionary: ResourceDictionary = {
  Hooks: {
    BankingAuth: {
      Error: "Kết nối ngân hàng không thành công",
    },
    Employee: {
      AccessSent: "Đã gửi lời mời cho nhân viên",
      BackOfficeTargetError:
        "Địa chỉ e-mail này thuộc về tài khoản nội bộ của {{appName}} (Admin, AML, onboarding) và không thể được mời. Hãy sử dụng địa chỉ e-mail khác.",
      AccessSendError: "Không thể gửi quyền truy cập cho nhân viên",
      EmployeeExistsError:
        "Người này đã có quyền truy cập nhân viên vào công ty này",
      InviteeNotRegisteredError:
        "Không có tài khoản {{appName}} nào cho e-mail này — người đó phải đăng ký {{appName}} trước, sau đó bạn mới có thể mời họ",
      InvitationCancelled: "Đã hủy lời mời",
      InvitationCancelError: "Không thể hủy lời mời",
      EmployeeRemoved: "Đã xóa nhân viên",
      EmployeeRemoveError: "Không thể xóa nhân viên",
    },
    Notifications: {
      Created: "Tạo thông báo thành công",
      CreateError: "Lỗi khi tạo thông báo",
      Updated: "Cập nhật thông báo thành công",
      UpdateError: "Lỗi khi cập nhật thông báo",
      Deleted: "Xóa thông báo thành công",
      DeleteError: "Lỗi khi xóa thông báo",
      Restored: "Khôi phục thông báo thành công",
      RestoreError: "Lỗi khi khôi phục thông báo",
    },
    OCR: {
      Error: "Không thể đọc dữ liệu từ tài liệu",
      Declined: "Giấy tờ không vượt qua kiểm tra tự động.",
    },
    Paypoint: {
      PaypointEdited: "Điểm thanh toán {{name}} đã được chỉnh sửa",
      AssignNfcCardSuccess: "Thẻ NFC đã được gán cho điểm thanh toán {{name}}",
      AssignNfcCardError: "Lỗi khi gán thẻ NFC cho điểm thanh toán",
      PaypointEditError: "Lỗi khi chỉnh sửa điểm thanh toán",
      PaypointCreateError: "Lỗi khi tạo điểm thanh toán",
      PaypointCreated: "Điểm thanh toán {{name}} đã được tạo",
      AssignNfcCardNoConflict:
        "Lỗi - Thẻ NFC đã được gán cho điểm thanh toán khác",
      ScanError: "Không thể bắt đầu thanh toán, vui lòng thử lại",
    },
    Transaction: {
      TipUpdateError: "Không thể cập nhật tiền tip",
    },
    BankingAccount: {
      Deleted: "Tài khoản ngân hàng đã bị xóa",
      DeleteError: "Lỗi khi xóa tài khoản ngân hàng",
      PrimaryAccountChanged: "Tài khoản chính đã được thay đổi",
      PrimaryAccountChangeError: "Lỗi khi thay đổi tài khoản chính",
      StatusChanged: "Tài khoản đã được chỉnh sửa",
      StatusChangeError: "Lỗi khi chỉnh sửa tài khoản",
    },
    TerminalContract: {
      DownloadError: "Lỗi khi tải hợp đồng thiết bị đầu cuối",
      UcbContractPrefix: "UCB_ban_nhap_hop_dong_",
    },
    Verifications: {
      Error: "Lỗi khi xác minh dữ liệu đăng ký",
    },
    VerificationEmail: {
      Error: "Lỗi khi gửi e-mail xác minh",
      Success: "Đã gửi e-mail xác minh",
    },
    CampaignTransaction: {
      Error: "Lỗi khi khởi tạo giao dịch chiến dịch",
      Success: "Khởi tạo giao dịch chiến dịch thành công",
    },
    Ares: {
      Error: "Lỗi khi kết nối với sổ đăng ký doanh nghiệp",
      SubjectNotFound: "Không tìm thấy đối tượng",
    },
  },
  Stories: {
    Bar: {
      YourStory: "Story của bạn",
    },
    ImageUpload: {
      Prompt: "Kéo ảnh vào đây hoặc nhấp để chọn",
      Error: "Tải ảnh lên thất bại",
      InvalidType: "Chỉ hỗ trợ hình ảnh PNG, JPEG hoặc WebP",
      TooLarge: "Hình ảnh tối đa {{megabytes}} MB",
    },
    VideoUpload: {
      Prompt: "Kéo video vào đây hoặc nhấp để chọn",
      Error: "Tải video lên thất bại",
      TooLong: "Video chỉ được dài tối đa {{seconds}} giây",
      InvalidType: "Chỉ hỗ trợ video MP4, WebM hoặc MOV",
      TooLarge: "Video tối đa {{megabytes}} MB",
    },
    Management: {
      Title: "Stories",
      CreateButton: "Story mới",
      Empty: "Chưa có story nào",
      LoadError: "Không thể tải stories",
      Status: {
        Draft: "Bản nháp",
        Live: "Đang hiển thị",
        Expired: "Đã hết hạn",
        Unpublished: "Đã gỡ",
      },
      Table: {
        Author: "Tác giả",
        Text: "Nội dung",
        State: "Trạng thái",
        LastPublishedAt: "Đăng lần cuối",
        ExpiresAt: "Hết hạn",
        DateCreated: "Tạo lúc",
        Publications: "Số lần đăng",
        Actions: "Thao tác",
        Preview: "Xem trước",
        Publish: "Đăng",
        Republish: "Đăng lại",
        LiveUntil: "Hiển thị đến {{dateTime}}",
        Unpublish: "Gỡ xuống",
      },
      Messages: {
        PublishSuccess: "Đã đăng story",
        PublishError: "Đăng không thành công",
        DeleteSuccess: "Đã xóa story",
        DeleteError: "Xóa không thành công",
        DeleteConfirmTitle: "Xóa story?",
        DeleteConfirm: "Story sẽ bị xóa vĩnh viễn.",
        LockedWhileLive:
          "Không thể chỉnh sửa story đang hiển thị cho đến khi hết hạn hoặc bị gỡ xuống.",
        UnpublishSuccess: "Đã gỡ story",
        UnpublishError: "Gỡ story không thành công",
        UnpublishConfirmTitle: "Gỡ story xuống?",
        UnpublishConfirm:
          "Người xem sẽ không còn thấy ngay lập tức. Bạn có thể chỉnh sửa và đăng lại sau; đăng lại sẽ dùng thêm một lượt trong giới hạn hàng ngày của tác giả.",
        NotLiveAnymore: "Story không còn hiển thị; danh sách đã được làm mới",
      },
      Form: {
        CreateTitle: "Story mới",
        EditTitle: "Chỉnh sửa story",
        SaveAndPublish: "Lưu và đăng",
        SaveDraft: "Lưu bản nháp",
        Save: "Lưu",
        SaveSuccess: "Đã lưu story",
        SaveError: "Lưu không thành công",
      },
    },
    PostStory: {
      StoryImage: "Ảnh story",
      StoryVideo: "Video story",
      Text: "Nội dung",
      ButtonLabel: "Nhãn nút",
      ButtonUrl: "Liên kết nút",
      SheetSection: "Chi tiết ưu đãi",
      SheetTitle: "Tiêu đề",
      SheetDescription: "Mô tả",
      SheetPrice: "Giá",
      SheetPriceNote: "Ghi chú giá",
      SheetImage: "Ảnh ưu đãi",
      Form: {
        Format: {
          Title: "Định dạng",
          Subtitle: "Chọn một — story là ảnh hoặc video.",
          PhotoTitle: "Story ảnh",
          PhotoHint: "{{formats}} · hiển thị trong {{seconds}} giây",
          VideoTitle: "Story video",
          VideoHint: "{{formats}} · tối đa {{seconds}} giây",
        },
        Media: {
          PhotoTitle: "Ảnh",
          PhotoSubtitle: "Ảnh dọc 9:16 là tốt nhất. Tối đa {{megabytes}} MB.",
          VideoTitle: "Video",
          VideoSubtitle:
            "Video dọc 9:16 là tốt nhất. Tối đa {{seconds}} giây và {{megabytes}} MB.",
          PosterLabel: "Ảnh bìa",
          PosterHint:
            "Không bắt buộc. Không có ảnh bìa, story sẽ mở với khung hình đen cho đến khi video bắt đầu.",
        },
        Text: {
          Title: "Nội dung",
        },
        Button: {
          Title: "Nút",
          Subtitle:
            "Hiển thị trên story và mở ưu đãi này. Liên kết được dùng cho nút bên trong ưu đãi.",
          LabelPlaceholder: "ví dụ: Nhận ưu đãi",
          UrlPlaceholder: "https://…",
        },
        Offer: {
          Subtitle: "Gắn một ưu đãi trên marketplace vào story này.",
          Attach: "Gắn ưu đãi",
          Remove: "Gỡ ưu đãi",
        },
      },
      LimitExceeded:
        "Bạn đã đạt giới hạn story trong 24 giờ qua. Vui lòng thử lại sau.",
      UsageLabel: "Story đã đăng trong 24 giờ qua: {{used}} / {{limit}}",
      Validation: {
        MediaRequired: "Story cần có ảnh hoặc video",
        ButtonUrlInvalid: "Nhập liên kết hợp lệ bắt đầu bằng https://",
        ButtonLabelRequired: "Ưu đãi cần nhãn nút để mở",
      },
    },
  },
  Common: {
    TurnOn: "Bật",
    LoadMore: "Tải thêm",
    BackToMoone: "Quay lại {{appName}}",
    DownloadError: "Tải tệp xuống không thành công",
    SaveError: "Lưu không thành công",
    UnknownUserType: "Loại người dùng không xác định",
    Unsupported: "không được hỗ trợ",
    Retry: "Thử lại",
    Restore: "Khôi phục",
    TaxNumber: "Mã số thuế",
    VatNumber: "Mã số thuế GTGT",
    VatStatus: {
      [VatStatus.Unknown]: "Chưa xác minh",
      [VatStatus.NotRegistered]: "Chưa đăng ký thuế GTGT",
      [VatStatus.Registered]: "Mã số thuế GTGT hợp lệ",
      [VatStatus.Payer]: "Người nộp thuế GTGT",
      [VatStatus.RegisteredNonPayer]: "Đối tượng được định danh thuế GTGT",
    },
    VatRegistryStatusLabel: "Trạng thái trong sổ đăng ký thuế GTGT",
    VatRegistryStatus: "Sổ đăng ký thuế GTGT: {{status}}",
    VatRegistryUnavailableHint:
      "Sổ đăng ký thuế GTGT hiện không phản hồi. Bạn có thể nhập mã số thuế GTGT ngay bây giờ hoặc bất cứ lúc nào sau này.",
    VatNumberRejectedByRegistry:
      "Sổ đăng ký thuế GTGT không có mã số thuế GTGT này. Hãy kiểm tra xem bạn đã nhập đúng chưa — nếu không, dịch vụ sẽ được lập hóa đơn kèm thuế GTGT của Séc.",
    Restart: "Khởi động lại",
    Loading: "Đang tải",
    ThankYou: "Cảm ơn bạn",
    Disable: "Vô hiệu hóa",
    Notes: "Ghi chú",
    Copy: "Sao chép",
    ComingSoon: "Sắp ra mắt",
    Month: "Tháng",
    NotAvailable: "Không khả dụng",
    Verification: {
      Verified: "Đã xác minh",
      NotVerified: "Chưa xác minh",
    },
    User: "Người dùng",
    AnonymousUser: "Người dùng {{appName}}",
    UnnamedChannel: "Kênh không tên",
    SearchMinCharsHint:
      "Tìm theo @biệt danh hoặc tên, nhập ít nhất {{minChars}} ký tự.",
    MoreOptions: "Tùy chọn khác",
    Yes: "Có",
    No: "Không",
    Back: "Quay lại",
    Next: "Tiếp theo",
    Close: "Đóng",
    Open: "Mở",
    Clear: "Xóa",
    Pause: "Tạm dừng",
    Play: "Phát",
    Mute: "Tắt tiếng",
    Unmute: "Bật tiếng",
    RiskProfileStatus: {
      NotVerified: "Chưa xác minh",
      LowRisk: "Rủi ro thấp",
      MediumRisk: "Rủi ro trung bình",
      HighRisk: "Rủi ro cao",
      Unacceptable: "Không chấp nhận được",
    },
    UserType: {
      Hunter: "Thợ săn",
      Customer: "Khách hàng",
      Merchant: "Đối tác",
      Admin: "Quản trị viên",
      Aml: "AML",
      Employee: "Nhân viên",
      CustomerOnboarding: "Đăng ký khách hàng",
      HunterPlus: "Hunter+",
      AdminLite: "Admin (chỉ đọc)",
      Disponent: "Người được ủy quyền",
      Child: "Trẻ em",
    },
    FacilityCategory: {
      Restaurants: "Nhà hàng",
      Food: "Thực phẩm",
      Car: "Ô tô",
      Electronics: "Điện tử",
      ClothingAndShoes: "Quần áo và Giày dép",
      HealthAndBeauty: "Sức khỏe và Làm đẹp",
      Finance: "Tài chính",
      LeisureTime: "Giải trí",
      PhoneTvAndInternet: "Điện thoại, TV và Internet",
      Housing: "Nhà ở",
      Travel: "Du lịch",
      Insurance: "Bảo hiểm",
      Education: "Giáo dục",
      Institutions: "Cơ quan",
      ConstructionAndMaintenance: "Xây dựng và Bảo trì",
      ECommerceAndOnlineServices: "Thương mại điện tử và Dịch vụ trực tuyến",
      PersonalServices: "Dịch vụ cá nhân",
      LegalAndConsultingServices: "Dịch vụ pháp lý và Tư vấn",
      IndustrialProductionAndProcessing: "Sản xuất và Chế biến công nghiệp",
      Other: "Khác",
    },
    WeekDay: {
      Monday: "Thứ Hai",
      Tuesday: "Thứ Ba",
      Wednesday: "Thứ Tư",
      Thursday: "Thứ Năm",
      Friday: "Thứ Sáu",
      Saturday: "Thứ Bảy",
      Sunday: "Chủ Nhật",
    },
    BeneficialOwner: {
      Title: "Chủ sở hữu hưởng lợi",
      Name: "Tên",
      LastName: "Họ",
      Gender: "Giới tính",
      BirthDate: "Ngày sinh",
      Nationality: "Quốc tịch",
      IsForeigner: "Là người nước ngoài",
    },
    Address: {
      Title: "Địa chỉ",
      NoAddressAvailable: "Không có địa chỉ",
      Type: {
        [AddressType.Permanent]: "Thường trú",
        [AddressType.Mail]: "Thư tín",
        [AddressType.Headquarters]: "Trụ sở chính",
      },
      Street: "Đường",
      StreetNumber: "Số nhà",
      OrientationNumber: "Số định hướng",
      PostalCode: "Mã bưu chính",
      Municipality: "Thành phố",
    },
    QRPayment: "Thanh toán QR",
    ShareToBankApp: "Chia sẻ đến ứng dụng ngân hàng",
    AppName: "{{appName}}",
    Amount: "Số tiền",
    TotalAmount: "Tổng số tiền",
    Note: "Ghi chú",
    MandatoryNoteDescription:
      "Ghi chú là bắt buộc! Nếu không có ghi chú, thanh toán sẽ không được ghép nối.",
    Unknown: "Không xác định",
    UnknownRecipient: "Người nhận không xác định",
    ShowAll: "Hiển thị tất cả",
    ShowMore: "Hiển thị thêm",
    ShowLess: "Hiển thị ít hơn",
    ShowProfile: "Xem trang cá nhân",
    VariableSymbol: "Ký hiệu biến",
    Required: "Trường bắt buộc",
    InvalidIBAN: "IBAN không hợp lệ",
    CancelEdit: "Hủy chỉnh sửa",
    Cancel: "Hủy",
    Confirm: "Xác nhận",
    UnsavedChangesTitle: "Thay đổi chưa lưu",
    UnsavedChangesWarning:
      "Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng biểu mẫu không? Tất cả dữ liệu chưa lưu sẽ bị mất.",
    DiscardChanges: "Bỏ thay đổi",
    NiceDay: "Chúc bạn một ngày tốt lành",
    Send: "Gửi",
    Continue: "Tiếp tục",
    FillMissing: "Vui lòng điền tất cả thông tin bắt buộc",
    IncompleteSection: "Thông tin trong phần này chưa đầy đủ",
    FirstName: "Tên",
    LastName: "Họ",
    Gender: "Giới tính",
    PersonalNumber: "Số định danh cá nhân",
    BirthPlace: "Nơi sinh",
    Nationality: "Quốc tịch",
    OtherNationalities: "Quốc tịch khác",
    Number: "Số",
    Type: "Loại",
    IdentityDocument: "Giấy tờ tùy thân",
    Contact: "Liên hệ",
    Phone: "Điện thoại",
    PhoneVerified: "Điện thoại đã xác minh",
    PhoneVerificationDescription:
      "Vui lòng xác minh số điện thoại của bạn. Điều này giúp bảo vệ {{appName}} khỏi thư rác và tài khoản giả.",
    Remove: "Gỡ",
    Replace: "Thay thế",
    Optional: "không bắt buộc",
    Delete: "Xóa",
    Edit: "Chỉnh sửa",
    Verify: "Xác minh",
    BirthDate: "Ngày sinh",
    AccountNumber: "Số tài khoản",
    TransactionPaymentCode: "Mã giao dịch",
    IBAN: "IBAN",
    Save: "Lưu",
    Saved: "Đã lưu",
    DownloadQRCode: "Tải mã QR",
    Email: "E-mail",
    Login: "Đăng nhập",
    CompanyName: "Tên công ty",
    CompanyNumber: "Mã số công ty",
    PartyTypeLabel: "Hình thức kinh doanh",
    GeneralInfo: "Thông tin chung",
    PartyType: {
      [PartyType.LegalEntity]: "Pháp nhân",
      [PartyType.SelfEmployed]: "Tự kinh doanh",
      [PartyType.NaturalPerson]: "Cá nhân",
    },
    PartyTypeShortcut: {
      [PartyType.LegalEntity]: "PN",
      [PartyType.SelfEmployed]: "TKD",
      [PartyType.NaturalPerson]: "CN",
    },
    Sent: "Đã gửi",
    Price: "Giá",
    License: "Giấy phép",
    Licenses: "Giấy phép",
    UnknownDate: "Ngày không xác định",
    Time: {
      TimePassed: {
        Now: "vừa xong",
        Minute: "phút trước",
        Hour: "giờ trước",
        Day: "ngày trước",
        Week: "tuần trước",
        Month: "tháng trước",
        Year: "năm trước",
        Minute_one: "{{count}} phút trước",
        Minute_other: "{{count}} phút trước",
        Hour_one: "{{count}} giờ trước",
        Hour_other: "{{count}} giờ trước",
        Day_one: "{{count}} ngày trước",
        Day_other: "{{count}} ngày trước",
        Week_one: "{{count}} tuần trước",
        Week_other: "{{count}} tuần trước",
        Month_one: "{{count}} tháng trước",
        Month_other: "{{count}} tháng trước",
        Year_one: "{{count}} năm trước",
        Year_other: "{{count}} năm trước",
      },
      TimeRemaining: {
        Minute: "phút",
        Hour: "giờ",
        Day: "ngày",
        Week: "tuần",
        Month: "tháng",
        Year: "năm",
        Minute_one: "{{count}} phút",
        Minute_other: "{{count}} phút",
        Hour_one: "{{count}} giờ",
        Hour_other: "{{count}} giờ",
        Day_one: "{{count}} ngày",
        Day_other: "{{count}} ngày",
        Week_one: "{{count}} tuần",
        Week_other: "{{count}} tuần",
        Month_one: "{{count}} tháng",
        Month_other: "{{count}} tháng",
        Year_one: "{{count}} năm",
        Year_other: "{{count}} năm",
      },
    },
    QRInstructions:
      "Không điền dữ liệu thủ công, hãy sử dụng mã QR mà bạn có thể quét trong ứng dụng ngân hàng di động!",
    Status: "Trạng thái",
    Balance: "Số dư",
  },
  CodeLists: {
    IdentificationList: {
      IDCard: "Thẻ căn cước",
      Passport: "Hộ chiếu",
      DrivingLicense: "Bằng lái xe",
      Other: "Khác",
    },
    IdentityDocumentVerdict: {
      NotChecked: "Chưa kiểm tra",
      Approved: "Đã chấp thuận",
      Declined: "Bị từ chối",
      InReview: "Kiểm tra thủ công",
      Unavailable: "Kiểm tra không khả dụng",
    },
  },
  Errors: {
    MissingId: "Lỗi: thiếu ID",
    DataLoadingError: "Không thể tải dữ liệu",
    RequestError: "Đã xảy ra lỗi trong quá trình yêu cầu",
    ApplicationError: {
      Title: "Đã xảy ra lỗi",
      Home: "Trang chủ",
      ErrorOccurred: "Chúng tôi xin lỗi, nhưng đã xảy ra lỗi trong ứng dụng",
      TeamHasBeenInformed:
        "Các nhà phát triển của chúng tôi đã được thông báo về lỗi và đang làm việc để khắc phục.",
      AreYouDeveloper: "Bạn là nhà phát triển? Xem lỗi là gì.",
    },
    Error404: {
      Subtitle: "Không tìm thấy trang",
      Home: "Trang chủ",
    },
    Error403: {
      Subtitle: "Bạn không có quyền truy cập để xem trang này",
    },
    NoUserRole: "Lỗi, người dùng không được gán vai trò",
    UnknownError: "Đã xảy ra lỗi không xác định",
  },
  Offline: {
    Title: "Bạn đang ngoại tuyến",
    NoInternet: "Kiểm tra kết nối internet của bạn và thử lại.",
    ServerUnreachable: {
      Title: "Sự cố kết nối",
      Message:
        "Chúng tôi đang gặp sự cố kỹ thuật. Chúng tôi đang làm việc để khắc phục. Xin lỗi vì sự bất tiện này.",
    },
    Reconnected: "Đã khôi phục kết nối",
  },
  SignIn: {
    Title: "Đăng nhập",
    Form: {
      Controls: {
        SignInButtonLabel: "Đăng nhập",
        CancelButtonLabel: "Hủy",
        ForgottenPassword: "Quên mật khẩu?",
      },
      Fields: {
        Email: "E-mail",
        Password: "Mật khẩu",
      },
    },
    Error: {
      General: "Đã xảy ra lỗi",
      Forbidden: "Mật khẩu hoặc e-mail không đúng",
      InvalidLogin: "Mật khẩu hoặc e-mail không đúng",
      InvalidCredentials: "Mật khẩu hoặc e-mail không đúng",
      ApplicationVerification: "Mật khẩu hoặc e-mail không đúng",
      PhoneNumberNotFound: "Không tìm thấy số điện thoại",
      SmsSendingFailed: "Gửi SMS thất bại",
      InvalidToken: "Mã không hợp lệ",
      AccountNotFound: "Mật khẩu hoặc e-mail không đúng",
      NotFound: "Mật khẩu hoặc e-mail không đúng",
      AccountIsDeactivated:
        "Tài khoản đã bị vô hiệu hóa. Nếu bạn muốn khôi phục tài khoản, vui lòng liên hệ hỗ trợ.",
      AccountLinkedToIdentity:
        "Tài khoản này đã được chuyển sang tài khoản chính của bạn. Vui lòng đăng nhập bằng e-mail của tài khoản chính.",
    },
  },
  SignUp: {
    Title: {
      Merchant: "Tài khoản doanh nghiệp mới",
      Customer: "Tài khoản cá nhân mới",
      Hunter: "Tài khoản hunter mới",
    },
    Form: {
      Controls: {
        SignUpButtonLabel: "Đăng ký",
      },
      Fields: {
        Login: "E-mail",
        Password: "Mật khẩu",
        AgreeWithTermsAndConditions: {
          MooneLite: {
            Text: "Tôi đồng ý với",
            LinkText: "điều khoản và điều kiện {{appName}} Lite",
            LinkUrl: "/content/terms/Moone-moone-lite.pdf",
          },
          FullMooneEULA: {
            StartText:
              "Bằng cách đăng ký trong ứng dụng {{appName}}, tôi đồng ý với",
            ContractText: "Hợp đồng dịch vụ thanh toán",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "với công ty Mo.one a.s., bao gồm các",
            RelatedDocsText: "điều khoản liên quan",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
          EULACheckboxLabel: {
            StartText:
              "Bằng cách đăng ký trong ứng dụng {{appName}}, tôi đồng ý với",
            ContractText: "Hợp đồng dịch vụ thanh toán",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "của công ty Mo.one a.s., bao gồm các",
            RelatedDocsText: "điều khoản liên quan",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
          HunterEULACheckboxLabel: {
            StartText: "Bằng cách mua giấy phép thợ săn, tôi đồng ý với",
            ContractText: "Hợp đồng nhượng quyền kỹ thuật số",
            ContractUrl:
              "/content/terms/legione-hunters-franchise-contract.pdf",
            MiddleText: "của LEGI.ONE LTD., bao gồm các",
            RelatedDocsText: "Điều khoản liên quan",
            RelatedDocsUrl: "/content/terms/2-hunters-related-terms.pdf",
          },
        },
      },
    },
    Error: {
      General: "Đã xảy ra lỗi",
      UserExists: "Tài khoản đã tồn tại",
      WeakPassword:
        "Mật khẩu phải có ít nhất 8 ký tự và chứa một chữ thường, một chữ hoa và một số",
    },
    AffiliateLandingDisclaimer: {
      Title: "Bạn đã có tài khoản Mo.one?",
      Body: "Nếu bạn đã có tài khoản, hãy đăng nhập thay vì đăng ký lại và cho người mời biết email của bạn — họ có thể gửi lời mời thẳng vào hộp thư trong ứng dụng của bạn.",
      SignInButton: "Đăng nhập",
    },
  },
  Validation: {
    InvalidLogin: "Đăng nhập không hợp lệ",
    InvalidPersonalNumber: "Số định danh cá nhân không hợp lệ",
    OtherNationalitySameAsPrimary:
      "Quốc tịch khác phải khác với quốc tịch chính",
    InvalidVatNumber: "Mã số thuế GTGT không hợp lệ",
    PersonalNumber:
      "Số định danh cá nhân phải có tối đa {{count}} chữ số, nhập không có dấu gạch chéo",
    CompanyName: "Tên công ty là bắt buộc",
    CompanyNumber: "Mã số công ty phải có {{count}} chữ số",
    Phone: {
      InvalidFormat: "Định dạng số điện thoại không hợp lệ",
      MinDigits: "Số điện thoại phải chứa ít nhất {{count}} chữ số",
      MaxCharacters: "Số điện thoại phải chứa tối đa {{count}} ký tự",
    },
    Required: "Vui lòng điền vào trường này",
    InvalidEmail: "E-mail không hợp lệ",
    InvalidUrl: "URL không hợp lệ",
    Password: {
      Required: "Vui lòng điền vào trường này",
      MinLength: "Ít nhất {{length}} ký tự",
      MinLowercase: "Ít nhất một chữ thường",
      MinUppercase: "Ít nhất một chữ hoa",
      MinNumber: "Ít nhất một số",
      Match: "Mật khẩu không khớp",
      MatchRequirement: "Mật khẩu khớp nhau",
    },
    EulaAgreement: "Bạn phải đồng ý với các điều khoản và điều kiện",
    WalletAddress: "Với ví riêng, bạn phải điền địa chỉ ví",
    InvalidBankAccount: "Tài khoản ngân hàng không hợp lệ",
    InvalidPostalCode: "Nhập mã bưu chính theo định dạng 763 02",
    ResidenceRequired:
      "Điền nơi cư trú của người này — tên phố hoặc số nhà, thành phố và mã bưu chính",
    ExpirationAfterScheduled: "Ngày hết hạn phải sau ngày lên lịch",
    DateMustBeInFuture: "Ngày phải trong tương lai",
    TimeMustBeInFuture: "Thời gian phải trong tương lai",
    MaxLength: "Trường này phải có tối đa {{count}} ký tự",
  },
  ValidationMessages: {
    Required: "Vui lòng điền vào trường này",
    ArrayMinOne: "Phải chọn ít nhất một tùy chọn",
    TooSmallString: "Phải có ít nhất {{minimum}} ký tự",
    TooBigString: "Phải có tối đa {{maximum}} ký tự",
    InvalidEmail: "Vui lòng nhập địa chỉ email hợp lệ",
    InvalidUrl: "Vui lòng nhập URL hợp lệ",
  },
  Menu: {
    BottomMenuItems: {
      Overview: "Tổng quan",
      History: "Giao dịch",
      InitiateKeypadPayment: "Đăng ký",
      ActionButton: "Thanh toán",
      Accounts: "Tài khoản",
      Settings: "Thêm",
      Merchants: "Đối tác",
      Licenses: "Giấy phép",
      NewMerchant: "Đối tác",
      Users: "Người dùng",
      Stardust: "Stardust",
      Valor: "Valor",
      Settlement: "Quyết toán",
      ThanksToYou: "Cảm ơn bạn!",
      NotificationsManagement: "Thông báo",
      ToBeVerified: "Xác minh",
      Hunters: "Hunters",
      WhereToPay: "Thanh toán ở đâu",
      Chat: "Chat",
    },
    Help: "Trợ giúp",
    Logout: "Đăng xuất",
  },
  Onboarding: {
    ProcessTitle: "Thông tin về bạn",
    Title: "Xác minh danh tính của bạn",
    LoadingTitle: "Thông tin về bạn",
    ErrorTitle: "Lỗi ứng dụng",
    BeneficialOwnersTitle: "Chủ sở hữu thực sự",
    LicenseSelectionTitle: "Chào mừng đến với Legi.one",
    ManualLicensePaymentTitle: "Thanh toán giấy phép",
    BankAccountVerificationTitle: "Xác minh tài khoản",
    PoliticallyExposed: {
      Title: "Tôi là người có ảnh hưởng chính trị",
      Alert:
        "Rất tiếc, hiện tại chúng tôi không thể cung cấp dịch vụ cho những người có ảnh hưởng chính trị.",
    },
    HunterDescription: {
      IdentityVerification:
        "Trước khi chúng ta chính thức bắt đầu cùng nhau, chúng tôi cần xác minh danh tính của bạn.",
      HCRMDescription:
        "HCRM (Hunter & Customer Relationship Manager) là môi trường làm việc cá nhân của bạn trong Legi.one.",
      RemoteContract:
        "Từ đây bạn sẽ đăng ký đối tác mới, theo dõi mạng lưới của bạn, quản lý phần thưởng và có cái nhìn tổng quan về mọi thứ quan trọng. Đó là cơ sở kỹ thuật số của bạn.",
      DocumentSecurity:
        "Vì chúng tôi đang ký hợp đồng từ xa, chúng tôi cần xác minh rằng đó thực sự là bạn.",
      QuickProcess:
        "Đó là nguyên tắc tương tự như khi bạn ký hợp đồng với nhà mạng hoặc dịch vụ tài chính trực tuyến – nếu không gặp trực tiếp, việc xác minh là cần thiết.",
      Welcome: "Chào mừng đến với Legi.one HCRM!",
      IdentityVerificationRequired:
        "Trước khi chúng ta chính thức bắt đầu cùng nhau, chúng tôi cần xác minh danh tính của bạn.",
      HCRMWorkEnvironment:
        "Từ đây bạn sẽ đăng ký đối tác mới, theo dõi mạng lưới của bạn, quản lý phần thưởng và có cái nhìn tổng quan về mọi thứ quan trọng. Đó là cơ sở kỹ thuật số của bạn.",
      RemoteContractVerification:
        "Vì chúng tôi đang ký hợp đồng từ xa, chúng tôi cần xác minh rằng đó thực sự là bạn.",
      VerificationPrinciple:
        "Đó là nguyên tắc tương tự như khi bạn ký hợp đồng với nhà mạng hoặc dịch vụ tài chính trực tuyến – nếu không gặp trực tiếp, việc xác minh là cần thiết.",
      QuickProcessAndWelcome:
        "Chỉ mất một phút – và sau đó bạn có thể bắt đầu sử dụng đầy đủ tất cả các tính năng HCRM. Chào mừng bạn đến với đội ngũ!",
    },
    MerchantOrCustomerDescription: {
      Welcome: "Chào mừng đến với {{appName}}!",
      IdentityVerificationRequired:
        "Trước khi chúng tôi mở tài khoản cho bạn, chúng tôi cần xác minh danh tính của bạn.",
      MoonePaymentIdentity:
        "{{appName}} không chỉ là một ứng dụng – đó là danh tính thanh toán của bạn.",
      PaymentIdentityDescription:
        "Với nó, bạn sẽ thanh toán, xác nhận giao dịch và chứng minh bản thân một cách an toàn qua các dịch vụ. Đó là lý do tại sao việc xác minh rằng đó thực sự là bạn là quan trọng.",
      LicensedPaymentInstitution:
        "Chúng tôi là tổ chức thanh toán được cấp phép dưới sự giám sát của Ngân hàng Quốc gia Séc.",
      BankLevelIdentityVerification:
        "Khi xác minh danh tính, các quy tắc tương tự như ngân hàng áp dụng cho chúng tôi – chúng được quy định bởi Luật số 253/2008 Coll., về một số biện pháp chống hợp pháp hóa tiền thu được từ hoạt động tội phạm và tài trợ khủng bố.",
      DocumentsUsagePurpose:
        "Tài liệu của bạn chỉ phục vụ cho mục đích này. Chúng được mã hóa, bảo vệ và chúng tôi sẽ không bao giờ sử dụng chúng theo cách khác mà không có sự đồng ý rõ ràng của bạn.",
      QuickProcessAndThankYou:
        "Bạn có thể làm điều đó trong một phút – và sau đó bạn có thể bắt đầu sử dụng đầy đủ {{appName}}. Cảm ơn bạn đã tin tưởng chúng tôi.",
    },
    Steps: {
      Documents: {
        NoOwningPartyError: "Không thể tải dữ liệu người dùng.",
        Declined: {
          Title: "Giấy tờ không vượt qua kiểm tra tự động",
          Description:
            "Hãy chụp lại giấy tờ (không dùng bản quét hoặc ảnh chụp màn hình), hoặc tiếp tục – nhân viên của chúng tôi sẽ xác minh giấy tờ thủ công.",
          Retry: "Tải lên lại",
          Continue: "Tiếp tục với kiểm tra thủ công",
          AttemptsLeft: "Số lần thử còn lại: {{count}}",
          AttemptsExhausted:
            "Không thể lặp lại kiểm tra tự động nữa. Hãy tiếp tục bước tiếp theo, nhân viên của chúng tôi sẽ xác minh giấy tờ.",
          Reasons: {
            DocumentExpired: "Giấy tờ đã hết hạn.",
            NotOriginal:
              "Đây không phải ảnh chụp giấy tờ thật (bản quét, bản sao hoặc ảnh chụp màn hình).",
            Unreadable:
              "Giấy tờ không đọc được – hãy chụp toàn bộ giấy tờ, rõ nét và không bị lóa.",
            Unsupported:
              "Chúng tôi không thể tự động xác minh loại giấy tờ này.",
            Generic: "Kiểm tra tự động không thể xác nhận giấy tờ.",
          },
        },
        ExistingDocumentsInfo:
          "Tài liệu của bạn đã được tải lên và đang được xử lý. Bạn có thể tiến hành bước tiếp theo.",
        LoadingError: "Không thể tải dữ liệu, vui lòng thử lại sau.",
        Processing: "Đang xử lý dữ liệu. Vui lòng đợi.",
        ProcessingFailed: "Không thể xử lý dữ liệu thẻ căn cước",
        FirstDocumentTitle: "Thẻ căn cước",
        SecondDocumentTitle: "Tài liệu thứ hai",
        SecondDocumentDescription:
          "Tài liệu thứ hai có thể là bằng lái xe hoặc hộ chiếu.",
        Forms: {
          DocumentTitle: "Tải lên bản quét tài liệu",
          DocumentDescription: "Nhấp vào đây để tải lên hoặc chụp ảnh",
          FrontSide: "Mặt trước thẻ căn cước",
          BackSide: "Mặt sau thẻ căn cước",
          SecondDocumentFrontSide: "Mặt trước tài liệu thứ hai",
          SecondDocumentBackSide: "Mặt sau tài liệu thứ hai",
          SecondDocumentTypeLabel: "Loại tài liệu thứ hai",
          SecondDocumentTypePassport: "Hộ chiếu",
          SecondDocumentTypeDrivingLicense: "Bằng lái xe",
          SecondDocumentTypeOther: "Khác",
        },
        Validations: {
          ForegroundMissing: "Vui lòng tải lên mặt trước thẻ căn cước của bạn",
          BackgroundMissing: "Vui lòng tải lên mặt sau thẻ căn cước của bạn",
          SecondForegroundMissing:
            "Vui lòng tải lên mặt trước của tài liệu thứ hai",
          SecondBackgroundMissing:
            "Vui lòng tải lên mặt sau của tài liệu thứ hai",
          SecondDocumentTypeMissing: "Vui lòng chọn loại tài liệu thứ hai",
        },
      },
      PersonalInformation: {
        SaveError: "Không thể lưu thông tin cá nhân",
        LoadingError: "Không thể tải thông tin cá nhân",
        Title: "Từ các tài liệu đã tải lên, chúng tôi đã đọc được dữ liệu sau:",
        DataConfirmation:
          "Tôi xác nhận rằng dữ liệu cơ bản và địa chỉ là chính xác",
        StardustParticipation: {
          Text: "Tôi đồng ý tham gia chương trình khách hàng thân thiết",
          LinkText: "Stardust",
          LinkUrl: "/content/terms/Moone-stardust-general.pdf",
        },
        ThanksToYouParticipation: {
          Text: "Tôi đồng ý tham gia chương trình giới thiệu",
          LinkText: "Cảm ơn bạn!",
        },
        FormGroups: {
          PersonalInformation: "Thông tin cơ bản",
          Address: "Địa chỉ",
          IdentityDocument: "Giấy tờ tùy thân",
        },
        DocumentValidity: {
          Generic: "Hiệu lực tài liệu",
          From: "Tài liệu có hiệu lực từ",
          To: "Tài liệu có hiệu lực đến",
        },
        ScanIncomplete:
          "Một số giá trị không được quét, kiểm tra thủ công sẽ được nhân viên của chúng tôi thực hiện.",
        DataMarkedAsIncorrect:
          "Cảm ơn thông tin, trong vòng 24 giờ kiểm tra sẽ được nhân viên của chúng tôi thực hiện.",
        DocumentIssued: "Tài liệu được cấp bởi",
        StreetAddress: "Đường",
        ConfirmDataRequest: "Bạn phải xác nhận rằng dữ liệu là chính xác",
        UseCompanyAddress: "Tôi sống tại địa chỉ công ty",
        ValueLabels: {
          PersonalInfo: {
            FirstName: "Tên",
            LastName: "Họ",
            PersonalNumber: "Số định danh cá nhân",
            BirthPlace: "Nơi sinh",
            Gender: "Giới tính",
            Nationality: "Quốc tịch",
          },
          AddressInfo: {
            StreetWithNumber: "Đường và số nhà",
            Municipality: "Thành phố",
            PostalCode: "Mã bưu chính",
          },
          DocumentInfo: {
            Type: "Loại",
            Number: "Số",
            Validity: "Hiệu lực",
            Issued: "Cấp bởi",
          },
        },
      },
      FinalStep: {
        SubmitButton: "Hoàn thành",
        LoadingError: "Lỗi, không thể tải dữ liệu cần thiết",
        SuccessToast: "Thông tin của bạn đã được gửi thành công.",
        Form: {
          HasNonEUResidence:
            "Tôi hiện tại (tính đến ngày đăng ký) cư trú ngoài EU hơn 12 tháng",
          HasNonEUNationality: "Tôi là công dân của một quốc gia ngoài EU",
        },
      },
    },
    BusinessOnboarding: {
      Steps: {
        LicenseSelection: {
          Title: "Chào mừng đến với Legi.one",
          Description:
            "Bằng cách mua giấy phép, bạn có quyền trở thành hunter cho Legi.one.",
          AlreadyOwned: "Bạn đã sở hữu giấy phép này.",
          Form: {
            PriceIncludesVAT: "Giá niêm yết đã bao gồm 21% VAT.",
            ChooseLicense: "Chọn loại giấy phép bạn muốn mua.",
            WalletCheckboxLabel: "Tôi muốn gửi đến ví riêng của tôi",
            PrivateWalletAddress: "Địa chỉ ví riêng",
            PrivateWalletAddressDescription:
              "Nhập địa chỉ ví riêng của bạn trên blockchain Polygon.",
            NoLicensesAvailableForCountry:
              "Không có giấy phép nào có sẵn cho quốc gia đã chọn.",
            SelectCountryFirst:
              "Vui lòng chọn quốc gia trước khi đặt mua giấy phép.",
            SubmitButton: "Đặt hàng và thanh toán",
            SeePaymentDetails: "Xem thông tin thanh toán",
            AlreadyOrdered: "Bạn đã đặt mua giấy phép này.",
          },
        },
        BankAccount: {
          Title: "Kết nối tài khoản",
          AvailableBanks: "Ngân hàng có sẵn",
          BanksComingSoon: "Ngân hàng sắp ra mắt",
        },
        FacilityCompletion: {
          Title: "Chi tiết cơ sở",
          Description:
            "Vui lòng hoàn thành thông tin chi tiết cho cơ sở của bạn. Điền địa chỉ, thông tin liên hệ và các dữ liệu cần thiết khác. Nếu bạn không có cơ sở, hãy bỏ qua bước này và nhấp vào Tiếp tục bên dưới.",
          IncompleteFacilitiesWarning:
            "Có một số cơ sở chưa hoàn thành. Vui lòng hoàn thành thông tin hoặc xóa chúng trước.",
          OrbitLFacilityRequiredWarning:
            "Để kích hoạt terminal cần phải thêm cơ sở kèm ảnh.",
          ContinueWithoutFacility: "Tiếp tục không có cơ sở",
        },
        IncomeInformation: {
          SaveError: "Không thể lưu thông tin thu nhập",
          Title: "Thông tin kinh doanh",
          FormGroups: {
            Business: "Doanh nghiệp của bạn",
            Personal: "Thông tin về bạn",
          },
          Fields: {
            BusinessActivity: "Hoạt động kinh doanh",
            SourceOfIncome: "Nguồn thu nhập",
            RelationType: "Vị trí của bạn",
            IsPoliticallyExposedPerson: "Tôi là người có ảnh hưởng chính trị",
            HasNonEUResidence:
              "Tôi hiện tại (tính đến ngày đăng ký) cư trú ngoài EU hơn 12 tháng",
            HasNonEUNationality: "Tôi là công dân của một quốc gia ngoài EU",
            ExpectedMonthlyRevenue: "Doanh thu hàng tháng dự kiến",
            AverageTransactionValue: "Giá trị giao dịch trung bình",
            TaxResidencyCountry: "Quốc gia cư trú thuế",
            OtherBusinessActivity: "Chỉ định hoạt động kinh doanh",
            OtherSourceOfIncome: "Chỉ định nguồn thu nhập",
          },
        },
        BusinessInformation: {
          SaveError: "Không thể lưu thông tin kinh doanh",
          LoadingError: "Không thể tải thông tin kinh doanh",
          CompanyNumberAresMismatch:
            "Số công ty đã nhập không khớp với dữ liệu từ sổ đăng ký doanh nghiệp",
          CompanyNumberAlreadyInUse:
            "Số đăng ký này đã được đăng ký bởi merchant khác",
          Title: "Thông tin kinh doanh",
          RegionLabel: "Quốc gia đăng ký",
          SlovakVatRegistrationNotice:
            "Lưu ý về mã số thuế GTGT: Nếu bạn là đối tượng chịu thuế có trụ sở tại Slovakia và nhận dịch vụ từ nhà cung cấp ở một quốc gia thành viên EU khác, theo § 7a Luật số 222/2004 Z. z. về thuế GTGT, bạn có nghĩa vụ đăng ký thuế trước khi nhận dịch vụ đầu tiên như vậy. Việc đăng ký theo § 7a không khiến bạn trở thành người nộp thuế GTGT. Nếu bạn không cung cấp cho chúng tôi mã số thuế GTGT hợp lệ, dịch vụ sẽ được lập hóa đơn kèm thuế GTGT của Séc, khoản thuế mà bạn không thể khấu trừ hoặc yêu cầu hoàn lại tại Slovakia.",
          FormGroups: {
            BasicInformation: "Thông tin cơ bản",
            Headquarters: "Trụ sở chính",
            Contact: "Liên hệ",
          },
        },
        OwnerModal: {
          Title: "Thông tin về người thụ hưởng",
        },
        BeneficialOwners: {
          SaveError: "Không thể lưu thông tin bổ sung",
          Title: "Người thụ hưởng",
          Question:
            "Bạn có phải là người thụ hưởng duy nhất của công ty không?",
          SecondaryQuestion: "Bạn có biết ai là người thụ hưởng không?",
          Description:
            "Người thụ hưởng là bất kỳ cá nhân nào cuối cùng sở hữu hoặc kiểm soát một pháp nhân hoặc thỏa thuận pháp lý",
          CheckboxTitle: "Tôi là người thụ hưởng",
          CheckboxDescription:
            "Người thụ hưởng là bất kỳ cá nhân nào cuối cùng sở hữu hoặc kiểm soát một pháp nhân hoặc thỏa thuận pháp lý",
          OwnersTitle: "Người thụ hưởng bổ sung",
          AddOwner: "Thêm người thụ hưởng",
          AddNextOwner: "Thêm người thụ hưởng khác",
          UboChoice: {
            IAmOwner: "Có, tôi là",
            IAmOwnerDescription:
              "Dữ liệu người thụ hưởng sẽ được tự động điền từ hồ sơ của bạn",
            NotTheOnlyOwner: "Không / Có nhiều người",
            ManualEntry: "Nhập",
            ManualEntryDescription: "Nhập thông tin người thụ hưởng thủ công",
            Unknown: "Tôi không biết",
            UnknownDescription:
              "Thông tin sẽ được xác minh bởi chuyên gia AML của chúng tôi",
          },
          FormGroups: {
            BasicInformation: "Thông tin cơ bản",
            Address: "Địa chỉ",
          },
        },
      },
    },
    BanksInPreparation: "Ngân hàng đang chuẩn bị",
    PotentialYearlySavings: "Tiết kiệm hàng năm tiềm năng",
  },
  Transactions: {
    Title: "Giao dịch",
    History: "Lịch sử",
    NoTransactions: "Không có giao dịch nào",
    CancelTransaction: "Hủy giao dịch",
    RefundTransaction: "Hoàn tiền giao dịch",
    InverseTransactionCreated:
      "Một giao dịch đảo ngược đã được tạo. Cần được xác nhận từ tài khoản người bán.",
    TransactionCancelError: "Đã xảy ra lỗi khi hủy giao dịch.",
    Payment: {
      Incoming: "Thanh toán đến",
      Outgoing: "Thanh toán đi",
      Unknown: "Thanh toán",
    },
    Type: {
      Buy: "Mua",
      Sell: "Bán",
      Withdrawal: "Rút tiền",
      LeadReward: "Thưởng giới thiệu",
      LeadRewardConsumer: "Thưởng đăng ký",
      Voucher: {
        GiftCard: "Thẻ quà tặng",
        SignUpSubsidy: "Quà đăng ký",
      },
      Coinback: "Coinback",
    },
    ErrorPayment: {
      Title: "Đã xảy ra lỗi",
      TitleNotCompleted: "Thanh toán chưa hoàn tất",
      Description:
        "Chúng tôi xin lỗi, nhưng đã có sự cố trong quá trình thanh toán.",
    },
    SuccessPayment: {
      Title: "Thanh toán thành công!",
      DescriptionFirstLine: "Tiền đã được gửi thành công",
      DescriptionSecondLine: "đến tài khoản người bán.",
    },
    Anonymous: {
      DownloadReceipt: "Tải hóa đơn về thiết bị",
      FillEmail: "Nhập e-mail của bạn để chúng tôi gửi hóa đơn cho bạn.",
      SignupTitle: "Tạo tài khoản và sử dụng các lợi ích của {{appName}}",
      Benefits:
        "✨ Thu thập Stardust và kiếm tiền với {{appName}}<newline/>🤝 Hỗ trợ các cửa hàng địa phương của bạn<newline/>💳 Phương thức thanh toán nhanh luôn trong tầm tay<newline/>📖 Lịch sử giao dịch và tài chính ở một nơi",
      CampaignSignupTitle:
        "Bằng cách tạo tài khoản, bạn sẽ tham gia đội {{campaignName}} và hỗ trợ với mỗi thanh toán!",
      CampaignSignupDescription:
        "Chọn một trong các tùy chọn tạo tài khoản có sẵn, đăng ký với một cú nhấp chuột và thanh toán với Mo.one.",
      CreateAccountViaEmail: "Tạo tài khoản qua E-mail",
      JustWantReceipt: "Tôi chỉ muốn hóa đơn",
      BackToSignup: "Quay lại tạo tài khoản",
      LoadingSkeleton: {
        loadingInfo: {
          title: "Xác minh thanh toán",
          description:
            "Đang thực hiện xác minh thanh toán <newline/> Đang tải thông tin thanh toán",
        },
        processingTransaction: {
          title: "Đang xử lý giao dịch",
          description:
            "Thanh toán của bạn đang được xử lý <newline/> Đang chờ xác nhận từ ngân hàng của bạn",
        },
      },
    },
    Status: {
      Completed: "Hoàn thành",
      PendingTrade: "Đang xử lý",
      PendingPayout: "Đang chờ xác nhận từ cửa hàng",
      WithdrawRequested: "Đang rút tiền",
      Withdrawn: "Hoàn thành",
    },
    TransactionStatus: {
      Created: "Đang chờ thanh toán",
      Cancelled: "Đã hủy",
      Fail: "Thất bại",
      Initiated: "Đã bắt đầu thanh toán",
      Processing: "Đang xử lý",
      Success: "Đã nhận thành công",
      InvestigationNeeded: "Trạng thái không xác định",
    },
    RefundState: {
      Title: "Hoàn tiền",
      Refunded: "Đã hoàn tiền",
      Pending: "Đang chờ hoàn tiền",
    },
    TransactionDirection: {
      Incoming: "Thanh toán đến",
      Outgoing: "Thanh toán đi",
      IncomingRefund: "Hoàn tiền đến",
      OutgoingRefund: "Hoàn tiền đi",
      Unknown: "Hướng không xác định",
    },
    BankTransferInfo:
      "Chuyển khoản ngân hàng có thể mất đến 2 ngày làm việc, tùy thuộc vào tốc độ của ngân hàng.",
    TransactionStatusDescription: {
      Created: "Giao dịch này đang chờ thanh toán.",
      Cancelled: "Giao dịch này đã bị hủy.",
      Fail: "Giao dịch thất bại.",
      Initiated: "Thanh toán đã được khởi tạo, đang chờ xác nhận.",
      Processing: "Giao dịch đang được xử lý.",
      Success: "Giao dịch này đã hoàn thành.",
      InvestigationNeeded: "Trạng thái không xác định",
    },
    ReceiptOnly: "Tôi chỉ muốn hóa đơn",
  },
  SetPassword: {
    Error: {
      General: "Đã xảy ra lỗi.",
      TokenNotFound: "Token không hợp lệ",
      TokenExpired: "Liên kết đặt mật khẩu đã hết hạn. ",
      TokenExpiredLinkText: "Yêu cầu liên kết mới",
      WeakPassword:
        "Mật khẩu phải có ít nhất 8 ký tự và chứa một chữ thường, một chữ hoa và một số",
    },
  },
  BankIDVerification: {
    Error: {
      General: "Xác thực BankID thất bại. Vui lòng thử lại.",
      BankIDUserInfoError: "Không thể lấy dữ liệu từ BankID.",
      VerificationAlreadyExists: "Người dùng BankID đã được xác minh.",
    },
  },
  Voucher: {
    ApplyError: {
      General: "Đã xảy ra lỗi",
      NotFound:
        "Mã đã nhập không chính xác. Kiểm tra xem mã đã được sao chép đúng chưa. Nếu vấn đề vẫn tiếp tục, hãy liên hệ với chúng tôi.",
      Applied: "Voucher đã được sử dụng",
      UserAccountNotFound: "Không tìm thấy người dùng",
      UserNotFound: "Không tìm thấy người dùng",
      UserIsWaitingForEmailVerification: "Không tìm thấy người dùng",
      InvalidRecaptcha: "Recaptcha không hợp lệ. Làm mới ứng dụng và thử lại.",
    },
    ToOverview: "Về tổng quan",
    SignIn: "Đăng nhập",
    AgreeWith: "Tôi đồng ý với",
    Continue: "Tiếp tục",
    CardCodeInstructions: "2. Sao chép mã 16 chữ số từ thẻ",
  },
  Balance: {
    Title: "Tổng quan",
    BalanceContent: {
      Title: "Số dư khả dụng",
      PayMeAction: "Thanh toán cho tôi",
      SendPaymentAction: "Thanh toán",
      HiddenBalance:
        "Để xem số dư, hãy hoàn thành đăng ký và chờ tài khoản của bạn được xác minh",
      ShowBalance: "Hiển thị số dư",
      HideBalance: "Ẩn số dư",
      CurrencyCount: "{{count}} loại tiền",
      CurrencyCount_one: "{{count}} loại tiền",
      CurrencyCount_few: "{{count}} loại tiền",
      CurrencyCount_other: "{{count}} loại tiền",
      CurrencySheetTitle: "Tiền của tôi",
    },
  },
  Banking: {
    Auth: {
      Title: "Kết nối tài khoản",
      Description: "Chọn ngân hàng bạn muốn kết nối.",
      BankList: {
        Title: "Danh sách ngân hàng",
        ComingSoon: "Sắp ra mắt",
      },
      BankConnectionInfo:
        "Kết nối ngân hàng là quy trình một lần, kết nối ngân hàng và sử dụng thanh toán {{appName}} không giới hạn!",
      BankConnectionWarning:
        "Cảnh báo: Chất lượng kết nối phụ thuộc vào ngân hàng. Nếu bạn gặp vấn đề với đăng nhập hoặc thanh toán, hãy liên hệ ngân hàng của bạn.",
    },
    AccountSelection: {
      Title: "Kết nối {{bankName}}",
      Description:
        "Trong trường hợp bạn không muốn sử dụng một số tài khoản đã kết nối với {{appName}}, hãy bỏ chọn chúng trong danh sách bên dưới.",
      Cancel: "Hủy",
      Confirm: "Xác nhận",
      AccountsSetUp: "Tài khoản đã được thiết lập thành công",
      RemoveError: "Lỗi khi xóa tài khoản",
      DeleteLaterInfo:
        "Bạn cũng có thể xóa tài khoản sau trong tab Thêm -> Tài khoản ngân hàng.",
      SelectedAccounts: "Chọn tất cả",
      AllAccounts: "Tất cả tài khoản",
      WarningMessage:
        "Bạn chỉ có thể kết nối tài khoản đứng tên bạn. Nếu bạn kết nối tài khoản của người khác, nó sẽ bị {{appName}} từ chối.",
    },
    BanksInPreparation: "Ngân hàng đang chuẩn bị",
    QRPaymentForeignBank: "Thanh toán bằng ngân hàng nước ngoài qua mã QR",
    BatchPayments: {
      Title: "Thanh toán hàng loạt",
      DetailTitle: "Chi tiết thanh toán hàng loạt",
      EmptyList: "Chưa có thanh toán hàng loạt nào được tạo.",
      NotFound: "Không tìm thấy thanh toán hàng loạt.",
      LoadMore: "Tải thêm",
      Account: "Tài khoản",
      TotalAmount: "Tổng số tiền",
      PaymentCount: "Số lượng thanh toán",
      CreatedAt: "Đã tạo",
      AuthorizedAt: "Đã ủy quyền",
      CompletedAt: "Đã hoàn thành",
      SignInBank: "Ủy quyền tại ngân hàng",
      PaymentsTable: "Thanh toán",
      Columns: {
        Date: "Ngày",
        Status: "Trạng thái",
        Account: "Tài khoản",
        PaymentCount: "Số lượng thanh toán",
        Total: "Tổng cộng",
        Recipient: "Người nhận",
        IBAN: "IBAN",
        VS: "VS",
        Amount: "Số tiền",
      },
      Status: {
        Created: "Đã tạo",
        Initiated: "Chờ ủy quyền",
        Processing: "Đang xử lý",
        Success: "Hoàn thành",
        Fail: "Thất bại",
        Cancelled: "Đã hủy",
      },
    },
  },
  BankNames: {
    CSOB: "CSOB",
    CSAS: "Ceska sporitelna",
    KB: "Komercni Banka",
    AirBank: "Air Bank",
    UCB: "UniCredit Bank",
    MONETA: "Moneta Money Bank",
    FIO: "Fio banka",
    MBank: "mBank",
    RB: "Raiffeisenbank",
    Citfin: "Citfin",
    TRINITY: "Trinity Bank",
    PenezniDum: "Penezni dum",
    Artesa: "Artesa",
    CREDITAS: "CREDITAS",
    NEY: "NEY savings cooperative",
    MaxBanka: "Max bank",
    NRB: "National Development Bank",
    JandT: "J&T Bank",
    PPF: "PPF bank",
    Oberbank: "Oberbank",
    PartnersBank: "Partners Bank",
    CNB: "Czech National Bank",
    Revolut: "Revolut",
    CZKT: "CZKT",
  },
  BankEnvironmentNames: {
    [BankEnvironment.CSOB_SANDBOX]: "CSOB",
    [BankEnvironment.CSOB_PROD]: "CSOB",
    [BankEnvironment.CSAS_SANDBOX]: "Ceska sporitelna",
    [BankEnvironment.CSAS_PROD]: "Ceska sporitelna",
    [BankEnvironment.KB_SANDBOX]: "Komercni banka",
    [BankEnvironment.KB_PROD]: "Komercni banka",
    [BankEnvironment.AirBank_SANDBOX]: "Air Bank",
    [BankEnvironment.AirBank_PROD]: "Air Bank",
    [BankEnvironment.UCB_SANDBOX]: "UniCredit Bank",
    [BankEnvironment.UCB_PROD]: "UniCredit Bank",
    [BankEnvironment.MONETA_SANDBOX]: "Moneta Money Bank",
    [BankEnvironment.MONETA_PROD]: "Moneta Money Bank",
    [BankEnvironment.FIO_SANDBOX]: "Fio banka",
    [BankEnvironment.FIO_PROD]: "Fio banka",
    [BankEnvironment.MBANK_SANDBOX]: "mBank",
    [BankEnvironment.MBANK_PROD]: "mBank",
    [BankEnvironment.RB_SANDBOX]: "Raiffeisenbank",
    [BankEnvironment.RB_PROD]: "Raiffeisenbank",
    [BankEnvironment.Citfin_PROD]: "Citfin",
    [BankEnvironment.TRINITY_PROD]: "Trinity Bank",
    [BankEnvironment.PenezniDum_PROD]: "Penezni dum",
    [BankEnvironment.Artesa_PROD]: "Artesa",
    [BankEnvironment.CREDITAS_PROD]: "CREDITAS",
    [BankEnvironment.NEY_PROD]: "NEY sporicitelna druzstvo",
    [BankEnvironment.MaxBanka_PROD]: "Max banka",
    [BankEnvironment.NRB_PROD]: "Narodni rozvojova banka",
    [BankEnvironment.JandT_PROD]: "J&T Banka",
    [BankEnvironment.PPF_PROD]: "PPF banka",
    [BankEnvironment.Oberbank_PROD]: "Oberbank",
    [BankEnvironment.PartnersBank_PROD]: "Partners Banka",
    [BankEnvironment.CNB_PROD]: "Czech National Bank",
    [BankEnvironment.Revolut_SANDBOX]: "Revolut",
    [BankEnvironment.Revolut_PROD]: "Revolut",
    [BankEnvironment.CZKT_SANDBOX]: "CZKT",
    [BankEnvironment.CZKT_PROD]: "CZKT",
  },
  BankRating: {
    Banks: {
      [Bank.CSOB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Để kết nối tài khoản, bạn cần nhấp vào mã QR hoặc biết tên đăng nhập và mật khẩu<linebreak/> • Việc gửi thông báo đẩy từ Smart Key đôi khi mất đến 1 phút<linebreak/> • Việc quay lại từ ứng dụng ngân hàng về {{appName}} phải được thực hiện thủ công",
        HowToConnect:
          "Khi kết nối tài khoản qua điện thoại di động, nhấp vào mã QR sẽ đưa bạn trực tiếp đến ứng dụng Smart Key. Nếu bạn không nhận được thông báo đẩy, hãy mở Smart Key trực tiếp từ menu điện thoại và xác nhận hành động được yêu cầu (ví dụ: thanh toán) ở đó. Sau khi kết nối tài khoản/thanh toán, nhấp vào mũi tên quay lại để quay về {{appName}} từ Smart Key. Các khoản thanh toán nhỏ hơn (ví dụ: lên đến 500,- Kč) đôi khi không cần xác nhận trong ứng dụng - trong trường hợp này, cuộn trang web xuống dưới cùng và nhấp vào nút màu xanh lá ở bên phải.",
        Review:
          "Chúng tôi đánh giá kết nối API từ ČSOB ở mức trung bình. Để kết nối tài khoản, bạn cần nhấp vào mã QR, điều này có thể gây nhầm lẫn cho một số người dùng. Các văn bản trên trang web ČSOB được hiển thị bằng tiếng Anh trên điện thoại. Thông báo đẩy từ ứng dụng Smart Key đôi khi mất nhiều thời gian để gửi đến. Không có chuyển hướng tự động quay lại {{appName}}. Chúng tôi đánh giá tích cực việc sử dụng xác thực một yếu tố cho các khoản thanh toán nhỏ hơn trên tài khoản đã xác minh, khi thanh toán được hoàn thành rất nhanh.",
        Email: "ombudsman@csob.cz",
      },
      [Bank.CSAS]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Để kết nối tài khoản, bạn cần điền tên đăng nhập/số khách hàng và ngày sinh<linebreak/> • Việc quay lại từ ứng dụng George về {{appName}} phải được thực hiện thủ công",
        HowToConnect:
          "Trước khi kết nối tài khoản, hãy kiểm tra xem bạn có tên đăng nhập/số khách hàng mà bạn sử dụng để đăng nhập vào ngân hàng trực tuyến. Sau khi kết nối tài khoản/thanh toán, nhấp vào mũi tên quay lại để quay về {{appName}} từ George.",
        Review:
          "Chúng tôi đánh giá kết nối API từ Česká spořitelna là tốt và khá ổn định. Thông báo đẩy hoạt động chính xác và nhanh chóng. Để kết nối tài khoản, người dùng phải nhập tên đăng nhập/số khách hàng và ngày sinh, điều này có thể gây phiền toái cho nhiều người dùng. Không có chuyển hướng tự động từ George quay lại {{appName}}.",
        Email: "ombudsman@csas.cz",
      },
      [Bank.KB]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Để kết nối tài khoản, bạn cần điền tên đăng nhập và số điện thoại<linebreak/> • Việc quay lại từ ứng dụng ngân hàng về {{appName}} phải được thực hiện thủ công<linebreak/> • Thanh toán đã xác nhận sẽ chỉ được thực hiện sau khi người dùng quay lại {{appName}}!",
        HowToConnect:
          "Để kết nối tài khoản, bạn cần nhập tên đăng nhập mà bạn sử dụng để đăng nhập vào ngân hàng trực tuyến. <bold>Sau khi xác nhận thanh toán, bạn phải quay lại từ ứng dụng ngân hàng về {{appName}} - nếu không thanh toán sẽ không được thực hiện!</bold> Nếu bạn sử dụng cả ứng dụng KB+ và ứng dụng KB Key (ngân hàng doanh nghiệp), bạn sẽ nhận được hai thông báo - bạn chỉ cần xác nhận hành động được yêu cầu (ví dụ: thanh toán) trong một trong hai ứng dụng.",
        Review:
          "Chúng tôi hiện đánh giá kết nối API từ Komerční banka là không thân thiện với người dùng và gần như không hoạt động. Để kết nối tài khoản, người dùng phải nhập tên đăng nhập và sau đó là số điện thoại, điều này có thể gây phiền toái cho nhiều người dùng. Đối với một hành động, hai thông báo xuất hiện đồng thời (từ ứng dụng KB+ và ứng dụng KB Key), điều này rất gây nhầm lẫn. Không có chuyển hướng tự động quay lại {{appName}}. Nếu người dùng không quay lại từ ứng dụng ngân hàng (KB+ hoặc KB Key) thủ công về {{appName}}, thanh toán đã xác nhận sẽ không được thực hiện, điều mà chúng tôi coi là trở ngại lớn - chúng tôi đã báo cáo vấn đề và đang cố gắng hết sức để ngân hàng khắc phục.",
        Email: "ombudsman@kb.cz",
        NotRecommended: {
          Reason: "Vi phạm nghiêm trọng quy định của CNB.",
          WarningText:
            "Bạn đang cố kết nối Komerční banka, ngân hàng hiện đang vi phạm quy định của Ngân hàng Quốc gia Séc.<linebreak/><linebreak/>Kết nối ngân hàng này sẽ làm phức tạp đáng kể việc thanh toán qua {{appName}}. Vui lòng cân nhắc kết nối ngân hàng khác.",
          RiskItButton: "TÔI SẼ CHẤP NHẬN RỦI RO VỚI KB",
        },
      },
      [Bank.AirBank]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Trang web không responsive<linebreak/> • Việc gửi thông báo đẩy từ ứng dụng MyAir đôi khi mất nhiều thời gian hơn<linebreak/> • Sau khi kết nối tài khoản, hãy bỏ chọn tất cả xác nhận trong MyAir<linebreak/> • Việc quay lại từ ứng dụng ngân hàng về {{appName}} phải được thực hiện thủ công (iOS)",
        HowToConnect:
          'Để kết nối tài khoản, nhấp vào nút đen "Đăng nhập qua ứng dụng", sẽ đưa bạn trực tiếp đến ứng dụng MyAir. Nếu bạn không nhận được thông báo đẩy, hãy mở MyAir trực tiếp từ menu điện thoại và xác nhận hành động được yêu cầu (ví dụ: thanh toán) ở đó. Do trang web không responsive của ngân hàng, có thể bạn sẽ bị lạc trong giây lát - chúng tôi khuyên bạn nên di chuyển ngón tay trên màn hình, phóng to và tìm trường hoặc nút chính xác. Sau khi kết nối tài khoản/thanh toán, nhấp vào mũi tên quay lại để quay về {{appName}} từ MyAir (áp dụng cho iPhone).',
        Review:
          "Chúng tôi đánh giá kết nối API từ Air Bank là một trong những tốt nhất. Để kết nối tài khoản, bạn không cần nhập tên đăng nhập hoặc mật khẩu. Chúng tôi coi khía cạnh tiêu cực là trang web không responsive và vấn đề với việc gửi thông báo đẩy muộn đôi khi. Việc chuyển hướng quay lại {{appName}} đi kèm với thời gian chờ không cần thiết 5 giây. Không có chuyển hướng tự động quay lại {{appName}} (áp dụng cho iPhone).",
        Email: "info@airbank.cz",
      },
      [Bank.UCB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Ứng dụng SmartBanking rất chậm<linebreak/> • Ngân hàng liên tục yêu cầu cho phép sử dụng cookie<linebreak/> • Ngân hàng hỏi bạn trước mỗi thanh toán bạn đang sử dụng điện thoại hay máy tính",
        HowToConnect:
          "Ứng dụng chậm, hãy đợi và không vội - thanh toán sẽ được hoàn thành sau một lúc. Trước mỗi thanh toán, bạn phải xác nhận bạn đang sử dụng máy tính (Online Banking), điện thoại (SmartBanking) hay là khách hàng doanh nghiệp (Corporate). Nếu ngân hàng yêu cầu bạn cho phép sử dụng cookie, bạn phải bỏ chọn nó.",
        Review:
          "Chúng tôi đánh giá kết nối API từ UniCredit Bank ở mức trung bình. Ứng dụng SmartBanking rất chậm, điều này kéo dài quá trình thanh toán một cách không hợp lý. Chúng tôi đánh giá tiêu cực các yêu cầu phiền toái về quyền sử dụng cookie và các yêu cầu liên tục về việc người dùng hiện đang kết nối từ điện thoại, máy tính hay là khách hàng doanh nghiệp. Số dư tài khoản chỉ được cập nhật 4 lần một ngày. Về mặt tích cực, chúng tôi đánh giá việc kết nối tài khoản trực tiếp qua ứng dụng SmartBanking mà không cần biết tên đăng nhập hoặc mật khẩu, và chuyển hướng tự động từ ứng dụng ngân hàng quay lại {{appName}}.",
        Email: "info@unicreditgroup.cz",
      },
      [Bank.MONETA]: {
        Rating: "4.75",
        AdditionalInfo: "",
        Warnings:
          "Không có gì đáng lo ngại. Nếu bạn gặp lỗi trong quy trình, hãy cho chúng tôi biết – MONETA đang tích cực trao đổi với chúng tôi và chúng ta sẽ cùng cố gắng giải quyết vấn đề.",
        HowToConnect:
          "Việc kết nối tài khoản ngân hàng MONETA chỉ cần một lần xác thực mạnh và một lần nhấp; sau khi xác nhận, bạn sẽ được tự động chuyển hướng từ Smart Banka quay lại {{appName}}. Thanh toán cũng diễn ra suôn sẻ như vậy – bạn xác nhận thanh toán trong Smart Banka và ứng dụng sẽ tự đưa bạn quay lại {{appName}}.",
        Review:
          "Kết nối API của MONETA Money Bank đã có sự cải thiện đáng kể trong năm 2026 và hiện thuộc nhóm tốt nhất trên thị trường Séc. Cả kết nối tài khoản và thanh toán đều hoạt động chỉ với một lần xác thực mạnh và một lần chạm, không cần đăng nhập thừa và tự động quay lại {{appName}}. Từ góc độ trải nghiệm người dùng, đây là một triển khai đúng chuẩn, tuân thủ quy định cũng như ý kiến giải thích RS 2025-28 của Ngân hàng Quốc gia Séc ngày 27. 11. 2025. Chúng tôi cũng ghi nhận việc MONETA đã phản hồi các góp ý của chúng tôi và cung cấp bản sửa luồng thanh toán như đã hứa. Nếu bạn vẫn phát hiện lỗi, hãy báo cho chúng tôi – ngân hàng đang trao đổi với chúng tôi và sẽ cố gắng khắc phục.",
        Email: "ombudsmanproklienty@moneta.cz",
      },
      [Bank.FIO]: {
        Rating: "4.25",
        AdditionalInfo: "",
        Warnings:
          'Sau khi kết nối tài khoản cũng như sau khi xác nhận thanh toán, bạn cần nhấn nút "Hoàn tất" – chỉ sau đó bạn mới quay lại {{appName}}. Trạng thái thanh toán trong {{appName}} được tải với một chút chậm trễ – hãy đợi một lát, thanh toán đang được xử lý.',
        HowToConnect:
          'Bạn xác nhận cả việc kết nối tài khoản và thanh toán trực tiếp trong ứng dụng Fio banka, nơi {{appName}} tự động chuyển hướng bạn đến. Sau khi xác nhận, hãy nhấn "Hoàn tất" và bạn sẽ được chuyển hướng quay lại {{appName}}.',
        Review:
          'Chúng tôi đánh giá rất tích cực kết nối API của Fio banka, trên cả Android và iOS. Việc kết nối tài khoản không còn yêu cầu nhập tên đăng nhập và mật khẩu, và việc chuyển hướng trực tiếp đến ứng dụng Fio banka rồi quay lại hoạt động ổn định trên cả hai nền tảng. So với ý kiến giải thích RS 2025-28 của Ngân hàng Quốc gia Séc ngày 27. 11. 2025, trong quy trình vẫn còn một lần nhấp thừa – xác nhận bằng nút "Hoàn tất" – và trạng thái thanh toán trong {{appName}} được tải chậm hơn một chút so với mong muốn của chúng tôi. Đây là những chi tiết nhỏ ngăn Fio banka đạt được đánh giá cao nhất. Nếu bạn phát hiện lỗi trong quy trình, hãy báo cho chúng tôi.',
        Email: "fio@fio.cz",
      },
      [Bank.MBank]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Để kết nối tài khoản và thực hiện thanh toán, bạn cần nhập Mã định danh số và mật khẩu<linebreak/> • Luôn yêu cầu đăng nhập vào ứng dụng di động mBank trước khi thực hiện thanh toán<linebreak/> • Việc quay lại từ ứng dụng di động mBank về {{appName}} phải được thực hiện thủ công",
        HowToConnect:
          "Để kết nối tài khoản, bạn cần biết Mã định danh số và mật khẩu của mình. Nếu bạn chưa có, bạn phải tạo chúng trong ngân hàng trực tuyến mBank. Sau khi xác nhận đăng nhập trong ứng dụng di động mBank, hãy quay lại trình duyệt và chọn tài khoản ngân hàng bạn muốn kết nối với {{appName}}. Trước khi xác nhận thanh toán, bạn phải đăng nhập lại vào ứng dụng di động mBank, vì vậy thanh toán với ngân hàng này thực tế luôn mất nhiều thời gian hơn so với đối thủ cạnh tranh.",
        Review:
          'Kết nối API của mBank cho thấy nhiều trở ngại khiến đánh giá của chúng tôi chỉ còn nửa sao. Việc kết nối tài khoản ngân hàng với mBank gặp khó khăn do cần biết Mã định danh số và mật khẩu. Chúng tôi đánh giá tiêu cực việc bắt buộc đăng nhập vào ứng dụng mBank trước khi thực hiện thanh toán, điều này kéo dài quá trình thanh toán một cách không cân xứng. Thiếu chuyển hướng tự động quay lại môi trường {{appName}} - nếu bạn không muốn đợi 15 giây để chuyển hướng, bạn phải nhấp vào nút "Tôi hiểu".',
        Email: "kontakt@mBank.cz",
      },
      [Bank.RB]: {
        Rating: "2",
        AdditionalInfo: "",
        Warnings:
          "• Để kết nối tài khoản, bạn cần nhập số khách hàng<linebreak/> • Việc quay lại từ xác nhận thanh toán về {{appName}} phải được thực hiện thủ công",
        HowToConnect:
          'Để kết nối tài khoản, bạn phải nhập số khách hàng mà bạn sử dụng để đăng nhập vào ngân hàng trực tuyến. Khi xác nhận thanh toán, bạn phải nhấp vào nút màu vàng "Ký" trên trang web của ngân hàng trước, sau đó ứng dụng mới mở. Sau khi xác nhận thanh toán, nhấp để quay lại {{appName}} trước tiên vào mũi tên quay lại và sau đó vào nút "Chuyển hướng về ứng dụng".',
        Review:
          'Chúng tôi đánh giá kết nối API của Raiffeisenbank cao hơn mức trung bình so với đối thủ cạnh tranh hiện tại. Chúng tôi đánh giá cao tốc độ thanh toán và sự ổn định của việc gửi thông báo đẩy. Quá trình thanh toán bị chậm lại do xác nhận thanh toán hai lần - một lần trên trang web Raiffeisenbank bằng cách nhấp vào nút màu vàng "Ký" và lần thứ hai trong ứng dụng của ngân hàng. Thiếu chuyển hướng tự động quay lại môi trường {{appName}} sau khi thực hiện thanh toán - bạn phải tự quay lại Mo.one, nếu không người bán sẽ không thấy rằng thanh toán đã thực sự được thực hiện.',
        Email: "reklamace@rb.cz",
      },
      [Bank.Citfin]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.TRINITY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PenezniDum]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Artesa]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CREDITAS]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NEY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.MaxBanka]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NRB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.JandT]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PPF]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Oberbank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PartnersBank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CNB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Revolut]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CZKT]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
    },
    NotRecommended: {
      Badge: "KHÔNG KHUYẾN NGHỊ",
      InfoboxTitle: "KHÔNG KHUYẾN NGHỊ",
      BetterButton: "TÔI MUỐN LỰA CHỌN TỐT HƠN",
    },
    Title: "Đánh giá kết nối ngân hàng",
    Description:
      'Chúng tôi mang đến cho người bán và khách hàng các khoản thanh toán tức thì đơn giản và tiện lợi tại cửa hàng và trực tuyến. Chúng tôi liên tục cải thiện hệ thống và chức năng.<linebreak/> Tuy nhiên, trải nghiệm thanh toán với {{appName}} bị ảnh hưởng trực tiếp bởi chất lượng kết nối với công nghệ do các ngân hàng cung cấp. Chúng tôi khuyên bạn nên nghiên cứu và kiểm tra trước các hạn chế mà bạn có thể gặp phải khi kết nối tài khoản hoặc thực hiện thanh toán. Cùng với các ngân hàng, chúng tôi đang nỗ lực loại bỏ từng rào cản để đến cuối năm 2026, trải nghiệm thanh toán thực sự tuyệt vời.<linebreak/> Chúng tôi đã giới thiệu hệ thống đánh giá, nhờ đó bạn có thể thấy ngân hàng của bạn hoạt động như thế nào. Đánh giá của chúng tôi được gọi là "Miss API" và là động lực tích cực để các ngân hàng cải thiện công nghệ và trải nghiệm thanh toán với {{appName}} của bạn. Nếu bạn không hài lòng với chất lượng kết nối của ngân hàng, chúng tôi khuyên bạn nên sử dụng ngân hàng khác có đánh giá tốt hơn. Bạn có thể mở tài khoản với ngân hàng khác ngay hôm nay trong vài phút trực tuyến từ điện thoại hoặc máy tính.',
    AccessibilityLabel: "",
    ContactUs: {
      PreText:
        "Nếu bạn gặp bất kỳ hạn chế nào khác không được đề cập cho ngân hàng của bạn, vui lòng cho chúng tôi biết tại",
      Email: "info@mo.one",
      PostText: "Chúng tôi đánh giá cao phản hồi của bạn!",
    },
    Detail: {
      CurrentRating: "Đánh giá hiện tại: {{rating}}/5.00",
      Titles: {
        Warning: "Cảnh báo:",
        HowToConnect: "Cách kết nối:",
        Review: "Đánh giá:",
        Email: "Nếu bạn muốn thay đổi, hãy liên hệ ombudsman của ngân hàng tại",
      },
    },
  },
  Transfer: {
    FromAccount: "Chọn tài khoản nguồn",
    ToAccount: "Chọn tài khoản đích",
    Amount: "Nhập số tiền",
    Note: "Thêm ghi chú",
    SubmitButton: "Chuyển",
    TransferButton: "Chuyển tiền",
    ConnectMoreAccounts: "Kết nối thêm tài khoản",
    NoBankAccountsError: "Không thể tải tài khoản ngân hàng.",
  },
  Merchant: {
    Employees: {
      Title: "Nhân viên",
    },
    LicenseShares: {
      Title: "Chia sẻ giấy phép",
    },
    Payment: {
      LoadingError: "Không thể tải dữ liệu",
      Title: "Doanh thu hôm nay",
      InitiatePaymentButton: "Khởi tạo thanh toán",
      InitiateKeypadPaymentButton: "THANH TOÁN {{amount}}",
    },
    Initiate: {
      PaypointHasNoAccountError:
        "Điểm thanh toán đã chọn không thể sử dụng cho thanh toán vì không có tài khoản ngân hàng được gán.",
      NoBankAccountsError:
        "Lỗi, chúng tôi không thể tải tài khoản ngân hàng của bạn.",
      ActiveTransactionConflict: {
        Title: "Xung đột giao dịch",
        Message: "Đã có một giao dịch đang hoạt động tại điểm thanh toán này.",
        Description:
          "Bạn có thể quay lại và khởi tạo giao dịch tại điểm thanh toán khác, hoặc ghi đè giao dịch hiện có tại điểm thanh toán này.",
        OverwriteButton: "Ghi đè hiện có",
        Overwriting: "Đang ghi đè...",
      },
      ConnectBankAccountLink: {
        PreText: "Bạn có thể bắt đầu sử dụng terminal sau khi",
        LinkText: "Thiết lập tài khoản chính của bạn.",
      },
      GenerateButton: "Tạo dữ liệu giao dịch",
      Form: {
        BusinessAccountSelectTitle: "Chọn tài khoản doanh nghiệp",
        PersonalAccountSelectTitle: "Chọn tài khoản cho thanh toán đến",
      },
    },
    InitiateDetail: {
      MerchantInstructions:
        'Bạn có thể thanh toán bằng cách quét mã QR, hoặc nhập mã giao dịch trong biểu mẫu "Thanh toán".',
      CustomerInstructions:
        "Hiển thị mã QR duy nhất để thanh toán cho người trả, hoặc chia sẻ ID giao dịch 3 chữ số với họ.",
      QRInstructions:
        "Bạn có thể thực hiện thanh toán bằng cách quét mã QR hoặc chia sẻ mã thanh toán.",
      QRCodeInstructionsSuccess:
        "Để xem chi tiết thanh toán, tải <newline/> mã QR trên điện thoại của bạn.",
      QRCodeWarning:
        "KHÔNG SỬ DỤNG đầu đọc trong ứng dụng ngân hàng của bạn! Mở {{appName}} bằng cách quét mã QR với camera hoặc đầu đọc QR.",
      UsePaypointWarning:
        "Không có PayPoint nào được đặt cho thanh toán đã chọn. Vui lòng thiết lập PayPoint để cải thiện quy trình thanh toán {{appName}}.",
      PaymentStatus: "Trạng thái thanh toán",
      TransactionFee: "Phí giao dịch",
      ProgressHeader: {
        [TransactionStatus.Created]: "Đang chờ thanh toán",
        [TransactionStatus.Initiated]: "Đã khởi tạo",
        [TransactionStatus.Processing]: "Đang xử lý",
        [TransactionStatus.Success]: "Đã nhận thành công",
        [TransactionStatus.Cancelled]: "Đã hủy",
        [TransactionStatus.Fail]: "Thất bại",
        [TransactionStatus.InvestigationNeeded]: "Trạng thái không xác định",
      },
      ShareTitle: "Thanh toán {{appName}}",
      ShareText:
        "{{name}} đang gọi bạn! Số tiền {{amount}} đã sẵn sàng. Nhấp và gửi đến đích! Cảm ơn bạn đã thanh toán với {{appName}}!",
      ShareReceiptTitle: "Hóa đơn thanh toán - {{appName}}",
      ShareReceiptText:
        "Hóa đơn thanh toán\n\nID giao dịch: {{transactionId}}\nSố tiền: {{amount}}\nGhi chú: {{note}}\nTham chiếu: {{reference}}\nTài khoản/IBAN: {{iban}}\n\nCảm ơn bạn đã sử dụng {{appName}}!",
      ActionButtons: {
        Share: "Chia sẻ",
        Info: "Thông tin",
        Qr: "QR {{appName}}",
      },
      NFCInstruction:
        "Quét NFC và hoàn thành thanh toán trên điện thoại của bạn.",
      Error: "Đã xảy ra lỗi khi tải hướng dẫn thanh toán",
      Loading: "Đang chuẩn bị thanh toán...",
      CreateAnotherPayment: "Tạo thanh toán khác",
      BackToOverview: "Quay lại tổng quan",
      ThankYouMessage: "Cảm ơn bạn đã thanh toán với {{ appName }}!",
    },
    MerchantStatus: {
      InDraft: "Đã bắt đầu đăng ký",
      InvitedWaitingForConfirmation: "Đã gửi lời mời",
      Onboarding: "Đang giới thiệu",
      WaitingForPaymentTerminal: "Đang chờ terminal thanh toán",
      Active: "Hoạt động",
      BlockedFinancialServices: "Bị chặn",
    },
    NoProductAssigned: "Bạn không có sản phẩm nào được gán.",
    NoPaypointProduct:
      "Bạn không có sản phẩm nào được gán cho phép tạo điểm thanh toán.",
    DataFailedToLoad: "Không thể tải dữ liệu.",
    PaymentDetails: "Chi tiết thanh toán:",
    AccountNumber: "Số tài khoản:",
    VariableSymbol: "Ký hiệu biến:",
    IBAN: "IBAN:",
    PaymentReference: "Tham chiếu thanh toán:",
    Amount: "Số tiền:",
    Note: "Ghi chú:",
    NoAccountSet: "Chưa thiết lập tài khoản",
    ConnectedBankAccounts: "Tài khoản ngân hàng đã kết nối",
  },
  Customer: {
    Pay: {
      Title: "Thanh toán",
      DescriptionText:
        "Bạn cũng có thể thanh toán bằng cách quét mã QR của đối tác.",
      PayButton: "Thanh toán",
      PayButtonWithAmount: "Thanh toán {{amount}}",
      ChooseBankAccount: "Chọn tài khoản bạn muốn thanh toán",
      ChooseBank: "Chọn ngân hàng bạn muốn thanh toán",
      AddNextBankAccount: "+ Thêm tài khoản khác",
      MooneLiteAccountExplanation:
        "= chức năng tài khoản bị hạn chế.<newline/>Để mở khóa tất cả tính năng {{appName}}, bạn cần hoàn thành đăng ký trước.",
      SelectBankAccount: "Chọn tài khoản ngân hàng",
      TransactionIdentifier: "ID giao dịch",
      Amount: "Số tiền",
      BillAmount: "Số tiền hóa đơn",
      Tip: "Tiền tip",
      AddTip: "Thêm tiền tip",
      fivePercent: "5%",
      tenPercent: "10%",
      twentyPercent: "20%",
      custom: "Tùy chỉnh",
      TipContinueWithout: "Tiếp tục không có tiền tip",
      TipCustomAmountLabel: "Số tiền tip",
      BankAccount: "Tài khoản ngân hàng",
      QuickPayment: {
        Processing: "Đang xử lý thanh toán nhanh...",
        Error: "Thanh toán nhanh thất bại",
        QuickPaymentFailed:
          "Giao dịch không thể hoàn thành với thanh toán nhanh.",
        UseAnotherAccount: "Sử dụng tài khoản khác",
      },
      AnonymousCollector: {
        UnsupportedMode:
          "Không thể sử dụng liên kết thanh toán này ở đây. Vui lòng kiểm tra liên kết và thử lại.",
      },
      ManualEntry: {
        Title: "Thanh toán",
        NfcTitle: "Chạm điện thoại vào điểm thanh toán",
        NfcSubtitle: "Thanh toán không tiếp xúc qua NFC.",
        ManualTitle: "Nhập ID giao dịch",
        ManualTitleWithNfc: "Hoặc nhập ID giao dịch theo cách thủ công",
        ManualSubtitle: "Bạn sẽ tìm thấy nó ở đối tác.",
        InputPlaceholder: "VD: A5DH8Q",
        InputLabel: "ID giao dịch",
        SubmitButton: "Tiếp tục",
        InvalidId: "Vui lòng nhập ID giao dịch hợp lệ",
        TransactionIdNotProvided: "Không có mã giao dịch nào được cung cấp.",
      },
    },
  },
  BankAccounts: {
    List: {
      Description:
        'Các tài khoản ngân hàng này được ghép nối với tài khoản của bạn. Nếu bạn muốn thêm tài khoản ngân hàng khác, nhấp vào nút "Kết nối tài khoản ngân hàng".',
      NoAccounts: "Bạn không có tài khoản ngân hàng nào được ghép nối.",
      SaveOrder: "Lưu thứ tự",
      EditOrder: "Chỉnh sửa thứ tự",
      AddAccount: "Kết nối tài khoản ngân hàng",
    },
    VerificationStatus: {
      Inactive: "Không hoạt động",
      AwaitingVerification: "Đang chờ xác minh",
      Rejected: "Bị từ chối",
      Active: "Hoạt động",
      Restricted: "Tài khoản Lite",
      PreApproved: "Đã phê duyệt trước",
    },
    VerificationStatusDescription: {
      Active:
        "Tài khoản đã được xác minh đầy đủ và có thể sử dụng cho tất cả giao dịch.",
      AwaitingVerification:
        "Tài khoản đang được xác minh. Không thể đặt làm chính cho đến khi xác minh hoàn tất.",
      Restricted:
        "Tài khoản đang ở chế độ Lite với chức năng hạn chế. Không thể đặt làm chính.",
      Inactive: "Tài khoản không hoạt động và không thể sử dụng cho giao dịch.",
      Rejected:
        "Xác minh tài khoản đã bị từ chối. Tài khoản không thể sử dụng.",
      PreApproved:
        "Tài khoản đã được phê duyệt trước. Bạn có thể nhận thanh toán tài khoản đến tài khoản trong giới hạn nhất định cho đến khi tài khoản được xác minh đầy đủ.",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Thanh toán vi mô",
    },
  },
  Form: {
    PersonalData: {
      Sex: {
        Female: "Nữ",
        Male: "Nam",
        NotSet: "Chưa xác định",
      },
    },
    PartyType: {
      NaturalPerson: "Cá nhân",
      LegalEntity: "Pháp nhân",
      SelfEmployed: "Tự kinh doanh (OSVČ)",
    },
    BusinessActivity: {
      RetailAndGoodsSales: "Bán lẻ và bán hàng",
      FoodServicesAndGastronomy: "Dịch vụ ẩm thực và ẩm thực",
      AccommodationAndTourism: "Lưu trú và du lịch",
      BeautyHealthAndWellness: "Sắc đẹp, sức khỏe và chăm sóc sức khỏe",
      ConstructionCraftsAndMaintenance: "Xây dựng, thủ công và bảo trì",
      TransportAutoAndLogistics: "Vận tải, ô tô và logistics",
      FinancialLegalAndConsulting: "Dịch vụ tài chính, pháp lý và tư vấn",
      EducationSportsAndLeisure: "Giáo dục, thể thao và giải trí",
      TechnologyITAndOnline: "Công nghệ, CNTT và dịch vụ trực tuyến",
      IndustryManufacturingAndWholesale: "Công nghiệp, sản xuất và bán buôn",
      OtherAndPublicServices: "Dịch vụ khác và công cộng",
      RetailAndCommerce: "Bán lẻ và thương mại",
      FoodAndBeverageServices: "Dịch vụ ẩm thực và đồ uống",
      AccommodationAndHospitality: "Lưu trú và khách sạn",
      BeautyAndPersonalCare: "Sắc đẹp và chăm sóc cá nhân",
      HealthcareAndPersonalCare: "Y tế và chăm sóc cá nhân",
      ConstructionAndMaintenance: "Xây dựng và bảo trì",
      TransportationAndLogistics: "Vận tải và logistics",
      FinancialServicesAndInsurance: "Dịch vụ tài chính và bảo hiểm",
      RealEstateAndPropertyServices: "Bất động sản và quản lý tài sản",
      LegalAndConsultingServices: "Dịch vụ pháp lý và tư vấn",
      EducationAndTraining: "Giáo dục và đào tạo",
      ArtsCultureAndEntertainment: "Nghệ thuật, văn hóa và giải trí",
      SportsAndRecreation: "Thể thao và giải trí",
      TechnologyAndITServices: "Công nghệ và dịch vụ CNTT",
      ECommerceAndOnlineServices: "Thương mại điện tử và dịch vụ trực tuyến",
      IndustrialProductionAndProcessing: "Sản xuất và chế biến công nghiệp",
      Other: "Khác",
      PersonalServices: "Dịch vụ cá nhân",
    },
    SourceOfIncome: {
      GoodsSalesRevenue: "Doanh thu bán hàng",
      ServiceAndCraftIncome: "Thu nhập từ dịch vụ và thủ công",
      HospitalityAndAccommodation: "Kinh doanh nhà hàng và lưu trú",
      CommissionsAndLicensing: "Hoa hồng và cấp phép",
      PropertyAndInvestmentIncome: "Thu nhập từ tài sản và đầu tư",
      PublicBudgetsAndGrants: "Ngân sách công và tài trợ",
      OtherBusinessIncome: "Thu nhập kinh doanh khác",
      Employment: "Việc làm",
      SelfEmployment: "Tự kinh doanh",
      Other: "Khác",
    },
    SourceOfIncomeHint: {
      GoodsSalesRevenue:
        "Bán lẻ, bán buôn, quầy hàng, sản phẩm kỹ thuật số, thương mại điện tử.",
      ServiceAndCraftIncome:
        "Tất cả dịch vụ từ cắt tóc đến sửa ống nước đến IT, tư vấn và tiếp thị.",
      HospitalityAndAccommodation:
        "Nhà hàng, quán bar, quán cà phê, khách sạn, nhà nghỉ và cho thuê ngắn hạn.",
      CommissionsAndLicensing:
        "Môi giới bất động sản, tư vấn viên, đối tác liên kết, bản quyền và bằng sáng chế.",
      PropertyAndInvestmentIncome:
        "Cho thuê bất động sản dài hạn, cổ tức, chia lợi nhuận và hoạt động holding.",
      PublicBudgetsAndGrants:
        "Thu nhập phi lợi nhuận, trợ cấp nhà nước, nhà thờ và quỹ từ thiện.",
      OtherBusinessIncome:
        "Các trường hợp cụ thể không thuộc các danh mục trên.",
    },
    ExpectedMonthlyRevenue: {
      LessThan100K: "Dưới 100.000 CZK",
      From100KTo500K: "100.000 đến 500.000 CZK",
      From500KTo1M: "500.000 đến 1.000.000 CZK",
      Over1M: "Trên 1.000.000 CZK",
    },
    AverageTransactionValue: {
      LessThan1K: "Dưới 1.000 CZK",
      From1KTo10K: "1.000 đến 10.000 CZK",
      From10KTo50K: "10.000 đến 50.000 CZK",
      Over50K: "Trên 50.000 CZK",
    },
    RelationType: {
      BeneficialOwner: "Người thụ hưởng",
      ProxyHolder: "Người đại diện ủy quyền",
      HuntersHunter: "Hunter của Hunter",
      BranchManager: "Quản lý chi nhánh",
      Mayor: "Thị trưởng",
      Governor: "Thống đốc",
      CityMayor: "Thị trưởng thành phố",
      ContactPerson: "Người liên hệ",
      HuntersMerchant: "Merchant của Hunter",
      MerchantsEmployee: "Nhân viên của Merchant",
      HuntersCustomer: "Khách hàng của Hunter",
      CustomersCustomer: "Khách hàng của khách hàng",
      MerchantsCustomer: "Khách hàng của Merchant",
      StatutoryBody: "Cơ quan điều hành",
      InsolvencyAdministrator: "Quản tài viên",
      Liquidator: "Thanh lý viên",
      ForcedAdministrator: "Quản trị viên bắt buộc",
      BranchOfficeManager: "Trưởng chi nhánh",
      ManagingDirector: "Giám đốc điều hành",
      BoardChairman: "Chủ tịch hội đồng quản trị",
      BoardMember: "Thành viên hội đồng quản trị",
      SupervisoryBoardChairman: "Chủ tịch ban kiểm soát",
      SupervisoryBoardMember: "Thành viên ban kiểm soát",
      Partner: "Đối tác",
      GeneralPartner: "Thành viên hợp danh",
      Chairman: "Chủ tịch",
      CommitteeMember: "Thành viên ủy ban",
      TrustManager: "Người quản lý quỹ tín thác",
    },
    RoleCategory: {
      StatutoryBody: "Cơ quan điều hành",
      StatutoryBodyHint:
        "Thành viên cơ quan điều hành chủ yếu là giám đốc điều hành, thành viên/chủ tịch hội đồng quản trị, thành viên/chủ tịch ban kiểm soát",
      ProxyHolder: "Người được ủy quyền",
      Other: "Khác",
      SpecificRole: "Vị trí cụ thể",
    },
    BankVerification: {
      NotVerified: "Chưa xác minh",
      Verified: "Đã xác minh",
      InProgress: "Đang xác minh",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Thanh toán vi mô",
    },
    IdentityVerification: {
      NotVerified: "Chưa xác minh",
      Verified: "Đã xác minh",
      Processing: "Đang xác minh",
      ToVerify: "Cần xác minh",
      Expired: "Đã hết hạn",
    },
    AdditionalInfo: {
      NotVerified: "Chưa xác minh",
      Verified: "Đã xác minh",
      NeedsInvestigation: "Cần điều tra",
    },
    UserStatus: {
      Unknown: "Không xác định",
      InvitedWaitingForConfirmation: "Đã gửi lời mời",
      Active: "Hoạt động",
      WaitingForEmailConfirmation: "Đang chờ xác nhận e-mail",
      Deactivated: "Đã vô hiệu hóa",
      BlockedFinances: "Bị chặn",
      Anonymous: "Ẩn danh",
      Onboarding: "Đang giới thiệu",
      EmailConfirmed: "E-mail đã xác nhận",
      RoleSelection: "Chọn vai trò SSO",
    },
    IdentityUserStatus: {
      Active: "Hoạt động",
      Pending: "Đang chờ chấp nhận",
      Suspended: "Tạm ngưng",
      Deactivated: "Đã thu hồi",
      Onboarding: "Đang giới thiệu",
    },
    AddressType: {
      Permanent: "Địa chỉ thường trú",
      Mail: "Địa chỉ liên lạc",
      Headquarters: "Trụ sở chính",
    },
    Version: {
      MooneLite: "{{appName}} Lite",
      FullMoone: "{{appName}} đầy đủ",
    },
  },
  FormSelectors: {
    BusinessForm: {
      Title: "Loại hình kinh doanh",
    },
  },
  User: {
    AccessRole: {
      Merchant: "Merchant",
      Hunter: "Hunter",
      Customer: "Người dùng",
      Admin: "Quản trị viên",
      Employee: "Nhân viên",
      Aml: "AML",
      HunterPlus: "Hunter+",
      CustomerOnboarding: "Đăng ký khách hàng",
      AdminLite: "Admin (chỉ đọc)",
      Disponent: "Người được ủy quyền",
      Child: "Trẻ em",
    },
    RoleFilter: {
      CustomerOnly: "Người dùng (không có vai trò khác)",
    },
  },
  Hunter: {
    Dashboard: {
      UnderConstruction:
        "Bảng điều khiển hunter, bảng xếp hạng, học viện và nhiều hơn nữa sẽ sớm ra mắt...",
      MissingLicenseHolderBankAccount:
        "Để nhận thưởng, hãy kết nối tài khoản ngân hàng thuộc sở hữu của chủ giấy phép nhượng quyền.",
      HunterPortalBanner: {
        Title: "Cổng Hunter",
        Description:
          "Terminal, thu hút khách hàng, sự kiện, học viện và nhiều hơn nữa tại một nơi.",
      },
      Prerequisites: {
        Title: "Các bước đầu tiên của Hunter",
        Description:
          "Trở thành chuyên gia bán hàng trên Mo.one trong vài bước và thành thạo các kỹ năng bán hàng.",
        Completed: "Hoàn thành",
        GreatWork: "Tuyệt vời!",
        InfoMessage:
          "Để có quyền truy cập đầy đủ vào các tính năng Hunter, trước tiên bạn cần làm quen với những điều cơ bản của Mo.one. Hoàn thành danh sách nhiệm vụ và mở khóa Full Hunter!",
        CompletedMessage:
          "Hoàn tất! Bây giờ bạn có thể bắt đầu gửi lời mời cho các thương gia.",
        Items: {
          RegisterAsMerchant: "Đăng ký làm Merchant và khám phá ứng dụng",
          InviteUserViaAffiliate: "Mời người dùng mới qua Nhờ Bạn!",
          BanksAndPayments:
            "Kết nối ít nhất 3 ngân hàng và thực hiện 30 thanh toán",
          OfflineTraining: "Tham dự",
          OfflineTrainingLink: "đào tạo Mo.one trực tiếp",
          OfflineTrainingUrl: "https://events.legi.one",
          BringMerchantsWithHunter:
            "Đưa 3 Merchant hợp tác cùng Hunter có kinh nghiệm",
        },
      },
    },
    LicensePaymentPending: {
      Title: "Giấy phép của bạn chưa được kích hoạt",
      ProcessingInfo:
        "Hiện tại bạn chưa có giấy phép đang hoạt động. Nếu bạn đã gửi thanh toán, vui lòng chờ thanh toán được xử lý và giấy phép được kích hoạt — chuyển khoản ngân hàng có thể mất 1–2 ngày làm việc.",
      NotPaidYetLink: "Bạn chưa gửi thanh toán?",
      NotPaidYetSubtitle: "Hiển thị thông tin thanh toán",
      PaymentDetailsTitle: "Thông tin thanh toán",
      NoLicenseTitle: "Bạn chưa có giấy phép",
      NoLicenseInfo:
        "Hiện tại bạn không có giấy phép đang hoạt động nào. Để vào khu vực Hunter của {{appName}}, trước tiên hãy đặt mua giấy phép.",
      OrderLicense: "Đặt mua giấy phép",
      OrderAnotherLicense: "Đặt mua giấy phép khác",
      SelectedLicenseLabel: "Giấy phép đã đặt",
      BackToMoone: "Quay lại {{appName}}",
    },
    Merchants: {
      Title: "Thương gia",
      NewRegistration: {
        Title: "Merchant mới",
        StartRegistrationButton: "Bắt đầu đăng ký",
        StartRegistrationError: "Lỗi khi bắt đầu đăng ký",
        StartRegistrationSuccess: "Đã bắt đầu đăng ký",
        CreateMerchantError: "Lỗi khi tạo merchant",
        Form: {
          Legend: {
            License: "Chọn giấy phép",
            CommissionSharing: "Chia sẻ hoa hồng",
          },
          Fields: {
            License: "Giấy phép",
            Country: "Quốc gia",
            Region: "Quốc gia",
            CompanyNumber: "Số công ty",
            ConfirmationLabel:
              "Tôi xác nhận rằng tôi đã nói chuyện trực tiếp với chủ sở hữu công ty hoặc người phụ trách dịch vụ thanh toán trong công ty.",
            RemoveHunter: "Xóa hunter",
            CommissionSettings: "Cài đặt hoa hồng",
            ShareCommissionWithHunters: "Chia sẻ hoa hồng với các Hunter khác",
            ShareCommissionWithHuntersButton: " + Chia sẻ với các Hunter khác",
          },
          NoLicenseForRegion:
            "Bạn không có giấy phép hoạt động cho thị trường này. Hãy chọn quốc gia khác hoặc mua giấy phép trước.",
          StatusIndicator: {
            Loading: "Đang kiểm tra khả dụng",
            EnterCompanyNumber: "Nhập số công ty để xác thực.",
            CompanyAvailable:
              "Tuyệt vời! {{company}} chưa sử dụng {{appName}}.",
            CompanyNotAvailable:
              "Rất tiếc, {{company}} đã sử dụng {{appName}}, hoặc đang trong quá trình đăng ký.",
            CompanyNotFound:
              "Số công ty đã nhập không được tìm thấy trong sổ đăng ký doanh nghiệp.",
          },
        },
      },
      AddNew: "Thêm merchant mới",
      OpenRegistrations: {
        Table: {
          Title: "Merchant tiềm năng",
          Columns: {
            CompanyName: "Tên công ty",
            CompanyNumber: "Số công ty",
            Phone: "Điện thoại",
            Email: "E-mail",
          },
        },
        Title: "Đăng ký đang mở",
        LoadingError: "Lỗi - Không thể tải danh sách đăng ký đang mở",
        RegisterNewMerchant: "Đăng ký merchant mới",
      },
      ListPage: {
        LoadingError: "Lỗi - Không thể tải danh sách merchants",
        LicenseError: "Lỗi - Không thể tải dữ liệu giấy phép",
        LicenseNotActive:
          "Giấy phép của bạn chưa hoạt động. Khi được kích hoạt, bạn sẽ thấy danh sách merchants ở đây.",
        ShowLicenses: "Hiển thị giấy phép",
        MerchantsTitle: "Merchants",
        SharedMerchantsTitle: "Merchants có hoa hồng được chia sẻ",
        Table: {
          Columns: {
            MerchantStatus: "Trạng thái merchant",
            ContactPerson: "Người liên hệ",
            Party: {
              CompanyName: "Tên công ty",
              Phone: "Điện thoại",
              Email: "E-mail",
              SettlementStatus: "Trạng thái quyết toán",
            },
            LicenseNumber: "Giấy phép",
            SharePercentage: "Tỷ lệ %",
            TransactionsCount: "Số giao dịch",
            DaysRegistered: "Số ngày đăng ký",
          },
        },
        SharedMerchantsError:
          "Lỗi - Không thể tải merchants có hoa hồng được chia sẻ",
      },
      CompleteRegistration: {
        MerchantCompany: {
          LoadingError: "Lỗi - Không thể tải dữ liệu merchant",
        },
        ContactPerson: {
          Title: "Người liên hệ",
          OptionalTitle: "Người liên hệ tùy chọn",
          OptionalNoItems: "Chưa thêm người liên hệ nào",
        },
        Facilities: {
          RequiredInfo: "Vui lòng điền thông tin cơ sở",
          ContinueWithoutFacility: "Tiếp tục không có cơ sở",
        },
        SendAccess: {
          SendAccessError: "Lỗi khi gửi hướng dẫn đăng ký",
          SendAccessSuccess: "Hướng dẫn đăng ký merchant đã được gửi",
          Title: "Tóm tắt",
          MandatoryStepsTitle:
            "Trước khi gửi quyền truy cập, tất cả các bước sau phải được hoàn thành:",
          Login: "Đăng nhập merchant",
          LoginDescription:
            "Đây là e-mail mà merchant sẽ sử dụng để đăng nhập vào {{appName}}.",
          SendAccessButton: "Gửi quyền truy cập",
          BackOfficeTarget:
            "Địa chỉ e-mail này thuộc về tài khoản nội bộ của {{appName}} (Admin, AML, onboarding) và không thể được mời. Hãy sử dụng địa chỉ e-mail khác.",
          MerchantAlreadyExists: "Merchant với e-mail này đã tồn tại",
          MerchantAlreadyHasAccessToThisCompany:
            "Người dùng này đã có quyền truy cập merchant cho công ty này.",
          ExistingIdentityHint:
            "E-mail này đã có trong {{appName}}. Lời mời sẽ xuất hiện trong hộp thư của họ — chúng tôi không gửi e-mail.",
          NewIdentityHint:
            "Chúng tôi sẽ gửi e-mail kích hoạt với liên kết để đặt mật khẩu.",
          CompanyNumberAlreadyRegistered:
            "Merchant với mã số đăng ký {{companyNumber}} đã được đăng ký trong {{appName}}.",
          TestMerchantBannerTitle: "Đăng ký thử nghiệm",
          TestMerchantBanner:
            "Trước khi hoàn thành tất cả các bước đầu tiên, bạn có một lần đăng ký thương gia thử nghiệm để có thể dùng thử ứng dụng từ góc nhìn của thương gia.",
          Todos: {
            BasicInfo: "Điền thông tin chung của merchant",
            BeneficialOwners: "Thêm người thụ hưởng của công ty",
            ContactPerson: "Thêm người liên hệ cho quyết toán",
            Facilities: "Thêm cơ sở",
            Pricing: "Thiết lập giá cho tất cả sản phẩm đã chọn",
            HunterPrerequisites:
              "Hoàn thành tất cả các bước đầu tiên của Hunter",
          },
        },
        SaveMerchantPartyError: "Lỗi khi lưu bên merchant",
        SaveMerchantPartySuccess: "Dữ liệu bên merchant đã được lưu",
        GeneralTitle: "Đăng ký merchant",
        Title: "Đăng ký {{company}} ",
        MerchantError: "Lỗi - Merchant chưa được chọn hoặc không tồn tại",
        LoadingError: "Lỗi - Không thể tải dữ liệu merchant",
        Steps: {
          notes: "Ghi chú",
          party: "Merchant",
          facilities: "Cơ sở",
          company: "Công ty",
          products: "Sản phẩm",
          fees: "Phí",
          completion: "Hoàn thành",
        },
        NextStep: "Tiếp theo",
        PreviousStep: "Trước",
        Notes: {
          SaveSuccess: "Ghi chú đã được lưu",
          Title: "Ghi chú",
          Label: "Ghi chú của bạn về merchant",
          SaveError: "Lỗi khi lưu ghi chú",
          NoNotes: "Không có ghi chú...",
        },
      },
      Detail: {
        ActivateButton: "Kích hoạt doanh nghiệp",
        ActivateSuccess: "Doanh nghiệp đã được kích hoạt.",
        ActivateError: "Kích hoạt doanh nghiệp thất bại.",
        ResendAccessButton: "Gửi lại lời mời",
        ResendAccessSuccess: "E-mail truy cập đã được gửi thành công",
        ResendAccessSuccessWithUser:
          "Lời mời đã được gửi lại đến <bold>{{userLogin}}</bold>",
        ResendAccessError: "Lỗi khi gửi e-mail truy cập",
        CancelAccessButton: "Hủy lời mời",
        CancelAccessConfirmTitle: "Hủy lời mời?",
        CancelAccessConfirmBody:
          "Thao tác này sẽ thu hồi lời mời đang chờ cho {{userLogin}}. Bạn có thể gửi lời mời mới sau đó.",
        CancelAccessSuccess: "Đã hủy lời mời",
        CancelAccessError: "Lỗi khi hủy lời mời",
        CancelAccessForbidden:
          "Chỉ hunter đã gửi lời mời hoặc quản trị viên mới có thể hủy lời mời này.",
        Tabs: {
          Merchant: "Merchant",
          Products: "Sản phẩm",
          TerminalContracts: "Bản nháp terminal ",
          Paypoints: "Điểm thanh toán",
          Settlements: "Quyết toán",
        },
      },
    },
    AllMerchants: {
      LoadingError: "Lỗi - Không thể tải danh sách merchants",
      OwnedByMe: "Merchant của tôi",
      TableHeaders: {
        Status: "Trạng thái merchant",
        CompanyNumber: "Mã số doanh nghiệp",
        CompanyName: "Tên công ty",
        LicenseOwner: "Chủ giấy phép",
        LicenseType: "Loại giấy phép",
        DateCreated: "Ngày tạo",
        TransactionsCount: "Số lượng giao dịch",
      },
    },
    UnassignedMerchants: {
      Description:
        "Merchants tự đăng ký mà không có hunter nào được chỉ định. Nhấp vào hàng để chỉ định hunter và đặt phần trăm hoa hồng.",
      LoadingError: "Lỗi - Không thể tải danh sách merchants không có hunter",
      EmptyState:
        "Không có merchants nào không có hunter. Tất cả merchants đều đã có hunter được chỉ định.",
      OpenDetailLabel: "Mở chi tiết merchant",
      TableHeaders: {
        Status: "Trạng thái merchant",
        CompanyNumber: "Mã số doanh nghiệp",
        CompanyName: "Tên công ty",
        DateCreated: "Ngày tạo",
        Detail: "Chi tiết",
      },
      AssignDialog: {
        Title: "Chỉ định hunter cho",
        Subtitle: "{{companyName}} (Mã số: {{companyNumber}})",
        PrimaryLicenseLabel: "Giấy phép chính",
        MainCommission: "Hoa hồng chính",
        ShareLegend: "Chia sẻ hoa hồng với các giấy phép khác",
        ShareCommissionWithHuntersButton: "Chia sẻ hoa hồng với hunters",
        AssignButton: "Xác nhận chỉ định",
        AssignWarning:
          "Sau khi chỉ định, không thể chỉnh sửa hunters và hoa hồng nữa",
        CancelButton: "Hủy",
        AssignSuccess: "Đã chỉ định hunter thành công.",
        AlreadyHasHunterError: "Merchant này đã có hunter được chỉ định.",
        GenericError: "Không thể chỉ định hunter.",
        Validation: {
          PrimaryRequired: "Giấy phép chính là bắt buộc.",
          ShareOutOfRange: "Hoa hồng chia sẻ phải lớn hơn 0% và nhỏ hơn 100%.",
          PrimaryUnderMin: "Hunter chính phải giữ lại ít nhất 1% hoa hồng.",
        },
      },
    },
    HuntersOverview: {
      LoadingError: "Lỗi - Không thể tải danh sách hunters",
      Detail: {
        UserInfo: "Thông tin người dùng",
        PartyInfo: "Thông tin bên",
        ContactInfo: "Thông tin liên hệ",
        Login: "Đăng nhập",
        Status: "Trạng thái",
        FirstName: "Tên",
        LastName: "Họ",
        BirthDate: "Ngày sinh",
        CompanyName: "Tên công ty",
        CompanyNumber: "Mã số doanh nghiệp",
        TaxNumber: "Mã số thuế",
        Email: "Email",
        Phone: "Điện thoại",
        Licenses: "Giấy phép",
        NoLicensesFound: "Không tìm thấy giấy phép",
        AffiliatedTo: "Liên kết với",
        EditUser: "Chỉnh sửa",
        DateCreated: "Ngày tạo",
        PartyType: "Loại bên",
      },
      TableHeaders: {
        Login: "Đăng nhập",
        FirstName: "Tên",
        LastName: "Họ",
        CompanyName: "Tên công ty",
        DateCreated: "Ngày tạo",
        Status: "Trạng thái",
        AffiliatedTo: "Liên kết với",
        Prerequisites: "Điều kiện tiên quyết",
      },
    },
  },
  ApiStatuses: {
    UnknownError: "Đã xảy ra lỗi không mong đợi khi xử lý yêu cầu",
    UploadIdentificationCommandResultStatus: {
      [UploadIdentificationCommandResultStatus.Success]: "Tải lên thành công",
      [UploadIdentificationCommandResultStatus.MissingFiles]:
        "Vui lòng tải lên tất cả các tệp",
    },
    UploadIdentificationCommandResultStatus2: {
      [UploadIdentificationCommandResultStatus2.Success]: "Tải lên thành công",
      [UploadIdentificationCommandResultStatus2.MissingFiles]:
        "Vui lòng tải lên tất cả các tệp",
      [UploadIdentificationCommandResultStatus2.VerificationAttemptsExhausted]:
        "Không thể lặp lại kiểm tra giấy tờ tự động; vui lòng liên hệ hỗ trợ.",
    },
  },
  MobileApp: {
    InstallBanner: {
      Title: "Tải ứng dụng {{appName}}",
      Description:
        "Truy cập nhanh hơn ngay từ màn hình chính điện thoại của bạn.",
      AppStoreBadgeAlt: "Tải về trên App Store",
      PlayStoreBadgeAlt: "Tải trên Google Play",
    },
  },
  Language: {
    Czech: "Tiếng Séc",
    Language: "Ngôn ngữ ứng dụng",
    Settings: "Ngôn ngữ",
  },
  System: {
    Addresses: "Địa chỉ",
    BlockchainFee: "Phí blockchain",
    MempoolFeeLevel: "Mức phí mempool",
    Exchange: "Sàn giao dịch",
    Trades: "Giao dịch",
    Moone: "{{appName}}",
    HotWallet: "+ Đến Hot Wallet",
    ColdWallet: "+ Đến Cold Wallet",
    ExchangeWithdrawal: " + Đến rút sàn giao dịch ",
    UserAccounts: "- Đến tài khoản người dùng",
    ControlSum: "Tổng kiểm soát",
    ExchangeWithdrawalFee: "Phí rút sàn giao dịch",
    TradingVolume: "Khối lượng giao dịch",
    PerMonth: "Mỗi tháng",
    PerWeek: "Mỗi tuần",
    Per24h: "Mỗi 24 giờ",
    PurchasedBTC: "BTC đã mua",
    WithdrawnOrPending: "Đã rút hoặc đang chờ",
    BTCLedgerSum: "Tổng sổ cái BTC",
    CZKLedgerSum: "Tổng sổ cái CZK",
  },
  Error: {
    Page403: "Lỗi 403",
    Page404: "Lỗi 404",
    Unexpected: "Đã xảy ra lỗi không mong đợi",
    NoAccess: "Bạn không có quyền truy cập trang này.",
    OpenRegistrationsFailed: "Không thể tải danh sách đăng ký đang mở.",
    MerchantNotSelected: "Lỗi - Merchant chưa được chọn hoặc không tồn tại",
    LicenseInfoFailed: "Không thể tải thông tin về giấy phép của bạn.",
    InvalidPaypointId: "ID điểm thanh toán không hợp lệ hoặc bị thiếu",
    SomethingWentWrong: "Đã xảy ra lỗi, vui lòng thử lại sau.",
    InvalidUserRole: "Lỗi, vai trò người dùng hoặc merchant không hợp lệ",
    GoogleLoginFailed: "Lỗi trong quá trình đăng nhập Google",
    Error: "Lỗi",
    ProgrammerHint: "Bạn là lập trình viên? Xem lỗi là gì.",
    AccountsFailed: "Lỗi - Không thể tải tài khoản của bạn",
    UserDataFailed: "Lỗi, không thể tải dữ liệu người dùng",
    VerificationDataFailed: "Lỗi, không thể tải dữ liệu xác minh",
    DocumentsFailed: "Lỗi, không thể tải tài liệu",
    PersonDataFailed: "Không thể tải dữ liệu cá nhân.",
    IncomeDataFailed: "Không thể tải dữ liệu.",
    FormPreparationFailed: "Đã xảy ra lỗi khi chuẩn bị biểu mẫu",
    RelatedPartyDataFailed: "Lỗi khi tải dữ liệu bên liên quan.",
    MerchantFacilitiesFailed: "Không thể tải dữ liệu cơ sở.",
    UserFailed: "Lỗi, không thể tải người dùng",
    ActingPersonFailed: "Lỗi, không thể tải người đại diện",
    DocumentsFailedToLoad: "Lỗi, không thể tải tài liệu",
    AffiliateCodeFailed: "Không thể lấy mã liên kết của bạn.",
    NoInvitationsSent: "Bạn chưa gửi lời mời nào.",
    QRPaymentFailed: "Xin lỗi, đã xảy ra lỗi, vui lòng thử lại sau.",
  },
  Dashboard: {
    EmptyForRole: "Vai trò của bạn chưa được gán trang tổng quan.",
    NoAccess: "Bạn không có quyền truy cập trang này.",
    NoAccessRetry:
      "Hãy thử <signInLink>đăng nhập</signInLink> lại. Nếu vấn đề vẫn tiếp diễn, vui lòng liên hệ bộ phận hỗ trợ của chúng tôi.",
    AlreadyHaveAccount: "Đã có tài khoản {{appName}}?",
    IncomeTypeQuestion: "Loại thu nhập của bạn là gì?",
    Back: "QUAY LẠI",
    Loading: "Đang tải...",
  },
  Auth: {
    Redirecting: "Đang chuyển hướng",
    Error: "Lỗi",
    StateSync: {
      LoggedInFromAnotherTab: "Bạn đã được đăng nhập từ tab khác.",
      LoggedOutFromAnotherTab: "Bạn đã được đăng xuất từ tab khác.",
    },
    AuthPageLayout: {
      DividerText: "hoặc",
      SignInLinkText: "Đăng nhập",
      SignUpLinkText: "Đăng ký",
      SignInPrompt: "Đã có tài khoản?",
      SignUpPrompt: "Chưa có tài khoản?",
    },
    SSO: {
      CompleteSSORegistration: {
        Welcome: "Chào mừng đến với {{appName}}!",
        Title: "Hoàn thành đăng ký",
        Description:
          "Vì đây là lần đăng nhập đầu tiên, chúng tôi cần biết bạn đăng ký với vai trò Người dùng, Merchant hay Hunter.",
        SignUpAs: "Đăng ký với vai trò",
        RoleDescription: {
          Merchant:
            "Với vai trò merchant, bạn có thể nhận thanh toán từ khách hàng với phí thấp hơn và sử dụng điểm thanh toán không tiếp xúc.",
          Customer:
            "Với vai trò người dùng, bạn có thể gửi thanh toán trực tiếp, thanh toán mua hàng và tích lũy điểm Stardust.",
          Hunter:
            "Với vai trò hunter, bạn có thể nhận giấy phép Legione, quản lý merchants của bạn và kiếm hoa hồng từ giao dịch của họ",
        },
        RoleLabel: {
          Merchant: "Merchant",
          Customer: "Người dùng",
          Hunter: "Hunter",
        },
      },
      Google: {
        ButtonLabel: "Đăng nhập với Google",
      },
      Apple: {
        ButtonLabel: "Tiếp tục với Apple",
        SignInFailed: "Đăng nhập bằng Apple thất bại. Vui lòng thử lại.",
        NotSupportedInApp:
          "Đăng nhập bằng Apple không được hỗ trợ trong ứng dụng. Vui lòng sử dụng trình duyệt web.",
      },
      BankID: {
        ButtonLabel: "Tiếp tục với BankID",
      },
    },
    Migration: {
      Title: "Liên kết tài khoản",
      Welcome: "Liên kết tài khoản của bạn với một Identity",
      Description:
        "Tài khoản của bạn phải được liên kết với một Identity chính để phù hợp với mô hình tài khoản mới. Vui lòng hoàn thành một trong các bước bên dưới.",
      RoleHint: "Vai trò tài khoản hiện tại: {{role}}",
      LinkToCustomerOption: "Tôi đã có tài khoản Customer — liên kết",
      CreateIdentityOption: "Tạo Identity mới từ tài khoản này",
      CreateIdentityDeferred:
        "Loại tài khoản này hiện không hỗ trợ tạo Identity mới — vui lòng liên kết với một Identity hiện có.",
      LinkToCustomerTitle: "Liên kết với tài khoản Customer hiện có",
      LinkToCustomerDescription:
        "Nhập thông tin đăng nhập của tài khoản Customer hiện có. Vai trò hiện tại của bạn sẽ được thêm vào Identity đó.",
      LoginLabel: "E-mail tài khoản Customer",
      PasswordLabel: "Mật khẩu tài khoản Customer",
      LinkButton: "Liên kết tài khoản",
      BackButton: "Quay lại",
      LinkError: "Liên kết thất bại. Vui lòng kiểm tra thông tin đăng nhập.",
      LinkSsoDivider: "hoặc",
      LinkSsoDescription:
        "Đăng nhập bằng tài khoản Google hoặc Apple mà bạn dùng cho tài khoản Customer của mình.",
      LinkSsoNoAccount:
        "Không có tài khoản Customer nào dưới e-mail Google/Apple này. Hãy dùng tài khoản có cùng e-mail hoặc đăng nhập bằng mật khẩu.",
      LinkSsoError: "Liên kết qua Google/Apple thất bại. Vui lòng thử lại.",
      CreateError: "Tạo Identity thất bại. Vui lòng thử lại.",
      AccountNotReady:
        "Tài khoản này chưa sẵn sàng để sử dụng — quá trình đăng ký chưa hoàn tất. Vui lòng liên hệ bộ phận hỗ trợ hoặc đại diện kinh doanh để được tạo lại tài khoản.",
      EmployeeNotSupported:
        "Tài khoản nhân viên hiện chưa thể liên kết với Danh tính. Vui lòng liên hệ với thương gia của bạn hoặc bộ phận hỗ trợ.",
      BackOfficeNotSupported:
        "Tài khoản nội bộ (Admin, AML, onboarding) không được liên kết hay tự tạo — quản trị viên sẽ thiết lập. Vui lòng liên hệ quản trị viên.",
      SignOut: "Đăng xuất",
      MerchantCreateIdentity: {
        Title: "Tạo Identity mới — người đại diện theo pháp luật",
        Description:
          "Identity của công ty phải dựa trên cơ quan đại diện theo pháp luật. Vui lòng chọn bạn là ai trong số những người đại diện theo pháp luật, hoặc nhập thông tin thủ công.",
        CompanyLabel: "Công ty",
        CompanyNumber: "(Mã số: {{number}})",
        UnknownCompany: "(không xác định)",
        PickPersonTitle: "Người đại diện theo pháp luật của công ty",
        AlreadyLinkedHint: "đã có Identity riêng",
        UnnamedPerson: "(không có tên)",
        StatutoryDeclaration:
          "Tôi cam đoan rằng tôi là người đại diện theo pháp luật hoặc thành viên cơ quan đại diện theo pháp luật của công ty {{company}}.",
        CreateAsButton: "Tạo Identity với tư cách {{name}}",
        CreateAsButtonNoSelection: "Tạo Identity",
        ManualEntryToggle:
          "Tôi không có trong danh sách — nhập thông tin của tôi",
        ManualEntryToggleEmpty: "Nhập thông tin thủ công",
        ManualTitle:
          "Thông tin cá nhân của bạn (người đại diện theo pháp luật)",
        FirstNameLabel: "Tên",
        LastNameLabel: "Họ",
        BirthDateLabel: "Ngày sinh",
        PhoneLabel: "Số điện thoại",
        SubmitManualButton: "Tạo Identity",
        SubmitError: "Tạo Identity thất bại. Vui lòng thử lại.",
        LoadError: "Không tải được danh sách đại diện công ty.",
        RelationTypes: {
          BeneficialOwner: "Chủ sở hữu hưởng lợi",
          ProxyHolder: "Người được ủy quyền",
          BranchManager: "Quản lý chi nhánh",
          BranchOfficeManager: "Quản lý văn phòng chi nhánh",
          ContactPerson: "Người liên hệ",
          StatutoryBody: "Cơ quan pháp lý",
          Mayor: "Thị trưởng",
          Governor: "Tỉnh trưởng",
          CityMayor: "Thị trưởng thành phố",
          InsolvencyAdministrator: "Quản tài viên",
          Liquidator: "Người thanh lý",
          ForcedAdministrator: "Quản trị viên bắt buộc",
        },
      },
    },
    Invitations: {
      PageTitle: "Lời mời",
      PageDescription:
        "Lời mời đang chờ để đảm nhận thêm vai trò trong {{appName}}. Chấp nhận để thêm vai trò vào tài khoản, từ chối để bỏ qua.",
      EmptyState: "Bạn không có lời mời nào đang chờ.",
      MerchantInviteTitle:
        "Bạn được mời vận hành {{companyName}} với tư cách Người bán.",
      MerchantInviteUnnamedCompany:
        "Bạn được mời vận hành một tài khoản Người bán.",
      EmployeeInviteTitle:
        "Bạn đã được mời làm việc tại {{companyName}} với vai trò nhân viên.",
      EmployeeBellTitle: "Lời mời mới từ công ty",
      EmployeeBellMessage:
        "{{company}} đã mời bạn làm nhân viên. Xác nhận lời mời trong mục Lời mời.",
      MerchantBellTitle: "Lời mời mới đến công ty",
      MerchantBellMessage:
        "Bạn đã được mời quản lý {{company}}. Xác nhận lời mời trong mục Lời mời.",
      InvitedBy: "Được mời bởi {{inviter}}",
      ExpiresAt: "Hết hạn {{date}}",
      AcceptButton: "Chấp nhận",
      DeclineButton: "Từ chối",
      KycRequired:
        "Hoàn tất xác minh danh tính trên tài khoản Khách hàng của bạn trước khi chấp nhận.",
      AcceptError: "Không thể chấp nhận lời mời. Vui lòng thử lại.",
      AcceptedButSwitchFailed:
        "Đã chấp nhận lời mời — nhưng không thể chuyển sang nó. Hãy tải lại trang hoặc chuyển ngữ cảnh trong menu tài khoản.",
      DeclineError: "Không thể từ chối lời mời. Vui lòng thử lại.",
      LoadError: "Không thể tải lời mời của bạn.",
    },
    ContextSwitcher: {
      Title: "Chuyển vai trò",
      AddRole: "Tạo vai trò",
      Switching: "Đang chuyển…",
      PersonalAccountHint: "Tài khoản cá nhân",
      Roles: {
        Customer: "Khách hàng",
        Hunter: "Hunter",
        HunterPlus: "Hunter Plus",
        Merchant: "Thương gia",
        Disponent: "Disponent",
        Employee: "Nhân viên",
        Admin: "Quản trị viên",
        Aml: "AML",
        CustomerOnboarding: "Customer onboarding",
        AdminLite: "Admin (chỉ đọc)",
        Child: "Trẻ em",
      },
    },
    ForgottenPassword: {
      Title: "Quên mật khẩu",
      Email: "E-mail",
      ResetPasswordButton: "Đặt lại mật khẩu",
      SuccessMessage:
        "Nếu người dùng với e-mail này tồn tại, chúng tôi đã gửi hướng dẫn đặt lại mật khẩu.",
    },
    EmailVerification: {
      EmailSentTo: "E-mail với liên kết kích hoạt đã được gửi đến",
      Redirecting: "Đang chuyển hướng",
      EmailVerification: "Xác minh e-mail",
      EmailSent: "E-mail đã được gửi",
      ResendEmail: "Gửi lại e-mail",
      EmailInstructions:
        "Trước khi tiếp tục, cần kích hoạt tài khoản bằng cách nhấp vào liên kết trong e-mail này.",
      ResendEmailLabel: "Không nhận được e-mail?",
      ResendEmailText:
        "Thử kiểm tra thư mục SPAM hoặc Bulk. Hoặc yêu cầu gửi lại e-mail.",
    },
  },
  Account: {
    ThankYouFriendInvited: "Cảm ơn bạn. Bạn bè của bạn đã được mời thành công.",
  },
  Components: {
    PasswordInput: {
      ShowPassword: "Hiển thị mật khẩu",
      HidePassword: "Ẩn mật khẩu",
    },
    EmployeeAutocomplete: {
      Placeholder: "Chọn nhân viên",
      SelectAll: "Chọn tất cả",
    },
    CategoryAutocomplete: {
      Placeholder: "Chọn danh mục",
    },
    ShareButton: {
      AccessibilityLabel: "Chia sẻ",
      Error: "Chia sẻ thất bại",
    },
    NoPrimaryAccountPopup: {
      Message:
        "Vui lòng chọn một tài khoản chính từ các tài khoản ngân hàng đã kết nối. Nó sẽ được sử dụng làm tài khoản mặc định cho các giao dịch của bạn.",
      Accounts: "Quản lý tài khoản đã kết nối",
    },
    LanguageSwitcher: {
      ComingSoon: "Sắp ra mắt",
    },
    CountrySelector: {
      LoadingError: "Danh sách quốc gia không khả dụng",
      Label: "Chọn quốc gia bạn muốn mua giấy phép",
      ComingSoon: "sắp ra mắt",
      SlovakLicensesComingSoon:
        "Giấy phép Slovakia sắp ra mắt. Chúng tôi đang chuẩn bị.",
    },
    RegionRequiredModal: {
      Title: "Chọn thị trường của bạn",
      Description:
        "Thị trường xác định loại tiền tệ và quyết toán mà bạn hoạt động. Lựa chọn này không thể thay đổi sau này.",
      LoadingError: "Danh sách thị trường không khả dụng",
      Error: "Không thể đặt khu vực của bạn. Vui lòng thử lại.",
      Confirm: "Xác nhận",
    },
    LicenseOrder: {
      CreateError: "Lỗi khi tạo đơn đặt giấy phép",
      CreateSuccess: "Đơn đặt giấy phép đã được tạo",
      LoadingError: "Lỗi khi tải đơn đặt giấy phép",
      Coupon: {
        Title: "Mã giảm giá",
        CheckboxLabel: "Tôi có mã giảm giá",
        Label: "Mã giảm giá",
        Placeholder: "Nhập mã giảm giá",
        Validate: "Áp dụng",
        Applied: "Đã áp dụng mã giảm giá",
        Remove: "Xóa mã giảm giá",
        OriginalPrice: "Giá gốc",
        Discount: "Giảm giá",
        FinalPrice: "Giá sau giảm",
        Error: {
          CouponNotFound: "Không tìm thấy mã giảm giá",
          CouponExpired: "Mã giảm giá đã hết hạn",
          CouponOutOfStock: "Mã giảm giá đã hết lượt sử dụng",
          CouponInvalidType: "Mã giảm giá không áp dụng cho loại giấy phép này",
          CouponRegionMismatch: "Mã giảm giá không hợp lệ cho quốc gia đã chọn",
          Unavailable: "Mã giảm giá không thể sử dụng được nữa",
        },
      },
    },
    LicensePayment: {
      PendingActivationInfo:
        "Giấy phép sẽ được kích hoạt sau khi thanh toán được ghi nhận. Nếu bạn đã thanh toán, vui lòng đợi thanh toán được ghi nhận.",
    },
    Invoice: {
      PaymentData: "Dữ liệu thanh toán",
      AccountNumber: "Số tài khoản",
      VariableSymbol: "Ký hiệu biến",
      SpecificSymbol: "Ký hiệu cụ thể",
      IBAN: "IBAN",
      Reference: "Số tham chiếu",
      Amount: "Số tiền",
      Note: "Ghi chú",
      MandatoryNoteDescription:
        "Ghi chú là bắt buộc! Không có ghi chú, thanh toán sẽ không được khớp",
      EmployerGuidelineButton: "Tải hướng dẫn cho nhà tuyển dụng",
      BulkDownload: {
        Download: "Tải hóa đơn",
        Success: "Hóa đơn đã được tải thành công",
        Error: "Không thể tải hóa đơn",
      },
    },
    RevalidateBankingAuthModal: {
      Title: "Ủy quyền cho một số ngân hàng của bạn sắp hết hạn",
      Description:
        "Để tiếp tục sử dụng {{appName}} như thường lệ, vui lòng xác thực lại chúng.",
      InvalidTitle: "Ủy quyền cho một số ngân hàng của bạn đã hết hạn",
      InvalidDescription:
        "Để khôi phục chức năng, vui lòng xác thực lại quyền truy cập các ngân hàng sau.",
      InvalidPispDescription:
        "Để khôi phục thanh toán qua các ngân hàng sau, vui lòng xác thực lại quyền truy cập.",
      ExpiringPispTitle: "Ủy quyền thanh toán sắp hết hạn",
      ExpiringPispDescription:
        "Để tiếp tục thanh toán qua các ngân hàng sau, vui lòng xác thực lại chúng.",
    },
    UnpaidSettlementPopup: {
      PayMonthlySettlement: "Thanh toán quyết toán hàng tháng {{amount}}.",
      PayMonthlySettlements: "Thanh toán các quyết toán hàng tháng",
      NoSettlementTransactionError:
        "Lỗi, quyết toán không có giao dịch được gán.",
    },
    LicensePicker: {
      LoadingError:
        "Rất tiếc, chúng tôi không thể tải giấy phép. Vui lòng thử lại sau.",
      LicenseDescription: {
        [LicenseCode.Gold]:
          "Giấy phép Hunter trong Legi.one với hình ảnh vật lý lớn.",
        [LicenseCode.Silver]:
          "Giấy phép Hunter trong Legi.one với hình ảnh vật lý trung bình.",
        [LicenseCode.Bronze]:
          "Giấy phép Hunter trong Legi.one với hình ảnh vật lý nhỏ.",
        [LicenseCode.Standard]:
          "Giấy phép Hunter trong Legi.one với hình ảnh kỹ thuật số.",
      },
      Perks: {
        Terminals: "thiết bị đầu cuối",
        Terminals_one: "thiết bị đầu cuối",
        Terminals_other: "thiết bị đầu cuối",
        SubAccounts: "tài khoản phụ",
        SubAccounts_one: "tài khoản phụ",
        SubAccounts_other: "tài khoản phụ",
        NoSubAccounts: "Không có tài khoản phụ",
      },
    },
    BanksList: {
      DataLoadingError: "Xin lỗi, chúng tôi không thể tải danh sách ngân hàng.",
      ShowAll: "Hiển thị tất cả ({{count}})",
      HideAll: "Ẩn",
    },
    LimitedAccountPopup: {
      Title: "Tài khoản bị hạn chế",
      Message:
        "Thông tin bạn cung cấp cần được xác minh bởi nhân viên của chúng tôi. Sau khi xác minh, chúng tôi sẽ thông báo cho bạn.",
    },
    DocumentExpirationWarning: {
      UploadNewDocument: "Tải lên giấy tờ mới",
      UploadSuccess: "Giấy tờ đã được tải lên thành công. Đang chờ xác minh.",
      AdminWarningTitle: "Giấy tờ của người dùng sắp hết hạn",
      AdminWarningMessage:
        "Giấy tờ tùy thân của người dùng này sẽ hết hạn vào {{date}}.",
      AdminExpiredTitle: "Giấy tờ của người dùng đã hết hạn",
      AdminExpiredMessage:
        "Giấy tờ tùy thân của người dùng này đã hết hạn. Người dùng bị hạn chế quyền truy cập.",
      WarningPrimaryTitle: "Giấy tờ tùy thân của bạn sắp hết hạn",
      WarningPrimaryMessage:
        "Giấy tờ tùy thân của bạn sẽ hết hạn vào {{date}}.",
      ExpiredPrimaryTitle: "Giấy tờ tùy thân của bạn đã hết hạn",
      ExpiredPrimaryMessage: "Giấy tờ tùy thân của bạn đã hết hạn.",
      WarningSecondaryTitle: "Giấy tờ phụ của bạn sắp hết hạn",
      WarningSecondaryMessage: "Giấy tờ phụ của bạn sẽ hết hạn vào {{date}}.",
      ExpiredSecondaryTitle: "Giấy tờ phụ của bạn đã hết hạn",
      ExpiredSecondaryMessage: "Giấy tờ phụ của bạn đã hết hạn.",
      AdminWarningSecondaryTitle: "Giấy tờ phụ của người dùng sắp hết hạn",
      AdminWarningSecondaryMessage:
        "Giấy tờ phụ của người dùng này sẽ hết hạn vào {{date}}.",
      AdminExpiredSecondaryTitle: "Giấy tờ phụ của người dùng đã hết hạn",
      AdminExpiredSecondaryMessage:
        "Giấy tờ phụ của người dùng này đã hết hạn.",
      SecondDocumentValidTo: "Hiệu lực giấy tờ phụ đến",
      AdminNotificationExpiredTitle: "Giấy tờ của người dùng đã hết hạn",
      AdminNotificationExpiredMessage:
        "Giấy tờ tùy thân của người dùng {{user}} đã hết hạn.",
    },
    RelatedPartyDocumentExpiration: {
      Title: "Giấy tờ của các bên liên quan cần được chú ý",
      WarningMessage:
        "{{name}} ({{relation}}) — giấy tờ tùy thân sẽ hết hạn vào {{date}}.",
      ExpiredMessage: "{{name}} ({{relation}}) — giấy tờ tùy thân đã hết hạn.",
      UpdateDocuments: "Cập nhật giấy tờ của bên liên quan",
    },
    MooneLitePopup: {
      Title: "Tài khoản Lite",
      Message:
        "Tài khoản của bạn đang hoạt động ở chế độ Lite hạn chế. Để sử dụng đầy đủ {{appName}}, bạn cần có ít nhất một tài khoản ngân hàng được kết nối và hoàn thành đăng ký bằng cách thêm dữ liệu cá nhân và xác minh giấy tờ tùy thân.",
      BankVerificationMessage:
        "Chúng tôi đã có dữ liệu cá nhân và giấy tờ tùy thân của bạn. Để sử dụng đầy đủ {{appName}}, hãy kết nối và xác minh tài khoản ngân hàng của bạn.",
      CompleteRegistrationButton: "Hoàn thành đăng ký",
      ConnectBankAccountButton: "Kết nối tài khoản ngân hàng",
      LimitExceeded:
        "Bạn đã vượt quá giới hạn sử dụng {{appName}} Lite. Để tiếp tục sử dụng {{appName}}, bạn cần hoàn thành đăng ký bằng cách thêm dữ liệu cá nhân và xác minh giấy tờ tùy thân.",
      RestrictionList: {
        NoPeerToPeerPayments: "Thanh toán chỉ có thể được gửi đến merchants",
        NoBalance: "Bạn không thể xem số dư trên tài khoản của mình",
        NoIncomingPayments: "Bạn không thể nhận thanh toán",
        NoLoyaltyPoints:
          "Bạn không thể kiếm điểm khách hàng thân thiết Stardust",
        MaxPaymentLimit:
          "Số tiền tối đa của các khoản thanh toán đi là 1000 EUR (hoặc tương đương bằng CZK)",
        MaxTransactionsLimit:
          "Nếu bạn vượt quá giới hạn giao dịch đã đặt, dịch vụ sẽ tự động bị tạm ngưng.",
      },
    },
    SetupChecklist: {
      Title: "Hoàn tất đăng ký",
      Subtitle: "Hoàn thành các bước sau để tận dụng tối đa {{appName}}.",
      LiteSubtitle:
        "Bạn đang dùng {{appName}} Lite — hoàn thành các bước sau để nâng cấp lên Full {{appName}} và tận dụng tối đa ứng dụng.",
      MerchantTitle: "Hoàn tất thiết lập",
      MerchantSubtitle:
        "Hoàn thành các bước sau để nhận thanh toán với {{appName}}.",
      StepsCompleted: "Đã hoàn thành {{completed}} trên {{total}} bước",
      Start: "Bắt đầu",
      InReview: "Đang xét duyệt",
      Steps: {
        ConnectBank: {
          Title: "Kết nối tài khoản ngân hàng",
          Description:
            "Thêm tài khoản ngân hàng của bạn để có thể gửi thanh toán.",
          Action: "Kết nối tài khoản",
        },
        SetPrimaryAccount: {
          Title: "Đặt tài khoản ngân hàng chính",
          Description:
            "Dành cho thanh toán đi, thanh toán nhanh và nhận thanh toán.",
          Action: "Chọn tài khoản chính",
          BlockedDescription:
            "Bạn sẽ có thể chọn tài khoản chính sau khi danh tính của bạn được xác minh.",
        },
        VerifyIdentity: {
          Title: "Xác minh danh tính của bạn",
          Description: "Mở khóa số dư, thanh toán đến và Stardust",
          Action: "Xác minh danh tính",
        },
      },
    },
    Bitcoin: "Bitcoin",
    IBAN: "IBAN",
    Maximum: "tối đa",
    SAT: "SAT",
    Or: "hoặc",
    RateConfirmation: "Xác nhận tỷ giá",
    Account: {
      DeactivateUser: {
        Title:
          "Bằng bước này bạn sẽ vô hiệu hóa tài khoản {{appName}} của mình",
        Description:
          "Tài khoản của bạn sẽ bị vô hiệu hóa và bạn sẽ không còn có thể đăng nhập vào tài khoản.",
        Confirmation:
          "Bạn có thực sự muốn vô hiệu hóa tài khoản? Việc vô hiệu hóa tài khoản {{appName}} sẽ dẫn đến mất quyền truy cập vào tài khoản {{appName}} của bạn.",
        DeactivateButton: "Vô hiệu hóa tài khoản",
        SuccessMessage: "Tài khoản đã được vô hiệu hóa thành công.",
        InfoSection: {
          Title: "Vô hiệu hóa tài khoản nghĩa là gì?",
          Paragraph1:
            "Khi vô hiệu hóa tài khoản, bạn sẽ ngay lập tức mất quyền truy cập vào ứng dụng {{appName}} (đăng nhập, thanh toán, giấy phép, quản lý tài khoản) và mọi quy trình đang diễn ra sẽ dừng lại, bao gồm việc chi trả cashback, settlement và hoa hồng affiliate.",
          Paragraph2:
            "Tuy nhiên, dữ liệu và lịch sử giao dịch của bạn vẫn được lưu trong hệ thống. Theo quy định của Ngân hàng Quốc gia Séc (ČNB) và Luật chống rửa tiền (AML), chúng tôi có nghĩa vụ lưu trữ những dữ liệu này trong 10 năm kể từ khi kết thúc hợp tác để phục vụ cho việc kiểm tra của cơ quan chức năng nếu có.",
        },
      },
      AccountTab: "Cài đặt",
      PublicInformationTab: "Hồ sơ",
      Products: "Sản phẩm",
      ContactPersons: "Người liên hệ",
      NoRoleAssignedError:
        "Đã xảy ra lỗi - người dùng không có vai trò được gán.",
      Primary: "Chính",
      VerificationAccount: "Tài khoản xác minh",
      AccountOwner: "Chủ tài khoản",
      ConnectionDate: "Ngày kết nối",
      ManualVerificationRequired: "Tài khoản này cần được xác minh thủ công",
      ActivateAccount: "Kích hoạt",
      RejectAccount: "Từ chối",
      AccountActivationConfirm:
        "Bạn có thực sự muốn kích hoạt tài khoản này?\n\nHành động này không thể hoàn tác.",
      AccountRejectionConfirm:
        "Bạn có thực sự muốn từ chối tài khoản này?\n\nHành động này không thể hoàn tác.",
      TerminalDocuments: "Tài liệu terminal",
      TerminalDocumentsFailed: "Không thể tải dữ liệu tài liệu terminal.",
      MerchantFacilitiesFailed: "Không thể tải dữ liệu cơ sở.",
      RelatedParties: "Các bên liên quan",
      RelatedPartySaved: "Dữ liệu bên liên quan đã được lưu",
      RelatedPartyError: "Đã xảy ra lỗi khi lưu dữ liệu bên liên quan",
      NoDocumentsForPerson: "Không tìm thấy tài liệu đã tải lên cho người này.",
      VerificationSaved: "Dữ liệu xác minh đã được lưu",
      VerificationError: "Đã xảy ra lỗi khi lưu dữ liệu xác minh",
      GeneralInformation: "Thông tin chung",
      Facilities: "Cơ sở",
      Verification: "Xác minh",
      Company: "Công ty",
      Declaration: "Tuyên bố",
      PersonalInformation: "Thông tin về bạn",
      CompanyName: "Tên công ty",
      TaxNumber: "Mã số thuế",
      TaxResidence: "Nơi cư trú thuế",
      BusinessSubject: "Đối tượng kinh doanh",
      SpecifyBusinessSubject: "Chỉ định đối tượng kinh doanh",
      IncomeSource: "Nguồn thu nhập",
      LegacyIncomeSource: "Nguồn thu nhập trước đây",
      SpecifyIncomeSource: "Chỉ định nguồn thu nhập",
      ExpectedMonthlyVolume: "Khối lượng hàng tháng dự kiến",
      AverageTransactionValue: "Giá trị giao dịch trung bình",
      PoliticallyExposed: "Người có ảnh hưởng chính trị",
      NonEUPermanentResidence:
        "Tôi hiện tại (tính đến ngày đăng ký) cư trú ngoài EU hơn 12 tháng",
      NonEUNationality: "Tôi là công dân của một quốc gia khác ngoài EU",
      StreetNumber: "Số đường",
      OrientationNumber: "Số định hướng",
      PostalCode: "Mã bưu chính",
      DocumentNumber: "Số tài liệu",
      BankAccount: "Tài khoản ngân hàng",
      PartyError: "Đã xảy ra lỗi khi lưu dữ liệu bên",
      VatRegistration: "Đăng ký thuế GTGT",
      VatNumberRestoredByRegistry:
        "Sổ đăng ký thuế GTGT đã xác nhận mã số thuế GTGT {{vatNumber}}, vì vậy mã số này vẫn được lưu — sổ đăng ký là nguồn dữ liệu chính thức.",
      VatStatusNotVerifiedHint:
        "Trạng thái trong sổ đăng ký thuế GTGT chưa được xác minh. Bạn có thể nhập mã số thuế GTGT bất cứ lúc nào.",
      PersonalDataChangeNotification:
        "Nếu bạn cần thay đổi dữ liệu cá nhân, vui lòng gửi thông tin mới đến info@mo.one.",
      SecondDocumentUploadError: "Không thể tải lên tài liệu thứ hai",
      SecondDocumentUploadSuccess:
        "Tài liệu thứ hai đã được tải lên và xử lý thành công",
      FirstDocumentUploadError: "Không thể tải lên tài liệu",
      FirstDocumentUploadSuccess:
        "Tài liệu đã được tải lên và xử lý thành công",
      FirstDocumentUpload: {
        UploadButton: "Tải lên tài liệu",
        FileDescription: "Nhấp vào đây để tải lên hoặc chụp ảnh",
      },
      SecondDocumentUpload: {
        Title: "Tài liệu thứ hai",
        Description: "Tài liệu thứ hai có thể là bằng lái xe hoặc hộ chiếu.",
        UploadButton: "Tải lên tài liệu thứ hai",
        FileLabel: "Mặt trước tài liệu thứ hai",
        FileDescription: "Nhấp vào đây để tải lên hoặc chụp ảnh",
      },
    },
    Forms: {
      Validation: {
        InvalidEmail: "E-mail không hợp lệ",
        PasswordMinLength: "Mật khẩu phải có ít nhất 8 ký tự",
        PasswordLowercase: "Mật khẩu phải chứa ít nhất một chữ thường",
        PasswordUppercase: "Mật khẩu phải chứa ít nhất một chữ hoa",
        PasswordNumber: "Mật khẩu phải chứa ít nhất một số",
        TermsAgreement: "Bạn phải đồng ý với các điều khoản và điều kiện",
        UserAlreadyExists: "Người dùng đã sử dụng {{appName}}.",
        InvitationAlreadySent: "Bạn đã gửi lời mời đến e-mail này.",
        InvitationError: "Đã xảy ra lỗi trong quá trình mời.",
      },
    },
    Merchant: {
      Logo: {
        FacilityTitle: "Logo cơ sở",
        Hint: "Định dạng hỗ trợ: PNG, JPEG, WebP, SVG (tối đa 2 MB). Khuyến nghị sử dụng logo tối trên nền trắng hoặc trong suốt.",
        FileTooLarge: "Tệp quá lớn (tối đa 2 MB)",
        InvalidFileType: "Định dạng tệp không được hỗ trợ",
        UploadSuccess: "Logo đã được tải lên",
        UploadError: "Không thể tải lên logo",
        DeleteSuccess: "Logo đã được xóa",
        DeleteError: "Không thể xóa logo",
      },
      Avatar: {
        Title: "Ảnh đại diện merchant",
        Hint: "Định dạng hỗ trợ: PNG, JPEG, WebP (tối đa 2 MB). Ảnh đại diện được hiển thị làm hình ảnh của merchant và trong chat.",
        RemoveConfirm: "Xóa ảnh đại diện merchant?",
        LockedAfterOnboardingHint:
          "Bạn chỉ có thể thay đổi ảnh đại diện merchant trong quá trình onboarding. Merchant có thể tự thay đổi bất cứ lúc nào trong tài khoản của mình.",
        UploadSuccess: "Đã cập nhật ảnh đại diện merchant",
        UploadError: "Không thể tải lên ảnh đại diện merchant",
        DeleteSuccess: "Đã xóa ảnh đại diện merchant",
        DeleteError: "Không thể xóa ảnh đại diện merchant",
      },
      Pricings: {
        PricingSettingError: "Lỗi - Không thể đặt giá merchant",
        PricingChangeError: "Lỗi - Không thể thay đổi giá merchant",
        LoadingError: "Lỗi - Không thể tải giá merchant",
        DirectPaymentError:
          "Lỗi - Không thể tải phí thanh toán trực tiếp merchant, vui lòng liên hệ quản trị viên.",
        SelectPricingLabel: "Chọn giá",
        FeeWithFee: "{{totalFee}}%",
        FeeWithCategoryAndFee: "{{categoryName}} {{totalFee}}%",
        FeeWithFeeAndAssignedCount:
          "{{totalFee}}% - {{assignedCount}}× được chỉ định",
        FeeWithCategoryFeeAndAssignedCount:
          "{{categoryName}} {{totalFee}}% - {{assignedCount}}× được chỉ định",
        CategoryNames: {
          Partner: "Đối tác",
          Prime: "Prime",
          Standard: "Tiêu chuẩn",
          Individual: "Cá nhân",
        },
      },
      LoadingError: "Lỗi - Không thể tải dữ liệu merchant",
      PaymentFailed: "Không thể tải dữ liệu.",
      AccountLoadingError: "Lỗi - Không thể tải tài khoản của bạn",
      PayPoints: {
        NoBankAccountConnectedWarning: {
          title: "Chưa kết nối tài khoản ngân hàng",
          linkPretext: "Thanh toán điểm thanh toán chỉ có thể được tạo sau khi",
          linkText: "kết nối tài khoản ngân hàng.",
        },
        NoProductAssigned: "Bạn không có sản phẩm nào được gán.",
        NoPaypointProduct:
          "Bạn không có sản phẩm nào được gán cho phép tạo điểm thanh toán.",
      },
      ContactPersons: {
        Title: "Người liên hệ",
        LoadingError: "Lỗi - Không thể tải người liên hệ",
        DeleteSuccess: "Người liên hệ đã được xóa thành công",
        DeleteError: "Lỗi - Không thể xóa người liên hệ",
        DeleteConfirmation: "Bạn có chắc muốn xóa người liên hệ {{name}}?",
        AddContactPerson: "+Thêm người liên hệ",
        NewContactPerson: "Người liên hệ mới",
        ContactPersonDetail: "Chi tiết người liên hệ",
        NoContactPersons: "Chưa có người liên hệ nào được thêm",
        Form: {
          AddSuccess: "Người liên hệ đã được thêm thành công",
          AddError: "Lỗi - Không thể thêm người liên hệ",
          UpdateSuccess: "Người liên hệ đã được cập nhật thành công",
          UpdateError: "Lỗi - Không thể cập nhật người liên hệ",
          Legend: "Người liên hệ",
        },
      },
      BeneficialOwners: {
        BeneficialOwnerDetail: "Chi tiết người thụ hưởng",
        AddBeneficialOwner: "+ Thêm người thụ hưởng",
        NewBeneficialOwner: "Người thụ hưởng mới",
        Title: "Người thụ hưởng",
        LoadingError: "Không thể tải dữ liệu người thụ hưởng.",
        NoBeneficialOwners: "Chưa có người thụ hưởng nào được thêm",
        Form: {
          DeleteConfirmation: "Bạn có chắc muốn xóa người thụ hưởng {{name}}?",
          AddSuccess: "Người thụ hưởng đã được thêm thành công",
          AddError: "Lỗi - Không thể thêm người thụ hưởng",
          UpdateSuccess: "Người thụ hưởng đã được cập nhật thành công",
          UpdateError: "Lỗi - Không thể cập nhật người thụ hưởng",
          Legend: "Người thụ hưởng",
        },
      },
      Facilities: {
        Title: "Cơ sở",
        LoadingError: "Không thể tải dữ liệu cơ sở.",
        DeleteSuccess: "Cơ sở đã được xóa thành công",
        DeleteError: "Lỗi - Không thể xóa cơ sở",
        DeleteConfirmation: "Bạn có chắc muốn xóa cơ sở {{name}}?",
        AddFacility: "+ Thêm cơ sở",
        NewFacility: "Cơ sở mới",
        EditFacility: "Chỉnh sửa cơ sở",
        FacilityDetail: "Chi tiết cơ sở",
        NoFacilities: "Chưa có cơ sở nào được thêm",
        NoAddress: "Không có địa chỉ",
        Incomplete: "Chưa hoàn thành",
        NoPhotos: "Cơ sở chưa có ảnh nào được tải lên.",
        PhotosLoadingError: "Không thể tải ảnh của cơ sở.",
        Form: {
          AddSuccess: "Cơ sở đã được thêm thành công",
          AddError: "Lỗi - Không thể thêm cơ sở",
          UpdateSuccess: "Cơ sở đã được cập nhật thành công",
          UpdateError: "Lỗi - Không thể cập nhật cơ sở",
          PhotoUploadSuccess: "Ảnh đã được tải lên thành công",
          PhotoUploadError: "Lỗi - Không thể tải lên ảnh",
          PhotoTooLarge: "Ảnh quá lớn (tối đa {{maxSizeMb}} MB).",
          PhotoInvalidType:
            "Định dạng tệp không được hỗ trợ. Hãy dùng JPEG, PNG hoặc WebP.",
          PhotosNotSaved:
            "Cơ sở đã được lưu nhưng ảnh chưa được tải lên. Hãy sửa ảnh được đánh dấu và lưu lại.",
          PhotosDescription:
            "Tải lên ảnh cơ sở của bạn. Những ảnh này sẽ được hiển thị cho khách hàng. JPEG, PNG hoặc WebP, tối đa {{maxSizeMb}} MB mỗi ảnh.",
          UploadPhotos: "Tải lên ảnh",
          PhotoSelected: "Tệp đã chọn: {{name}}",
          PhotoUploadButton: "Tải lên",
          PhotoChangeButton: "Thay đổi",
          PhotoDeleteButton: "Xóa",
          Legend: {
            BasicInformation: "Thông tin cơ bản",
            Contact: "Liên hệ",
            OpeningHours: "Giờ mở cửa",
            Address: "Địa chỉ",
            Turnover: "Doanh thu",
            Terminals: "Terminal",
            PublicFacilityInfo: "Thông tin cơ sở công cộng",
            DetailedOpeningHours: "Giờ mở cửa chi tiết",
            Photos: "Ảnh cơ sở",
          },
          RequiredSection: "Thông tin bắt buộc",
          OptionalSection: "Thông tin không bắt buộc",
          OptionalSectionDescription:
            "Thương nhân sẽ hoàn thành những thông tin này trong quá trình đăng ký của họ. Nếu bạn đã có thông tin, bạn có thể điền trước.",
          PublicFacilityDescription:
            "Cơ sở công cộng yêu cầu thông tin bổ sung. Vui lòng điền bên dưới.",
          IsPublicHelpText:
            'Điều này sẽ cho phép khách hàng thấy cơ sở của bạn trong danh sách "nơi để thanh toán".',
          UseRegisteredAddress: "Giống với địa chỉ đăng ký",
          PrefillContact: "Điền sẵn liên hệ từ",
          NoName: "Không có tên",
          Validation: {
            CategoryRequiredWhenPublic:
              "Cần ít nhất một danh mục khi cơ sở là công cộng",
          },
          Fields: {
            Name: "Tên",
            ProvidedServices: "Dịch vụ cung cấp",
            ResponsiblePerson: "Người phụ trách",
            Phone: "Điện thoại",
            Email: "E-mail",
            IsPublic: "Tôi muốn cơ sở này được công khai",
            Category: "Danh mục",
            OpeningHoursFrom: "Từ",
            OpeningHoursTo: "Đến",
            Address: {
              Street: "Đường",
              StreetNumber: "Số đường",
              OrientationNumber: "Số định hướng",
              PostalCode: "Mã bưu chính",
              Municipality: "Thành phố",
              District: "Quận",
            },
            WeekDays: {
              Monday: "Thứ Hai",
              Tuesday: "Thứ Ba",
              Wednesday: "Thứ Tư",
              Thursday: "Thứ Năm",
              Friday: "Thứ Sáu",
              Saturday: "Thứ Bảy",
              Sunday: "Chủ Nhật",
            },
            YearlyTurnover: "Doanh thu hàng năm",
            RealCardTurnover: "Doanh thu thẻ thực tế",
            AverageTransactionValue: "Giá trị giao dịch trung bình",
            EstimatedTurnover: "Doanh thu ước tính",
            EstimatedTurnoverHelperText:
              "Vui lòng chỉ điền trường này nếu bạn đang đăng ký công ty mới",
            Description: "Về chúng tôi",
            PhotoOutside: "Ảnh ngoại thất",
            PhotoInside: "Ảnh nội thất",
            TerminalCount: "Số lượng terminal vật lý",
            TerminalCountHelperText: "Terminal vật lý không bao gồm SoftPOS.",
            SoftPosCount: "Số lượng SoftPOS",
            SoftPosCountHelperText:
              "Ứng dụng thanh toán trên điện thoại. Không đặt trước terminal vật lý.",
          },
          OpeningHours: {
            Title: "Giờ mở cửa",
            ClosedAllDay: "Đóng cửa cả ngày",
            OpenAllDay: "Mở cửa 24 giờ",
            AddTimeRange: "Thêm khoảng thời gian",
            DeleteTimeRange: "Xóa khoảng thời gian",
            From: "Từ",
            To: "Đến",
            BulkEdit: "Chỉnh sửa tất cả",
            ExitBulkEdit: "Thoát chỉnh sửa hàng loạt",
            ApplyToSelected: "Áp dụng cho các ngày đã chọn",
            SelectDays: "Chọn ngày",
            QuickSelectTitle: "Chọn nhanh",
            Cancel: "Hủy",
            Save: "Lưu",
            TimeRange: "Từ - Đến",
            CurrentHours: "Giờ hiện tại",
            ShowDetailedEdit: "Chỉnh sửa từng ngày",
            HideDetailedEdit: "Ẩn chỉnh sửa từng ngày",
            QuickSelect: {
              Weekdays: "T2-T6",
              AllWeek: "T2-CN",
              Weekend: "Cuối tuần",
            },
            Validation: {
              CannotBeBothOpenAndClosed:
                "Không thể vừa mở vừa đóng cửa cả ngày",
              InvalidTimeFormat:
                "Định dạng thời gian không hợp lệ. Mong đợi HH:MM:SS",
              OpeningTimeBeforeClosingTime:
                "Giờ mở cửa phải trước giờ đóng cửa",
            },
          },
        },
      },
      OrbitL: {
        Title: "Terminal thanh toán",
        StatusLabel: "Trạng thái đơn hàng",
        RefreshTooltip: "Làm mới trạng thái",
        Tariff: {
          Label: "Bảng giá",
          Pos1Cz: "Bảng giá 1 — 0,49 % MIF++",
          Pos2Cz: "Bảng giá 2 — 0,41 % MIF++",
          Pos3Cz: "Bảng giá 3 — 0,35 % MIF++",
          Pos4Cz: "Bảng giá 4 — 0,29 % MIF++",
        },
        Financing: {
          Label: "Tài trợ terminal",
          Legione: "Terminal được tài trợ bởi Legi.one",
          Hunter: "Terminal được tài trợ bởi Hunter",
        },
        HunterCapacity: {
          AvailableHelper: "Hunter có sẵn {{count}} terminal",
          ExceedsError:
            "Số lượng terminal ({{requested}}) vượt quá dung lượng khả dụng của hunter ({{available}}).",
        },
        Progress: {
          Steps: {
            Completion: "Hoàn thiện dữ liệu",
            Signing: "Ký tài liệu",
            Processing: "Đang xử lý",
            Dispatch: "Gửi terminal",
            DispatchSoftPos: "Kích hoạt SoftPOS",
            Done: "Hoàn tất",
          },
        },
        Checklist: {
          Heading: "Danh sách kiểm tra yêu cầu",
          CompletionSuccess:
            "Tất cả các yêu cầu đã được đáp ứng. Bạn có thể tiến hành tải xuống hợp đồng.",
          ToCompleteSection: "Cần hoàn thiện",
          GoToSettingsLink: "Đến cài đặt",
          Items: {
            BasicInfo: "Thông tin cơ bản của thương nhân",
            FacilityInfo: "Thông tin cơ sở",
            BankAccountInfo: "Tài khoản ngân hàng nhận tiền",
            ExecutiveInfo: "Thông tin người đại diện",
            ExecutiveInfoSelfEmployed: "Thông tin cá nhân của bạn",
            ExecutiveDocuments: "Giấy tờ tùy thân của người đại diện",
            ExecutiveDocumentsSelfEmployed: "Giấy tờ tùy thân của bạn",
            TerminalAssignment: "Phân bổ thiết bị đầu cuối cho cơ sở",
          },
          Validation: {
            BasicInfo: "Vui lòng hoàn thiện thông tin cơ bản của thương nhân",
            FacilityInfo: "Vui lòng hoàn thiện thông tin cơ sở",
            BankAccountInfo:
              "Vui lòng thêm hoặc xác minh tài khoản ngân hàng nhận tiền",
            ExecutiveInfo: "Vui lòng hoàn thiện thông tin người đại diện",
            ExecutiveInfoSelfEmployed:
              "Vui lòng hoàn thiện thông tin cá nhân của bạn",
            ExecutiveDocuments:
              "Vui lòng tải lên giấy tờ tùy thân của người đại diện",
            ExecutiveDocumentsSelfEmployed:
              "Vui lòng tải lên giấy tờ tùy thân của bạn",
            TerminalAssignment:
              "Thiết bị đầu cuối chưa được phân bổ đầy đủ cho tất cả cơ sở",
          },
          BankReconnect: {
            Explanation:
              "Bạn đã thêm tài khoản ngân hàng, nhưng quyền sở hữu tài khoản chưa được xác minh. Vui lòng kết nối lại ngân hàng – bạn sẽ đăng nhập vào ngân hàng trực tuyến rồi quay lại đây.",
            Button: "Kết nối lại ngân hàng",
          },
          MissingFields: {
            MissingExecutive: "chưa có người đại diện theo pháp luật",
            PrimaryBankAccount: "chưa có tài khoản ngân hàng nhận tiền chính",
            BankVerificationAudit:
              "thiếu xác minh quyền sở hữu tài khoản ngân hàng",
            BirthDate: "ngày sinh",
            Email: "e-mail",
            Phone: "số điện thoại",
            PermanentAddress: "nơi cư trú",
            PermanentAddressStreet: "tên phố hoặc số nhà",
            PermanentAddressMunicipality: "thành phố cư trú",
            PermanentAddressPostalCode: "mã bưu chính nơi cư trú",
            Documents: "giấy tờ tùy thân",
            FirstDocumentNumber: "số giấy tờ thứ nhất",
            FirstDocumentValidity: "hiệu lực giấy tờ thứ nhất",
            FirstDocumentPhotos: "ảnh giấy tờ thứ nhất",
            SecondDocumentNumber: "số giấy tờ thứ hai",
            SecondDocumentValidity: "hiệu lực giấy tờ thứ hai",
            SecondDocumentPhotos: "ảnh giấy tờ thứ hai",
          },
        },
        Rejection: {
          Title: "Đơn vị xử lý đã trả lại giấy tờ để sửa",
          Intro:
            "Các giấy tờ dưới đây cần được sửa. Hãy cập nhật trong phần cài đặt và chúng tôi sẽ gửi lại đơn hàng.",
          ContractGroup: "Hợp đồng và thông tin công ty",
          DocumentLabel: "{{type}} số {{number}}",
          DocumentTypes: {
            IdCard: "Chứng minh thư",
            Passport: "Hộ chiếu",
            DriverLicense: "Giấy phép lái xe",
            OtherDocument: "Giấy tờ khác",
          },
        },
        Phase: {
          RequiresCompletion: "Cần hoàn thiện",
          ReadyToDownloadContract: "Sẵn sàng tải xuống",
          ContractDownloaded: "Đã tải hợp đồng",
          SubmittedToComgate: "Đã gửi xử lý",
          ProcessingByComgate: "Đang xử lý",
          TerminalDispatched: "Terminal đã gửi đi",
          Completed: "Hoàn tất",
        },
        FinancingModel: {
          Hunter: "Hunter",
          Legione: "LEGI.ONE",
        },
        Messages: {
          LoadStatusError: "Không thể tải trạng thái đơn hàng Orbit L",
          Processing:
            "Đơn hàng của bạn đang được xử lý. Chúng tôi sẽ thông báo bước tiếp theo qua email.",
          CompletedSuccess:
            "Đơn hàng đã hoàn tất. Các terminal đã được bàn giao và đang hoạt động.",
        },
        Contract: {
          DocumentsHeading: "Tài liệu hợp đồng",
          LoanTitle: "Hợp đồng cho mượn terminal",
          LoanFileName: "Hop_dong_cho_muon_terminal",
          PaymentServicesTitle: "Hợp đồng dịch vụ thanh toán",
          PaymentServicesFileName: "Hop_dong_dich_vu_thanh_toan",
          DownloadedAt: "Hợp đồng đã được tải vào ngày {{date}}",
          DownloadButton: "Tải hợp đồng",
          DownloadAgainButton: "Tải lại hợp đồng",
          AcceptanceLabel:
            'Tôi xác nhận đã đọc cả hai hợp đồng và đồng ý với các điều khoản. Khi nhấn "Đặt hàng ràng buộc" tôi ký điện tử các hợp đồng.',
          SubmitButton: "Đặt hàng ràng buộc dịch vụ thẻ",
          SubmittingButton: "Đang gửi...",
          SubmitNote:
            "Sau khi gửi đơn hàng, chúng tôi sẽ xử lý yêu cầu của bạn. Bạn sẽ được thông báo các bước tiếp theo qua email.",
          DownloadSuccess: "Hợp đồng đã được tải thành công",
          DownloadError: "Tải hợp đồng thất bại",
          SubmitSuccess: "Đơn hàng đã được gửi xử lý.",
          SubmitError: "Gửi đơn hàng Orbit L thất bại: {{error}}",
          SubmitErrorGeneric: "Gửi đơn hàng thất bại",
        },
        Handover: {
          DispatchedNoData:
            "Các terminal đã được gửi đi. Thông tin chi tiết sẽ được cập nhật tự động sau khi cập nhật trạng thái.",
          Title: "Bàn giao terminal",
          DispatchedReady:
            "Các terminal của bạn đã được gửi đi và sẵn sàng kích hoạt.",
          TableTID: "TID (Terminal ID)",
          TableSerialNumber: "Số seri",
          TableModel: "Model",
          Note: "Sau khi xác nhận bàn giao, các terminal sẽ được tự động kích hoạt làm điểm thanh toán (PayPoints) trong tài khoản của bạn.",
          ConfirmButton: "Xác nhận nhận terminal",
          ConfirmingButton: "Đang xác nhận...",
          ConfirmSuccess: "Bàn giao terminal đã được xác nhận thành công",
          ConfirmError: "Xác nhận bàn giao terminal thất bại: {{error}}",
          ConfirmErrorGeneric: "Xác nhận bàn giao thất bại",
        },
        TerminalSelection: {
          Title: "Chọn terminal",
          SelectionCount: "Đã chọn {{selected}} trong {{required}} terminal",
          NoTerminalsAvailable: "Bạn không có terminal nào để phân bổ",
          StockExceeded:
            "Tổng số terminal ({{total}}) vượt quá kho có sẵn ({{available}})",
          SerialNumber: "SN",
          HardwareModel: "Model",
        },
        FacilityTerminals: {
          Title: "Phân bổ terminal cho cơ sở",
          TerminalCountLabel: "Số lượng terminal vật lý",
          TerminalCountHelperText: "Terminal vật lý không bao gồm SoftPOS.",
          SoftPosCountLabel: "Số lượng SoftPOS",
          SoftPosCountHelperText:
            "Ứng dụng thanh toán trên điện thoại, không có terminal vật lý.",
          SoftPosRequestHelperText:
            "Bạn chưa có SoftPOS. Nhập số lượng và gửi yêu cầu; SoftPOS sẽ được kích hoạt sau khi bộ phận hỗ trợ xác nhận.",
          SoftPosStatus: "SoftPOS: {{count}}",
          TerminalStatus: "{{assigned}}/{{total}} đã phân bổ",
          NoTerminalsConfigured: "Chưa cấu hình terminal",
          NoAddress: "Không có địa chỉ",
          FullyReserved: "Tất cả terminal đã được phân bổ",
          SaveButton: "Lưu terminal",
          Saving: "Đang lưu...",
          SaveSuccess: "Phân bổ terminal thành công",
          SaveError: "Phân bổ terminal thất bại",
          InsufficientStock:
            "Không đủ terminal trong kho. Vui lòng liên hệ hỗ trợ.",
          CountsLocked:
            "Không thể thay đổi số lượng terminal trực tiếp nữa, đơn hàng đã ở Comgate. Hãy gửi yêu cầu thay đổi và bộ phận hỗ trợ sẽ xử lý.",
          LoadError: "Không thể tải dữ liệu terminal",
          AssignedTerminals: "Các terminal đã phân bổ",
        },
        TerminalCountChange: {
          NotificationTitle: "Yêu cầu thay đổi số lượng terminal",
          NotificationMessage:
            "{{company}} yêu cầu thay đổi số lượng terminal từ {{from}} thành {{to}}.",
          LockedHint:
            "Đơn hàng đã được gửi tới Comgate nên không thể thay đổi số lượng terminal trực tiếp. Hãy gửi yêu cầu tới bộ phận hỗ trợ.",
          RequestButton: "Yêu cầu thay đổi",
          ModalTitle: "Yêu cầu thay đổi số lượng terminal",
          ModalDescription:
            "Sau khi đơn hàng đã gửi tới Comgate, số lượng terminal không thể thay đổi tự động. Việc gửi sẽ tạo một yêu cầu cho bộ phận hỗ trợ, họ sẽ thống nhất thay đổi với Comgate và liên hệ lại với bạn.",
          ModalSummaryHeading: "Tóm tắt thay đổi",
          ModalFacilityChange: "{{facility}}: {{from}} → {{to}}",
          ModalTotal: "Tổng: {{from}} → {{to}}",
          ModalFacilitySoftPosChange:
            "{{facility}} (SoftPOS): {{from}} → {{to}}",
          ModalSoftPosTotal: "Tổng SoftPOS: {{from}} → {{to}}",
          ModalNoteLabel: "Ghi chú cho bộ phận hỗ trợ (không bắt buộc)",
          ModalNotePlaceholder: "Ví dụ: chúng tôi mở chi nhánh mới ngày 1/9.",
          ModalConfirm: "Gửi yêu cầu",
          ModalCancel: "Hủy",
          PendingTitle: "Đã gửi yêu cầu thay đổi số lượng terminal",
          PendingMessage:
            "Yêu cầu thay đổi số lượng terminal từ {{from}} thành {{to}} đã được gửi tới bộ phận hỗ trợ. Chúng tôi sẽ liên hệ lại ngay khi thống nhất được với Comgate.",
          PendingNote: "Ghi chú của bạn: {{note}}",
          PendingSoftPosMessage: "Giấy phép SoftPOS: {{from}} → {{to}}.",
          RequestSuccess: "Đã gửi yêu cầu tới bộ phận hỗ trợ",
          RequestError: "Không thể gửi yêu cầu",
          RequestConflictError:
            "Bạn đã có một yêu cầu thay đổi số lượng terminal đang mở. Vui lòng đợi yêu cầu được xử lý.",
        },
      },
      TerminalContracts: {
        Title: "Bản nháp hợp đồng terminal",
        LoadingError: "Không thể tải dữ liệu bản nháp hợp đồng terminal.",
        NoTerminalContracts: "Chưa có bản nháp hợp đồng terminal nào được thêm",
        AddSuccess: "Bản nháp hợp đồng terminal đã được thêm thành công",
        AddError: "Lỗi - Không thể thêm bản nháp hợp đồng terminal",
        UpdateSuccess: "Bản nháp hợp đồng terminal đã được cập nhật thành công",
        UpdateError: "Lỗi - Không thể cập nhật bản nháp hợp đồng terminal",
        DeleteSuccess: "Bản nháp hợp đồng terminal đã được xóa thành công",
        DeleteError: "Lỗi - Không thể xóa bản nháp hợp đồng terminal",
        DeleteConfirmation:
          "Bạn có chắc muốn xóa bản nháp hợp đồng terminal {{type}}?",
        AddButtonText: "+ Thêm bản nháp hợp đồng terminal",
        NewContractDialogTitle: "Bản nháp hợp đồng terminal mới",
        EditContractDialogTitle: "Chỉnh sửa bản nháp hợp đồng terminal",
        ViewContractDialogTitle: "Xem bản nháp hợp đồng terminal",
        ProductType: {
          UCB: "Orbit M - Terminal vật lý không máy in (Android)",
          COMGATE: "Orbit L - Terminal vật lý có máy in (Android)",
          ELCOM: "Orbit ELCOM - Terminal ELCOM",
        },
        Form: {
          Fields: {
            Type: "Loại",
            GprsCount: "Số lượng terminal GPRS",
            TerminalCount: "Số lượng terminal vật lý",
            TerminalCountHelperText: "Terminal vật lý không bao gồm SoftPOS.",
            SoftPosCount: "Số lượng SoftPOS",
            CountsFromFacilitiesHint:
              "Tổng theo các cơ sở; chỉnh sửa trong biểu mẫu cơ sở.",
            Currencies: "Đơn vị tiền tệ",
            Tariff: "Biểu phí",
            PayoutIBAN: "IBAN thanh toán",
            PayoutBIC: "BIC thanh toán",
            PayoutCurrency: "Đơn vị tiền thanh toán",
            PayoutAccountNumber: "Số tài khoản thanh toán",
          },
        },
        Comgate: {
          SubmitButton: "Gửi tới Comgate",
          Submitting: "Đang gửi...",
          SubmitConfirmation:
            "Hành động này sẽ tạo hợp đồng cho vay, tự động chấp nhận và gửi dữ liệu đến Comgate. Tiếp tục?",
          SubmitSuccess: "Đã gửi thành công tới Comgate. MID: {{mid}}",
          SubmitError: "Không thể gửi tới Comgate. Vui lòng thử lại.",
          SubmitViaOrbitL:
            "Sử dụng quy trình Orbit L onboarding để gửi hợp đồng này tới Comgate.",
          StatusLabel: "Trạng thái Comgate",
          Statuses: {
            REQUESTED: "Đã yêu cầu",
            PROCESSING: "Đang xử lý",
            WAITING_FOR_DOCUMENTS: "Đang chờ tài liệu",
            WAITING_FOR_AUTHORIZATION_PAYMENT: "Đang chờ thanh toán xác thực",
            ERRORS_IN_DOCUMENTS: "Lỗi trong tài liệu",
            ERROR_ACTION_PENDING: "Lỗi - đang chờ xử lý",
            REJECTED: "Đã từ chối",
            ASSOCIATION_REGISTERING: "Đang đăng ký hiệp hội",
            READY: "Sẵn sàng",
          },
        },
      },
      AppProducts: {
        Title: "Sản phẩm",
        LoadingError: "Không thể tải dữ liệu sản phẩm.",
        NoProducts: "Chưa có sản phẩm nào được thêm",
        Form: {
          AddError: "Lỗi - Không thể thêm sản phẩm",
          AddErrorCountsLocked:
            "Đơn hàng đã được gửi tới Comgate nên không thể thêm sản phẩm trực tiếp. Hãy gửi yêu cầu thay đổi số lượng terminal, bộ phận hỗ trợ sẽ xử lý.",
          RemoveError: "Lỗi - Không thể xóa sản phẩm",
          Prerequisites: {
            Title: "Điều kiện tiên quyết",
            FacilityAdded: "Cơ sở đã được thêm",
            FacilityPhotos: "Ảnh cơ sở kinh doanh (bên ngoài + bên trong)",
          },
        },
        UnknownProduct: "Sản phẩm không xác định",
        Products: {
          OrbitS: "Orbit S",
          OrbitM: "Orbit M",
          OrbitL: "Orbit L",
          SoftPos: "SoftPOS",
        },
        ProductDescriptions: {
          OrbitS: "Không có terminal vật lý, 3 thẻ NFC",
          OrbitM: "Orbit M - Terminal vật lý không có máy in (Android)",
          OrbitL: "Orbit L - Terminal vật lý có máy in (Android)",
          SoftPos:
            "SoftPOS - Ứng dụng thanh toán trên điện thoại, không có terminal vật lý",
        },
        ProductAccordion: {
          Active: "Hoạt động",
          Activate: "Kích hoạt sản phẩm",
          Deactivate: "Vô hiệu hóa",
          Preview: "Sắp ra mắt",
          Default: "Mặc định",
          ProductNotActivated: "Sản phẩm này chưa được kích hoạt",
          SoftPosViaChangeRequest:
            "Đơn đặt terminal đã được gửi tới Comgate. Để thêm SoftPOS, hãy vào thẻ Orbit L: nhập số lượng SoftPOS cho cơ sở và gửi yêu cầu thay đổi số lượng. SoftPOS sẽ được kích hoạt sau khi bộ phận hỗ trợ xác nhận.",
          SoftPosContactSupport:
            "Đơn đặt terminal đã được gửi tới Comgate. Để thêm SoftPOS, hãy liên hệ bộ phận hỗ trợ.",
          FeeWithPricing: "Phí đã đặt: {{totalFee}}% | {{productName}}",
          FeeWithCategoryAndPricing:
            "{{categoryName}} | Phí đã đặt: {{totalFee}}% | {{productName}}",
          IndividualPricing: "Bảng giá cá nhân",
        },
      },
    },
    ProfilePhoto: {
      ChangeAction: "Đổi ảnh",
      RemoveAction: "Xóa ảnh",
      CropDialogTitle: "Cắt ảnh của bạn",
      ZoomLabel: "Phóng to",
      CropSave: "Lưu",
      CropCancel: "Hủy",
      FileTooLarge: "Tệp quá lớn (tối đa 2 MB)",
      InvalidFileType:
        "Loại tệp không được hỗ trợ. Hãy dùng PNG, JPEG hoặc WebP.",
    },
    UserAccount: {
      ProfilePhoto: {
        Hint: "Định dạng được hỗ trợ: PNG, JPEG, WebP (tối đa 2 MB)",
        RemoveConfirm: "Bạn có chắc muốn xóa ảnh hồ sơ?",
        UploadSuccess: "Đã cập nhật ảnh hồ sơ",
        UploadError: "Không thể tải lên ảnh hồ sơ",
        DeleteSuccess: "Đã xóa ảnh hồ sơ",
        DeleteError: "Không thể xóa ảnh hồ sơ",
      },
      ChangePassword: {
        SectionTitle: "Mật khẩu",
        OpenAction: "Đổi mật khẩu",
        DialogTitle: "Đổi mật khẩu",
        OldPasswordLabel: "Mật khẩu hiện tại",
        NewPasswordLabel: "Mật khẩu mới",
        NewPasswordConfirmLabel: "Xác nhận mật khẩu mới",
        Submit: "Đổi mật khẩu",
        Cancel: "Hủy",
        Success:
          "Đã đổi mật khẩu. Vui lòng đăng nhập lại bằng mật khẩu mới của bạn.",
        NewMustDiffer: "Mật khẩu mới phải khác mật khẩu hiện tại.",
        WrongOldPassword: "Mật khẩu hiện tại không đúng.",
        GenericError: "Không thể đổi mật khẩu. Vui lòng thử lại.",
        RateLimitError: "Quá nhiều lần thử. Vui lòng đợi một lát và thử lại.",
      },
    },
    Onboarding: {
      LogoutButtonLabel: "Rời khỏi đăng ký",
      LicensePaymentReceived: "Đã nhận thanh toán",
      LicensePaymentProcessing: "Chúng tôi đang xử lý thanh toán của bạn",
      SSO: {
        MerchantDescription:
          "Với vai trò merchant, bạn có thể nhận thanh toán từ khách hàng với phí thấp hơn và sử dụng điểm thanh toán không tiếp xúc.",
        CustomerDescription:
          "Với vai trò người dùng, bạn có thể gửi thanh toán trực tiếp, thanh toán mua hàng và tích lũy điểm Stardust.",
        HunterDescription:
          "Với vai trò hunter, bạn có thể nhận giấy phép Legione, quản lý merchants của bạn và kiếm hoa hồng từ giao dịch của họ",
        Merchant: "Merchant",
        Customer: "Người dùng",
        FirstLogin:
          "Vì đây là lần đăng nhập đầu tiên, chúng tôi cần biết bạn đăng ký với vai trò Người dùng, Merchant hay Hunter.",
      },
    },
    Shared: {
      Filters: {
        Title: "Bộ lọc",
        TimePeriod: "Khoảng thời gian",
        TimePeriodLabels: {
          day: "Hôm nay",
          week: "Tuần này",
          month: "Tháng này",
          custom: "Tùy chỉnh",
        },
        Unlimited: "Không giới hạn",
        DateFrom: "Từ",
        DateTo: "Đến",
        DateRange: "Phạm vi ngày",
        PayPoint: "PayPoint",
        AllPayPoints: "Tất cả PayPoint",
        Employee: "Nhân viên",
        AllEmployees: "Tất cả nhân viên",
        Status: "Trạng thái",
        AllStatuses: "Tất cả trạng thái",
        Apply: "Áp dụng",
        Reset: "Xóa bộ lọc",
        RefundOrCancellation: "Hoàn tiền hoặc hủy",
        ShowOnlyRefundsAndCancellations: "Chỉ hoàn tiền và hủy",
      },
      NotificationTypeSelect: {
        SelectNotificationType: "Chọn loại thông báo",
      },
      CodeListAutocomplete: {
        Placeholder: "Chọn tùy chọn",
        SelectAll: "Chọn tất cả",
      },
      Carousel: {
        ScrollLeft: "Cuộn sang trái",
        ScrollRight: "Cuộn sang phải",
      },
      Progress: {
        AriaLabel: "Tiến trình",
      },
      Dropdown: {
        NoOptions: "Không có tùy chọn nào",
      },
      PoliticallyExposedDescription: `Người có ảnh hưởng chính trị (PEP) là người giữ hoặc đã giữ một chức vụ công quan trọng, như tổng thống, thủ tướng, bộ trưởng, đại sứ, thẩm phán tối cao, sĩ quan quân đội cấp cao hoặc thành viên quốc hội. Người có ảnh hưởng chính trị cũng có thể bao gồm các thành viên gia đình gần hoặc đồng sự thân cận của họ.

      Định nghĩa pháp lý của PEP có thể được tìm thấy trong Mục 4(5) của Đạo luật số 253/2008 Coll., về một số biện pháp chống hợp pháp hóa tiền thu được từ hoạt động tội phạm và tài trợ khủng bố.`,

      DownloadPartyIdentificationsButtonLabel: "Tải tài liệu",
      Payments: {
        Amount: "Số tiền",
        VariableSymbol: "Ký hiệu biến",
        Note: "Ghi chú",
      },
      SettlementPeriodSelector: {
        Placeholder: "Chọn kỳ",
        NoSettlementPeriods:
          "Hiện không có quyết toán nào có sẵn để tải xuống.",
      },
      BankingAccountSelector: {
        NoBankAccounts: "Bạn không có tài khoản ngân hàng nào đã kết nối.",
        ConnectBankAccount: "Kết nối tài khoản ngân hàng",
      },
      CardsList: {
        View: "Xem",
        Edit: "Chỉnh sửa",
        Delete: "Xóa",
        Download: "Tải xuống",
      },
      HunterAutocomplete: {
        SearchHunter: "Chọn hunter khác",
        SearchHunterPlaceholder: "Nhập tên hoặc ID giấy phép",
        SearchHunterMinLength: "Nhập ít nhất 2 ký tự để tìm kiếm",
        SearchHunterNoResults: "Không tìm thấy hunter nào",
      },
      HunterList: {
        MainHunterCard: {
          YourCommission: "Hoa hồng của bạn",
        },
      },
      MerchantUserAutocomplete: {
        Placeholder: "Nhập tên hoặc IČO",
        MinLength: "Nhập ít nhất 2 ký tự để tìm kiếm",
        NoResults: "Không tìm thấy merchant nào",
      },
      AddressAutocomplete: {
        MinLength: "Nhập ít nhất 3 ký tự để tìm kiếm",
        NoResults: "Không tìm thấy địa chỉ",
        Error:
          "Tìm kiếm địa chỉ không khả dụng, vui lòng nhập địa chỉ thủ công",
      },
      AddressInput: {
        SearchLabel: "Địa chỉ từ sổ đăng ký",
        EnterManually: "Nhập địa chỉ thủ công",
        SearchInRegistry: "Tìm địa chỉ trong sổ đăng ký",
        NotInRegistry:
          "Không tìm thấy địa chỉ này trong sổ đăng ký địa chỉ, vui lòng kiểm tra lại.",
        HasErrors: "Địa chỉ chưa đầy đủ hoặc không hợp lệ, vui lòng kiểm tra.",
        UncommittedQuery:
          "Chọn địa chỉ từ danh sách để áp dụng — chỉ nhập văn bản sẽ không thay đổi địa chỉ đã lưu.",
      },
    },
    Transactions: {
      Tabs: {
        Transfers: "Chuyển khoản",
        Cards: "Thẻ",
        AriaLabel: "Loại giao dịch",
      },
      Title: "Giao dịch",
      LoadMore: "Tải thêm",
      Export: "Xuất giao dịch",
      NoTransactions: "Chưa có giao dịch nào",
      PendingRefunds: "Giao dịch hoàn tiền đang chờ",
      MerchantDetailTransactionFees: {
        Title: "Phí giao dịch tháng này",
      },
      TransactionPaymentOptions: {
        DirectPaymentButton: "Thanh toán trực tiếp",
        ShowPaymentDataButton: "Hiển thị hướng dẫn thanh toán",
      },
      Filters: {
        Direction: "Hướng",
        AllDirections: "Tất cả hướng",
      },
      Summary: {
        Revenue: {
          day: "Doanh thu hàng ngày",
          week: "Doanh thu hàng tuần",
          month: "Doanh thu hàng tháng",
          custom: "Doanh thu theo kỳ",
        },
        UnlimitedRevenue: "Tổng doanh thu",
        FilteredRevenue: "Doanh thu theo bộ lọc",
        FilterSuffix: "theo bộ lọc",
      },
      Search: {
        Placeholder: "Tìm theo ID...",
      },
      ExportActions: {
        Download: "Tải xuống",
        Email: "Gửi qua email",
      },
      ExportDrawer: {
        ExportSelectionPdf: "Xuất lựa chọn (.pdf)",
        ExportSelectionXlsx: "Xuất lựa chọn (.xlsx)",
        ExportSelectionCsv: "Xuất lựa chọn (.csv)",
        ExportTodayRevenueCsv: "Xuất doanh thu hôm nay (.csv)",
        SendToEmail: "Gửi qua email (PDF + XLSX)",
        EmailAddress: "Địa chỉ email",
        EnterEmailAddress: "Nhập địa chỉ email",
        Send: "Gửi",
        Cancel: "Hủy",
        EmailSentSuccess: "Xuất đã được gửi đến email của bạn",
        EmailSentError: "Không thể gửi xuất qua email",
      },
      Direction: {
        Incoming: "Thanh toán đến",
        Outgoing: "Thanh toán đi",
        IncomingRefund: "Hoàn tiền đến",
        OutgoingRefund: "Hoàn tiền đi",
      },
    },
    CardTransactions: {
      Title: "Giao dịch thẻ",
      LoadMore: "Tải thêm",
      NoCardTransactions: "Chưa có giao dịch thẻ nào",
      Columns: {
        DateTime: "Ngày và giờ",
        Terminal: "Thiết bị đầu cuối",
        Operator: "Người thao tác",
        Amount: "Số tiền",
        Status: "Trạng thái",
        CardBrand: "Thẻ",
        Pan: "Số thẻ",
        Refund: "Hoàn tiền/hủy",
      },
      Status: {
        Approved: "Đã duyệt",
        Rejected: "Bị từ chối",
        Canceled: "Đã hủy",
        Pending: "Đang xử lý",
        Unknown: "Không xác định",
      },
      Direction: {
        Sale: "Thanh toán",
        Refund: "Hoàn tiền",
        Cancellation: "Hủy",
        Adjustment: "Điều chỉnh",
      },
      Summary: {
        NetAmount: "Doanh thu thuần",
        Sales: "Doanh thu",
        SalesCount: "Số lần thanh toán: {{count}}",
        Refunds: "Hoàn tiền",
        RefundsCount: "Số lần hoàn tiền: {{count}}",
      },
      Export: {
        Download: "Tải xuống",
        Email: "Gửi qua email",
        ExportPdf: "Xuất theo bộ lọc (.pdf)",
        ExportXlsx: "Xuất theo bộ lọc (.xlsx)",
        ExportCsv: "Xuất theo bộ lọc (.csv)",
        SendToEmail: "Gửi qua email (PDF + XLSX)",
        EmailAddress: "Địa chỉ email",
        EnterEmailAddress: "Nhập địa chỉ email",
        Send: "Gửi",
        Cancel: "Hủy",
        EmailSentSuccess: "Xuất đã được gửi đến email của bạn",
        EmailSentError: "Không thể gửi xuất qua email",
        DownloadError: "Không thể tải xuống tệp xuất",
      },
    },
    Sell: {
      OfferValid: "Ưu đãi còn hiệu lực trong {{seconds}} giây",
    },
    Affiliate: {
      LeadStatus: {
        AnonymousPaymentPerformed: "Thanh toán ẩn danh",
        Invited: "Đã mời",
        Registered: "Đã đăng ký",
        Completed: "Hoàn thành",
        CompletedRewardSent: "Hoàn thành",
        CompletedRewardApplied: "Hoàn thành",
        Withdrawn: "Đã rút",
      },
      ThanksToYou: {
        Participation: {
          Title: "Tham gia chương trình Cảm ơn bạn!",
          OptedInStatus:
            "Bạn đang tham gia Cảm ơn bạn! và nhận phần thưởng cho các lượt giới thiệu.",
          OptOutButton: "Rời khỏi chương trình",
          OptOutDialogTitle: "Rời khỏi Cảm ơn bạn!",
          OptOutDialogIrreversible:
            "Việc rời đi là vĩnh viễn. Bạn sẽ không thể tham gia lại chương trình.",
          OptOutDialogLoseTitle: "Bạn sẽ mất",
          OptOutDialogLoseReferrals:
            "Tất cả lượt giới thiệu đã có và phần thưởng từ chúng",
          OptOutDialogLoseInviter: "Liên kết với người đã mời bạn",
          OptOutDialogKeepTitle: "Bạn vẫn giữ",
          OptOutDialogKeepRewards: "Phần thưởng bạn đã nhận",
          OptOutDialogKeepAccount:
            "Tài khoản và mọi tính năng khác của {{appName}}",
          OptOutDialogEmailNote:
            "Chúng tôi sẽ gửi e-mail đến {{email}}; bạn hoàn tất việc rời đi bằng cách nhấp vào liên kết trong đó.",
          OptOutDialogConfirm: "Gửi e-mail xác nhận",
          EmailSent:
            "Chúng tôi đã gửi e-mail xác nhận tới {{email}}. Nhấp vào liên kết trong e-mail để hoàn tất; liên kết có hiệu lực đến {{expiresAt}}. Cho đến khi bạn nhấp vào, bạn vẫn ở trong chương trình.",
          ResendButton: "Gửi lại e-mail",
          EmailSentToast: "E-mail xác nhận đang được gửi.",
          EmailSendError:
            "Không thể gửi e-mail xác nhận. Vui lòng thử lại sau ít phút.",
          EmailCooldownError:
            "Chúng tôi vừa gửi e-mail xác nhận cho bạn. Hãy thử lại sau một phút.",
        },
        Join: {
          Title: "Bạn chưa tham gia Cảm ơn bạn!",
          Text: "Bạn đã từ chối chương trình khi đăng ký. Sau khi tham gia, bạn có thể mời bạn bè và nhận phần thưởng từ các khoản thanh toán của họ. Các lời mời và lượt giới thiệu trước đây sẽ không được khôi phục.",
          Button: "Tham gia chương trình",
          JoinedToast: "Bạn đã tham gia Cảm ơn bạn!",
        },
        Withdrawn: {
          Title: "Cảm ơn bạn!",
          Text: "Bạn đã rời khỏi Cảm ơn bạn! vĩnh viễn. Phần thưởng bạn đã nhận vẫn là của bạn. Không thể tham gia lại chương trình.",
          PayoutBalance: "Còn lại để thanh toán: {{amount}}",
        },
        WithdrawalPage: {
          Title: "Rời khỏi Cảm ơn bạn!",
          Prompt:
            "Nhấp để xác nhận rời khỏi Cảm ơn bạn! vĩnh viễn. Bạn sẽ mất tất cả lượt giới thiệu và liên kết với người đã mời bạn; phần thưởng bạn đã nhận vẫn là của bạn.",
          ConfirmButton: "Xác nhận rời khỏi",
          Success: {
            Title: "Đã rời khỏi chương trình",
            Text: "Bạn đã rời khỏi Cảm ơn bạn! vĩnh viễn. Phần thưởng bạn đã nhận vẫn là của bạn.",
          },
          AlreadyWithdrawn: {
            Title: "Bạn đã rời khỏi trước đó",
            Text: "Bạn đã rời khỏi Cảm ơn bạn! trước đó. Bạn không cần làm gì thêm.",
          },
          Expired: {
            Title: "Liên kết không còn hiệu lực",
            Text: "Liên kết đã hết hạn, hoặc chúng tôi đã gửi cho bạn một liên kết mới hơn. Nếu bạn vẫn muốn rời đi, hãy yêu cầu e-mail mới trong mục Cảm ơn bạn!.",
          },
          Error: {
            Title: "Không thể rời khỏi chương trình",
            Text: "Không thể hoàn tất việc rời khỏi chương trình. Hãy mở lại liên kết, hoặc yêu cầu e-mail mới trong mục Cảm ơn bạn!.",
          },
          ContinueButton: "Tiếp tục vào ứng dụng",
          OpenSectionButton: "Mở mục Cảm ơn bạn!",
        },
      },
      AffiliateStats: {
        Invited: "Đã mời",
        Registered: "Đã đăng ký",
        WithActiveLicense: "Có giấy phép hoạt động",
        AnonymousPayment: "Thanh toán đầu tiên với {{appName}}",
      },
      AffiliateLink: {
        Title: "Liên kết liên kết của bạn",
        LoadingError: "Lỗi - Không thể tải liên kết liên kết",
        CopyLink: "Sao chép liên kết",
        LinkCopied: "Đã sao chép!",
        ShareButton: {
          Title: "{{appName}}",
          Text: "Lời mời {{appName}}",
        },
      },
      AffiliateLinkWithActions: {
        InviteFriend: "Mời bạn bè",
        ShareButton: "Chia sẻ",
        EmailButton: "Gửi qua e-mail",
        QrButton: "Hiển thị QR",
        QrCodeFileName: "Mã QR liên kết",
        QrInstructions:
          "Hiển thị mã QR này cho bạn bè mà bạn muốn mời đến {{appName}}",
        LinkTypeToggle: {
          Title: "Chọn đích đến của liên kết",
          Registration: "Đăng ký trực tiếp",
          MooneInfo: "Qua trang web {{appName}}",
        },
      },
      CodeField: {
        SectionTitle: "Giới thiệu",
        Label: "Mã giới thiệu",
        Placeholder: "Điền nếu có người giới thiệu bạn",
        Verified: "Mã hợp lệ.",
        RecommendedBy: "Người giới thiệu: {{name}}",
        Locked: "Người giới thiệu đã được kích hoạt và không thể thay đổi.",
        LockedBy:
          "Người giới thiệu đã được kích hoạt và không thể thay đổi. Người giới thiệu: {{name}}",
        ApplyFailed:
          "Không thể lưu mã giới thiệu, quá trình đăng ký vẫn tiếp tục mà không có mã.",
        Error: {
          AffiliateCodeNotFound: "Mã này không tồn tại.",
          AffiliateCodeOwn: "Bạn không thể dùng mã của chính mình.",
          AffiliateCodeNotApplicable:
            "Không thể dùng mã này cho lần đăng ký này.",
          AffiliateReferrerAlreadySet: "Người giới thiệu đã được kích hoạt.",
          AffiliateReferrerTooLate: "Không thể thêm mã giới thiệu nữa.",
          TooManyRequests: "Quá nhiều lần thử, vui lòng thử lại sau giây lát.",
          Unavailable: "Không thể xác minh mã, vui lòng thử lại.",
          Unverified: "Vui lòng xác minh mã hoặc xóa mã.",
        },
      },
      LeadInvitation: {
        NewInvitation: "Lời mời mới",
        FriendInvited: "Cảm ơn bạn! Bạn bè của bạn đã được mời.",
        UserAlreadyExists: "Người dùng với email này đã tồn tại",
        InvitationAlreadySent: "Lời mời đã được gửi",
        GeneralError: "Đã xảy ra lỗi khi gửi lời mời",
        SendInvitation: {
          Hunter: "Gửi lời mời hunter",
          Customer: "Gửi lời mời",
          Merchant: "Gửi lời mời merchant",
        },
      },
      UserAffiliate: {
        MooneLiteWarning:
          "Để nhận phần thưởng từ chương trình Cảm ơn bạn, bạn phải hoàn thành đăng ký và đợi xác minh tài khoản trước.",
        Title: "Cảm ơn bạn!",
        Subtitle: "Thanh toán tạo nên thu nhập của bạn.",
        Description:
          "Chia sẻ mã liên kết của bạn, mời bạn bè và kiếm hoa hồng từ các giao dịch mua của họ. Càng nhiều người bạn mời, phần thưởng càng cao. Kiếm tiền từ thanh toán lâu dài như ngân hàng và công ty thẻ.",
        HowItWorksTitle: "Cách hoạt động:",
        HowItWorks:
          "• Xác minh tài khoản của bạn trong {{appName}}.<newline/>• Chia sẻ mã liên kết với bạn bè.<newline/>• Kiếm phần thưởng - mỗi khi người được giới thiệu thanh toán tại merchants, bạn kiếm được một phần từ chi tiêu của họ.",
        Rewards:
          "💡 Phần thưởng được ghi nhận tự động, bạn chỉ cần theo dõi thu nhập thụ động của mình tăng lên.",
        TermsLinkPretext:
          "📄 Thông tin thêm có thể được tìm thấy trong Điều khoản chương trình liên kết",
        YourAffiliateLink: "Liên kết liên kết của bạn",
        TermsLink: '"Cảm ơn bạn!"',
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        Tabs: {
          Customer: "Người dùng",
          Campaigns: "Chiến dịch",
        },
      },
      HunterAffiliate: {
        Title: "Trở thành huyền thoại & kiếm tiền lâu dài! 🚀",
        Description:
          "Mời bạn bè đến Legi.one và nhận 10% hoa hồng cho mỗi hunter mới! Nhưng đó chưa phải tất cả – nếu họ thành công, bạn sẽ nhận hoa hồng lâu dài từ một doanh nghiệp của họ và chia sẻ 50% doanh nghiệp thứ hai với bạn. Bạn cũng sẽ nhận được hoa hồng tăng từ một phần doanh nghiệp của mình.",
        InviteNow:
          "Chia sẻ mã liên kết của bạn ngay bây giờ và tích cực xây dựng thu nhập thụ động!",
        YourAffiliateLink: "Liên kết liên kết của bạn",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        TermsLinkPretext: "Cần thêm thông tin? Xem đầy đủ",
        TermsLink: "Điều khoản chương trình liên kết",
        Tabs: {
          Hunter: "Hunter",
          Customer: "Người dùng",
          Merchant: "Merchant",
          Campaigns: "Chiến dịch",
        },
        MerchantLicenseSelector: {
          Label: "Giấy phép mặc định cho thương nhân",
        },
        InviteExistingUser: {
          Title: "Mời người dùng đã có tài khoản Mo.one?",
          Description:
            "Nếu bạn muốn mời người đã có tài khoản Mo.one, hãy dùng quy trình đăng ký người bán mới. Khi bạn nhập email của họ, biểu mẫu sẽ phát hiện tài khoản hiện có và gửi lời mời thẳng vào hộp thư trong ứng dụng của họ — thay vì bắt họ đăng ký lại từ đầu.",
          ButtonLabel: "Mời người dùng hiện có làm người bán",
        },
      },
      MerchantAffiliate: {
        Title: "Mời merchants & kiếm phần thưởng! 🚀",
        Description:
          "Mời bạn bè đến {{appName}} và kiếm điểm cho hệ thống phần thưởng của chúng tôi, từ đó bạn sẽ liên tục nhận được lợi ích!",
        InviteNow:
          "Chia sẻ mã liên kết của bạn ngay bây giờ và tích cực xây dựng thu nhập thụ động!",
        TermsLinkPretext: "Cần thêm thông tin? Xem đầy đủ",
        YourAffiliateLink: "Liên kết liên kết của bạn",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        TermsLink: "Điều khoản chương trình liên kết",
        Tabs: {
          Customer: "Người dùng",
          Campaigns: "Chiến dịch",
        },
      },
      Earnings: {
        Title: "Thu nhập của bạn",
        TotalRegisteredUsers: "Người dùng đã đăng ký",
        TierBreakdown: "T1: {{t1}}, T2: {{t2}}, T3: {{t3}}",
        CurrentPayout: "Có sẵn để thanh toán",
        TotalEarned: "Tổng thu nhập",
        RegisteredUsersHint:
          "Tổng số người dùng đã đăng ký trên {{appName}} qua liên kết giới thiệu của bạn.<newline/><newline/><bold>Phân chia theo cấp:</bold><newline/>T1 (0,03%): {{t1}} người dùng<newline/>T2 (0,02%): {{t2}} người dùng<newline/>T3 (0,01%): {{t3}} người dùng",
        PayoutHint:
          "Số tiền hiện có sẵn để thanh toán từ phần thưởng giới thiệu của bạn.",
        TotalEarnedHint:
          "Tổng số tất cả phần thưởng giới thiệu kiếm được từ giao dịch của người dùng được mời.",
        CombinedPayoutHint:
          "Tổng phần thưởng thanh toán từ chương trình Stardust và chương trình giới thiệu Díky Tobě.",
        CombinedTotalEarnedHint:
          "Tổng thu nhập từ chương trình Stardust và chương trình giới thiệu Díky Tobě.",
        CombinedValorPayoutHint:
          "Tổng phần thưởng thanh toán từ chương trình Valor và chương trình giới thiệu Díky Tobě.",
        CombinedValorTotalEarnedHint:
          "Tổng thu nhập từ chương trình Valor và chương trình giới thiệu Díky Tobě.",
      },
      Campaigns: {
        SelectCampaign: "Chọn chiến dịch",
        SelectCampaignPlaceholder: "Chọn chiến dịch từ danh sách",
        SelectCampaignDescription:
          "Chọn một chiến dịch để xem chi tiết và liên kết liên kết.",
        Validity: "Hiệu lực:",
      },
      AnonymousPayer: "Thanh toán khách hàng ẩn danh",
    },
    Coinback: {
      Commission: "lên đến {{commission}}",
    },
    Settlements: {
      SettlementStatus: {
        Paid: "Đã thanh toán",
        Unpaid: "Đang chờ thanh toán",
        Overdue: "Quá hạn",
      },
      TotalEarnings: "Tổng thu nhập giao dịch",
      CardEarnings: "Hoa hồng giao dịch thẻ trong kỳ",
      TransactionCosts: "Chi phí giao dịch",
      SettlementCount: "Quyết toán {{count}} trên {{total}}",
      NoSettlementsFound: "Không tìm thấy quyết toán nào",
      LoadingError: "Đã xảy ra lỗi khi tải quyết toán",
      SettlementControls: {
        Filter: {
          Title: "Lọc",
          All: "Tất cả ({{total}})",
          Paid: "Đã thanh toán ({{paid}})",
          Unpaid: "Chưa thanh toán ({{unpaid}})",
          Overdue: "Quá hạn ({{overdue}})",
        },
        Sort: {
          Title: "Sắp xếp theo",
          DateDesc: "Ngày (mới nhất)",
          DateAsc: "Ngày (cũ nhất)",
          AmountDesc: "Số tiền (cao nhất)",
          AmountAsc: "Số tiền (thấp nhất)",
        },
      },
      SettlementList: {
        UpdateStatusSuccess: "Quyết toán đã được đánh dấu là đã thanh toán",
        UpdateStatusError: "Đã xảy ra lỗi khi cập nhật trạng thái",
        DownloadReportError: "Đã xảy ra lỗi khi tải báo cáo",
        DownloadReportFilePrefix: "bao_cao_quyet_toan_",
        SettlementPeriod: "Kỳ",
        SettlementDate: "Ngày quyết toán",
        DueDate: "Ngày đến hạn",
        Amount: "Số tiền",
        Status: "Trạng thái",
        Actions: "Hành động",
        DownloadReport: "Tải báo cáo",
        MarkAsPaid: "Đánh dấu đã thanh toán",
        Pay: "Thanh toán",
        SettlementStatusTooltip:
          "Chúng tôi kiểm tra trạng thái thanh toán mỗi 2 giờ từ 8:00 sáng đến 10:00 tối.",
        SettlementTypeHunterCommissionFunding: "Tài trợ hoa hồng hunter",
        SettlementTypeDefault: "Quyết toán",
        DownloadInvoice: "Tải hóa đơn",
        DownloadInvoiceError: "Lỗi khi tải hóa đơn",
        InvoiceFilePrefix: "hoa_don_",
        RegenerateInvoice: "Tạo lại hóa đơn",
        RegenerateInvoiceSuccess: "Hóa đơn đã được tạo lại",
        RegenerateInvoiceError: "Đã xảy ra lỗi khi tạo lại hóa đơn",
      },
      SettlementDownloadButton: {
        Title: "Quyết toán",
        Downloading: "Đang tải xuống...",
        Download: "Tải xuống",
        RegionPlaceholder: "Chọn thị trường",
        Regions: {
          CZ: "Séc (CZK)",
          SK: "Slovakia (EUR)",
        },
      },
    },
  },
  Coinback: {
    NoEshopsFound: "Không tìm thấy cửa hàng trực tuyến nào",
    Eshops: "Cửa hàng trực tuyến",
  },
  FormLabels: {
    AccountType: "Loại tài khoản để chuyển",
    TransferAccountType: "Loại tài khoản để chuyển",
    RecipientIBAN: "IBAN người nhận",
    Amount: "Số tiền",
  },
  AML: {
    BasicInfo: "Thông tin cơ bản",
    CompanyName: "Tên công ty",
    FirstName: "Tên",
    LastName: "Họ",
    CompanyNumber: "Số công ty",
    TaxNumber: "Mã số thuế",
    PersonalNumber: "Số định danh cá nhân",
    BirthDate: "Ngày sinh",
    BirthPlace: "Nơi sinh",
    Nationality: "Quốc tịch",
    Gender: "Giới tính",
    Phone: "Điện thoại",
    Email: "E-mail",
    Unknown: "Không xác định",
    Documents: "Tài liệu",
    DocumentNumber: "Số tài liệu",
    DocumentIssuer: "Cơ quan cấp",
    DocumentValidity: "Hiệu lực tài liệu",
    DocumentType: "Loại tài liệu",
    NoDocuments: "Không tìm thấy tài liệu đã tải lên cho người này.",
    IdentificationImageType: {
      FirstIDCardFrontSide: "Mặt trước CMND/CCCD",
      FirstIDCardBackSide: "Mặt sau CMND/CCCD",
      SecondIDCardFrontSide: "Mặt trước CMND/CCCD thứ hai",
      SecondIDCardBackSide: "Mặt sau CMND/CCCD thứ hai",
    },
    PdfUploaded: "Người dùng đã tải lên tệp PDF.",
    OpenPdf: "Mở PDF",
    ActingPerson: "Người đại diện",
    BeneficialOwners: "Người thụ hưởng",
    UboUnknownAlert: "Merchant đã đánh dấu người thụ hưởng là không xác định",
    Loading: "Đang tải...",
  },
  PersonalInfo: {
    ConfirmDataRequest: "Dữ liệu ở trên đã được đọc chính xác chưa?",
    FillMissingData:
      "Điền thông tin còn thiếu hoặc sửa thông tin không chính xác",
    DataConfirmationMessage:
      "Vui lòng cũng xác nhận tính chính xác của dữ liệu giấy tờ tùy thân.",
  },
  TableHeaders: {
    Verification: "Xác minh",
    Login: "Đăng nhập",
    Role: "Vai trò",
    Status: "Trạng thái",
    FirstName: "Tên",
    LastName: "Họ",
    Company: "Công ty",
    ClientIdentifier: "ID",
    DateCreated: "Ngày tạo",
    PaymentReference: "Tham chiếu thanh toán giấy phép",
    Version: "Phiên bản {{appName}}",
    Settlement: "Quyết toán",
    Admin: "Quản trị",
  },
  Nfc: {
    NfcCard: "Thẻ NFC",
    InvalidNfcCardNoFormat: "Định dạng mã định danh thẻ NFC không hợp lệ!",
    NfcCardNo: "Mã định danh thẻ NFC:",
    CopyNfcCardNo: "Sao chép mã định danh thẻ",
    CopyNfcCardNoSuccess: "Đã sao chép mã định danh thẻ",
    CardNotAssigned: "Thẻ NFC này hiện chưa được gán cho bất kỳ thứ gì.",
    AssignToPaypoint: "Gán cho điểm thanh toán",
    SelectPaypoint: "Chọn điểm thanh toán để gán thẻ",
    CardOverwriteConfirmation:
      "Điểm thanh toán {{name}} đã có thẻ NFC khác được gán. Bạn có muốn ghi đè bằng thẻ này không?",
    CardAssignedSuccessfully: "Thẻ NFC đã được gán thành công",
    CardAssignmentFailed: "Lỗi - Không thể gán thẻ NFC",
    CardAssignmentFailedFormatError: "Lỗi - Mã định danh thẻ NFC sai định dạng",
    Redirecting: "Đang tự động chuyển hướng.",
    RedirectFallbackHint:
      "Nếu sau 10 giây bạn vẫn chưa được chuyển hướng, hãy nhấn nút bên dưới.",
    RedirectManually: "Chuyển hướng thủ công",
    RedirectNotConfigured:
      "Thẻ NFC này chưa có địa chỉ. Vui lòng liên hệ nhân viên.",
    SelectMerchant: "Chọn merchant để gán thẻ",
  },
  ExternalIntegrations: {
    Title: "Tích hợp bên ngoài",
    Description:
      "Chấp nhận thanh toán qua {{appName}} trong cửa hàng trực tuyến của bạn. Tải plugin cho nền tảng của bạn và làm theo tài liệu hướng dẫn đính kèm.",
    DownloadPlugin: "Tải ZIP",
    DownloadDocumentation: "Tải tài liệu hướng dẫn (PDF)",
    WooCommerce: {
      Name: "WooCommerce",
      Description: "Plugin thanh toán cho WordPress / WooCommerce.",
      PluginUrl: "/content/integrations/moone-payments-for-woocommerce.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-WooCommerce-VI.pdf",
    },
    PrestaShop: {
      Name: "PrestaShop",
      Description: "Mô-đun thanh toán cho PrestaShop.",
      PluginUrl: "/content/integrations/moonepayments-for-prestashop.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-PrestaShop-VI.pdf",
    },
    PaymentGateway: {
      Name: "Cổng thanh toán",
      Description:
        "Hướng dẫn cho người bán về cổng thanh toán: thiết lập, thông tin truy cập và hoàn tiền.",
      DocumentationUrl: "/content/integrations/Mo.one-Payment-Gateway-CS.pdf",
    },
  },
  Paypoint: {
    Paypoint: "Điểm thanh toán",
    NoPaypoint: "Không có điểm thanh toán",
    NoPaypointPlaceholder: "Không có điểm thanh toán",
    UnnamedPaypoint: "Điểm thanh toán chưa đặt tên",
    AddPaypointButton: "Thêm điểm thanh toán mới",
    DownloadQRCode: "Tải QR",
    Individual: "Cá nhân",
    SeeOptions: "Xem tùy chọn",
    IndividualUnderConstruction:
      "Điểm thanh toán cá nhân vẫn đang được xây dựng, sắp ra mắt...",
    NewPaypoint: "PayPoint mới",
    UpdatePaypoint: "Cập nhật PayPoint",
    IdlePaypointInfo: "Không có giao dịch hoạt động tại điểm thanh toán này.",
    BackToDashboard: "Quay lại bảng điều khiển",
    LoadingError: "Lỗi khi tải điểm thanh toán.",
    UnknownOwner: "Chủ sở hữu không xác định",
    Form: {
      Name: "Tên",
      Description: "Mô tả",
      Legend: {
        GeneralInfo: "Thông tin chung",
        NFC: "Thẻ NFC",
        PaypointSettings: "Cài đặt điểm thanh toán",
        Device: "Thiết bị thanh toán",
        PaypointType: "Cài đặt PayPoint",
      },
      PaymentTypeLabel: "Phương thức thanh toán",
      PaymentType: {
        Standard: {
          label: "Thanh toán tiêu chuẩn",
          tooltip: "Bạn tạo thanh toán mỗi lần tại quầy thu ngân.",
        },
        FixedPrice: {
          label: "Thanh toán giá cố định",
          tooltip:
            "Số tiền thanh toán được đặt trước và khách hàng không thể thay đổi.",
        },
        EditablePrice: {
          label: "Thanh toán giá có thể chỉnh sửa",
          tooltip:
            "Khách hàng có thể chọn từ các mức giá có sẵn hoặc nhập số tiền tùy chỉnh.",
        },
        NfcLink: {
          label: "Liên kết NFC",
          tooltip:
            "Khi chạm điện thoại vào thẻ NFC, địa chỉ bạn nhập sẽ được mở thay cho thanh toán.",
        },
        NfcTableService: {
          label: "Phục vụ tại bàn NFC",
          tooltip:
            "Khi chạm điện thoại, trang của bàn sẽ được mở. Địa chỉ do Mo.one Hub thiết lập và không thể chỉnh sửa tại đây.",
        },
      },
      FixedAmountLabel: "Số tiền cố định",
      CurrencyLabel: "Tiền tệ",
      FixedAmountRequired: "Nhập số tiền cố định lớn hơn không",
      CurrencyRequired: "Chọn loại tiền tệ của điểm thanh toán",
      TipsLabel: "Tiền boa",
      TipsCheckbox: "Cung cấp tùy chọn tiền boa cho khách hàng",
      GatewaySettingsHint:
        "Đối với cổng thanh toán thương mại điện tử, số tiền và tiền boa do cửa hàng trực tuyến kiểm soát cho mỗi giao dịch, vì vậy các cài đặt này không khả dụng.",
      RedirectUrlLabel: "Địa chỉ (URL)",
      RedirectUrlInvalid: "Nhập địa chỉ hợp lệ bắt đầu bằng https://",
      TableServiceUrlMissing:
        "Mo.one Hub chưa thiết lập địa chỉ bàn. Cho đến khi được thiết lập, chạm điện thoại sẽ không chuyển hướng.",
      NfcCardNo: "Mã định danh thẻ NFC",
      NfcCardNoHelperText:
        "Mã định danh thẻ NFC là mã chữ số 14 ký tự được in trên thẻ NFC {{appName}}. Nếu bạn chưa có thẻ, bạn có thể sử dụng điểm thanh toán ảo qua mã QR và ghép nối với thẻ NFC sau.",
      Create: "Tạo",
      AssignNfcCardNoConflict: "Thẻ NFC đã được gán cho điểm thanh toán khác",
      NfcCardNoFormatError:
        "Mã định danh thẻ NFC phải có định dạng XX-XX-XX-XX-XX-XX-XX",
      NameMaxLengthError: "Tên không được vượt quá {{max}} ký tự",
      BankAccountNotAccessible:
        "Thiết lập tài khoản ngân hàng không khả dụng cho bạn.",
      EmployeesNotAccessible:
        "Thiết lập quyền truy cập nhân viên không khả dụng cho bạn.",
      Employees: "Nhân viên có quyền truy cập",
      PaypointAccount: "Tài khoản ngân hàng",
      Facility: "Cơ sở",
      Type: "Loại",
      TypeNFC: "NFC",
      TypeTerminal: "Terminal",
      TypeGateway: "Cổng thanh toán",
      TypeGatewayShort: "Cổng",
      Device: {
        NoActiveDevice: "Chưa có thiết bị nào được kết nối",
        LinkDevice: "Kết nối thiết bị",
        LinkDeviceTitle: "Kết nối thiết bị mới",
        ActiveDevice: "Thiết bị đã kết nối",
      },
      Activation: {
        Legend: "Kích hoạt SoftPOS",
        Code: "Mã kích hoạt",
        HelperText:
          "Nhập mã trong ứng dụng SoftPOS trên thiết bị. Mã chỉ dùng cho một thiết bị; khi chuyển sang thiết bị khác hãy hủy kích hoạt ứng dụng trên thiết bị cũ hoặc yêu cầu hỗ trợ giải phóng mã.",
        Copy: "Sao chép mã",
        Copied: "Đã sao chép",
      },
    },
  },
  Roles: {
    AddRole: {
      Banner: {
        Hunter:
          "Bạn có lời mời trở thành thợ săn — hãy hoàn tất đăng ký vai trò.",
        Merchant:
          "Bạn có lời mời trở thành doanh nghiệp — hãy hoàn tất đăng ký vai trò.",
        SignUpIntent: {
          Hunter:
            "Hãy hoàn tất đăng ký thợ săn mà bạn đã chọn khi tạo tài khoản.",
          Merchant:
            "Hãy hoàn tất đăng ký doanh nghiệp mà bạn đã chọn khi tạo tài khoản.",
        },
        Button: "Hoàn tất",
      },
      Completion: {
        Submit: "Hoàn tất đăng ký vai trò",
        Success: "Vai trò đã được kích hoạt.",
        Error: "Không thể hoàn tất vai trò.",
      },
      PickerTitle: "Chọn vai trò bạn muốn thêm vào tài khoản của mình.",
      MigrationRequired:
        "Việc thêm vai trò chỉ khả dụng sau khi hoàn tất di chuyển tài khoản.",
      KycRequired:
        "Vui lòng hoàn tất đăng ký tài khoản khách hàng của bạn trước (xác minh danh tính). Vai trò Hunter hoặc Merchant chỉ có thể được thêm sau đó.",
      BankVerificationRequired:
        "Vui lòng kết nối và xác minh tài khoản ngân hàng của bạn trước. Vai trò Hunter hoặc Merchant chỉ có thể được thêm sau đó.",
      BackOfficeAccount:
        "Tài khoản nội bộ (Admin, AML, onboarding) luôn chỉ có một vai trò — không thể thêm vai trò khác. Để sử dụng Mo.one cho mục đích cá nhân, hãy tạo một tài khoản riêng với địa chỉ e-mail khác.",
      HunterCard: {
        Title: "Thợ săn",
        Description: "Đăng ký các doanh nghiệp và nhận hoa hồng.",
        AlreadyHeld: "Bạn đã có vai trò thợ săn.",
      },
      MerchantCard: {
        Title: "Doanh nghiệp",
        Description: "Nhận thanh toán từ khách hàng tại doanh nghiệp của bạn.",
      },
      HunterForm: {
        Description:
          "Nhập mã số doanh nghiệp (IČO) của công ty mà bạn sẽ hoạt động với vai trò thợ săn.",
      },
      MerchantForm: {
        Description:
          "Chọn thị trường và nhập mã số doanh nghiệp của công ty sẽ nhận thanh toán.",
      },
      BankStep: {
        Connected: "Ngân hàng đã được kết nối — bạn có thể tiếp tục.",
      },
      Form: {
        CompanyNumber: "Mã số doanh nghiệp (IČO)",
        Region: "Thị trường",
        Submit: "Thêm vai trò",
        Success: "Đã thêm vai trò, đang chuyển ngữ cảnh…",
        Error: "Không thể thêm vai trò.",
      },
    },
  },
  Social: {
    Handle: {
      Label: "Biệt danh",
      Placeholder: "ví dụ: jan.novak",
      ValidationError:
        "Biệt danh phải có 3–30 ký tự: chữ thường a–z, chữ số, dấu chấm hoặc dấu gạch dưới, và ít nhất một chữ cái.",
      Reserved: "Không thể sử dụng biệt danh này",
      Available: "Biệt danh này còn trống",
      Taken: "Biệt danh này đã có người sử dụng",
      SaveError: "Không thể lưu biệt danh. Vui lòng thử lại.",
      StepTitle: "Chọn biệt danh công khai của bạn",
      StepDescription:
        "Biệt danh (@handle) là tên công khai của bạn trong {{appName}}. Người khác có thể tìm thấy bạn qua biệt danh này.",
      StepBenefitSearch:
        "Bạn bè có thể dễ dàng tìm thấy bạn qua <strong>{{handle}}</strong> khi tìm kiếm và hồ sơ của bạn sẽ có tại <strong>app.mo.one/@{{bareHandle}}</strong>",
      StepBenefitSearchHandleFallback: "@biệt danh",
      StepBenefitSearchUrlFallback: "biệt danh",
      StepBenefitFollows:
        "Người khác có thể theo dõi bạn và gửi yêu cầu theo dõi",
      StepBenefitChat: "Bạn có thể nhắn tin với bạn bè và người bán",
      StepBenefitLeaderboard:
        "Biệt danh sẽ hiển thị thay cho tên của bạn trong bảng xếp hạng Stardust và Valor",
      StepMissingWarning:
        "Nếu không có biệt danh, người khác không thể tìm thấy bạn và các tính năng cộng đồng sẽ không khả dụng. Bạn cũng có thể bổ sung bất cứ lúc nào trong hồ sơ.",
      ContinueWithoutHandle: "Tôi sẽ bổ sung sau",
      ChangeNote:
        "Khi thay đổi biệt danh, biệt danh cũ sẽ được giải phóng và địa chỉ hồ sơ công khai của bạn cũng thay đổi.",
      MissingBannerText:
        "Bạn chưa thiết lập biệt danh (@handle) — người khác chưa thể tìm thấy bạn.",
      MissingBannerAction: "Thiết lập",
    },
    Terms: {
      CheckboxLabel:
        "Tôi chấp nhận <terms>điều khoản và điều kiện</terms>, <chatTerms>điều khoản Trò chuyện</chatTerms> và <communityRules>quy tắc cộng đồng</communityRules>",
      Note: "Trò chuyện miễn phí và do Mo.one Digital Services s.r.o. cung cấp. Bạn có thể chấm dứt bất cứ lúc nào trong Ứng dụng, và với tư cách người tiêu dùng cũng có thể rút lại trong vòng 14 ngày qua e-mail. Cách chúng tôi xử lý dữ liệu của bạn được mô tả trong <privacy>Chính sách bảo vệ dữ liệu cá nhân</privacy>. Hãy tải về và lưu lại <summary>bản tóm tắt hợp đồng</summary> cùng các tài liệu, bạn có thể cần đến sau này.",
      ShowSummary: "Tóm tắt và tài liệu",
      HideSummary: "Ẩn tóm tắt",
      AcceptAndContinue: "Chấp nhận và tiếp tục",
      Required:
        "Bạn phải chấp nhận điều khoản và điều kiện, điều khoản Trò chuyện và quy tắc cộng đồng",
      Documents: {
        ContractSummary: {
          Title: "Tóm tắt hợp đồng",
          Url: {
            Customer: "/content/terms/Moone-chat-contract-summary-customer.pdf",
            Merchant: "/content/terms/Moone-chat-contract-summary-business.pdf",
            Hunter: "/content/terms/Moone-chat-contract-summary-business.pdf",
          },
        },
        Terms: {
          Title: "Điều khoản và điều kiện chung",
          Url: {
            Customer: "/content/terms/Moone-chat-business-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-business-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-business-terms-business.pdf",
          },
        },
        ChatTerms: {
          Title: "Điều khoản sản phẩm Trò chuyện",
          Url: {
            Customer: "/content/terms/Moone-chat-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-terms-business.pdf",
          },
        },
        CommunityRules: {
          Title: "Quy tắc cộng đồng",
          Url: {
            Customer: "/content/terms/Moone-chat-community-rules.pdf",
            Merchant: "/content/terms/Moone-chat-community-rules.pdf",
            Hunter: "/content/terms/Moone-chat-community-rules.pdf",
          },
        },
        ComplaintRules: {
          Title: "Quy trình khiếu nại",
          Url: {
            Customer: "/content/terms/Moone-chat-complaint-rules-customer.pdf",
            Merchant: "/content/terms/Moone-chat-complaint-rules-business.pdf",
            Hunter: "/content/terms/Moone-chat-complaint-rules-business.pdf",
          },
        },
        TechnicalTerms: {
          Title: "Điều khoản kỹ thuật",
          Url: {
            Customer: "/content/terms/Moone-chat-technical-terms.pdf",
            Merchant: "/content/terms/Moone-chat-technical-terms.pdf",
            Hunter: "/content/terms/Moone-chat-technical-terms.pdf",
          },
        },
        PrivacyPolicy: {
          Title: "Chính sách bảo vệ dữ liệu cá nhân",
          Url: {
            Customer: "/content/terms/Moone-chat-privacy-policy.pdf",
            Merchant: "/content/terms/Moone-chat-privacy-policy.pdf",
            Hunter: "/content/terms/Moone-chat-privacy-policy.pdf",
          },
        },
        ListLabel: "Tài liệu",
      },
      Terminate: {
        Title: "Chấm dứt Trò chuyện và tính năng cộng đồng",
        Description:
          "Chấm dứt hợp đồng Trò chuyện sẽ xóa biệt danh của bạn và mọi tính năng cộng đồng — trò chuyện, hồ sơ công khai, tìm kiếm và theo dõi. Tin nhắn và lượt theo dõi của bạn vẫn được giữ lại và sẽ hiển thị trở lại nếu sau này bạn chọn biệt danh mới.",
        Action: "Chấm dứt Trò chuyện và tính năng cộng đồng",
        ConfirmTitle:
          "Bạn thực sự muốn chấm dứt Trò chuyện và tính năng cộng đồng?",
        ConfirmText:
          "Biệt danh của bạn sẽ được giải phóng và trò chuyện, hồ sơ công khai, tìm kiếm cũng như theo dõi sẽ không còn khả dụng với bạn. Việc chấm dứt có hiệu lực ngay lập tức. Bạn có thể kích hoạt lại Trò chuyện bất cứ lúc nào bằng cách chọn biệt danh mới và chấp nhận điều khoản.",
        Success: "Trò chuyện và tính năng cộng đồng đã được chấm dứt.",
      },
      Summary: {
        Service: {
          Label: "Dịch vụ",
          Value: "Nhắn tin, nhóm và chia sẻ trong ứng dụng {{appName}}",
        },
        Provider: {
          Label: "Nhà cung cấp",
          Value:
            "Mo.one Digital Services s.r.o., IČO 245 32 819, Palackého třída 3048/124, 612 00 Brno, info@mo.one, +420 226 633 296",
        },
        Price: { Label: "Giá", Value: "Miễn phí" },
        Duration: { Label: "Thời hạn", Value: "Vô thời hạn" },
        Termination: {
          Label: "Chấm dứt",
          Value:
            "Bất cứ lúc nào và không cần nêu lý do trong Ứng dụng: {{appName}} của tôi › Cài đặt › Chấm dứt Trò chuyện và tính năng cộng đồng. Có hiệu lực ngay khi bạn xác nhận.",
        },
        Withdrawal: {
          Label: "Rút lại",
          Value:
            "Với tư cách người tiêu dùng trong vòng 14 ngày không cần nêu lý do, chỉ cần gửi e-mail đến info@mo.one",
        },
        Payments: {
          Label: "Thanh toán",
          Value: "Do Mo.one a.s. cung cấp theo hợp đồng của bạn với công ty đó",
        },
        Complaints: {
          Label: "Khiếu nại",
          Value:
            "Theo quy trình khiếu nại; giải quyết ngoài tòa án tại Cơ quan Thanh tra Thương mại Séc",
        },
        Devices: {
          Label: "Thiết bị",
          Value: "iOS 15 trở lên, Android 7 trở lên",
        },
        Important: {
          Label: "Quan trọng",
          Value:
            "Trò chuyện không dùng cho các cuộc gọi khẩn cấp. Hợp đồng được giao kết bằng tiếng Séc; bạn có thể sửa biệt danh trước khi xác nhận.",
        },
      },
    },
    PublicProfile: {
      PrivateAccount: "Tài khoản riêng tư",
      NotFound: "Biệt danh này không tồn tại.",
      Follow: "Theo dõi",
      Following: "Đang theo dõi",
      FollowBack: "Theo dõi lại",
      Requested: "Đã gửi yêu cầu",
      Mutual: "Theo dõi nhau",
      ApproveRequest: "Chấp nhận yêu cầu",
      DeleteRequest: "Xóa yêu cầu",
      MutualConfirmTitle: "Theo dõi lẫn nhau với @{{handle}}?",
      MutualConfirmInbox:
        "Tin nhắn của hai bạn sẽ đến thẳng hộp thư của nhau, mọi yêu cầu nhắn tin giữa hai bạn sẽ được chấp nhận và hai bạn có thể thêm nhau vào nhóm trực tiếp.",
      MutualConfirmName: "@{{handle}} cũng sẽ thấy tên thật của bạn.",
      SendMessage: "Gửi tin nhắn",
      SendMessageError: "Không thể mở cuộc trò chuyện. Vui lòng thử lại.",
      SendMessagePhoneRequired:
        "Xác minh số điện thoại của bạn để bắt đầu gửi tin nhắn.",
      MoreActions: "Hành động khác",
      Block: "Chặn",
      BlockConfirmTitle: "Chặn người dùng",
      BlockConfirmDescription:
        "Việc chặn sẽ hủy mọi lượt theo dõi và yêu cầu theo dõi giữa hai bạn, và hai bạn sẽ không thể tìm thấy hoặc kết nối với nhau nữa. Bạn có thể bỏ chặn bất cứ lúc nào trên trang Mọi người.",
      Report: "Báo cáo",
    },
    People: {
      SearchPlaceholder: "Tìm kiếm",
      SearchAllUsersPlaceholder:
        "Tìm trong tất cả người dùng theo @biệt danh hoặc tên",
      SearchNoResults: "Không tìm thấy ai.",
      RequestsTitle: "Yêu cầu theo dõi",
      OutgoingTitle: "Lời mời đã gửi",
      Approve: "Chấp nhận",
      Delete: "Xóa",
      CancelRequest: "Hủy",
      MutualTitle: "Theo dõi lẫn nhau",
      NoMutuals:
        "Chưa có ai theo dõi lẫn nhau — những người bạn theo dõi và theo dõi lại bạn sẽ xuất hiện ở đây.",
      FollowingTitle: "Đang theo dõi",
      NoFollowing: "Bạn chưa theo dõi ai.",
      FollowersTitle: "Người theo dõi",
      Tabs: {
        Mutual: "Lẫn nhau",
        Following: "Đang theo dõi",
        Followers: "Người theo dõi",
      },
      NoFollowers: "Chưa có ai theo dõi bạn.",
      Unfollow: "Xóa",
      BlockedTitle: "Người dùng bị chặn",
      NoBlocked: "Bạn chưa chặn ai.",
      Unblock: "Bỏ chặn",
      HandleGateTitle: "Hãy đặt biệt danh trước",
      HandleGateText:
        "Để theo dõi người khác, bạn cần một biệt danh (@handle) — người khác dùng nó để tìm bạn.",
      HandleGateAction: "Đặt biệt danh",
    },
    PublicPermissions: {
      IdentityLabel: "Danh tính",
      IdentityVerifiedTooltip: "Danh tính đã được xác minh",
      IdentityVerificationPendingTooltip: "Đang xác minh danh tính",
      PublicProfileLabel: "Hồ sơ công khai",
      PhoneVerifiedTooltip: "Số điện thoại đã được xác minh",
      PhoneVerificationPendingTooltip: "Đang xác minh số điện thoại",
      PhoneUnverifiedTooltip: "Số điện thoại chưa được xác minh",
      VerifyAction: "Xác minh",
      BioLabel: "Tiểu sử",
      BioTooLong: "Tiểu sử tối đa 160 ký tự",
      BioSaveError: "Không thể lưu tiểu sử. Vui lòng thử lại.",
      SectionDescription:
        "Với hồ sơ công khai, người khác có thể thấy tên thật của bạn và sẽ có thể tìm thấy bạn qua tên đó.",
      GoPublicConfirmTitle: "Công khai hồ sơ của bạn?",
      GoPublicConfirmRequests:
        "Tất cả {{count}} yêu cầu theo dõi đang chờ sẽ được chấp nhận.",
      GoPublicConfirmMutual:
        "Bạn đã theo dõi {{count}} người trong số họ, nên hai bên sẽ theo dõi lẫn nhau: tin nhắn của họ sẽ đến thẳng hộp thư của bạn và họ có thể thêm bạn vào nhóm trực tiếp.",
      GoPublicConfirmAction: "Công khai",
      GoPublicSummaryUnavailable:
        "Không thể tải các yêu cầu theo dõi đang chờ nên hồ sơ chưa thể công khai.",
    },
    Stats: {
      Mutual: "Lẫn nhau",
      Followers: "Người theo dõi",
      Following: "Đang theo dõi",
    },
  },
  Pages: {
    Titles: {
      AddRole: "Thêm vai trò",
      Valor: "Valor",
      Notifications: "Thông báo",
      Invitations: "Lời mời",
      ThanksToYou: "Cảm ơn bạn!",
      IncomingTransaction: "Thanh toán đến",
      OutgoingTransaction: "Thanh toán đi",
      UnknownTransaction: "Thanh toán",
      Licenses: "Giấy phép",
      NewPayment: "Thanh toán mới",
      MerchantOverview: "Merchant",
      Employees: "Nhân viên",
      LanguageSettings: "Cài đặt ngôn ngữ",
      PayPoints: "Điểm thanh toán",
      BankAccountDetail: "Tài khoản ngân hàng",
      SetPassword: "Đặt mật khẩu",
      AmlUsers: "Người dùng AML",
      NotificationsManagement: "Quản lý thông báo",
      NewNotification: "Thông báo mới",
      EditNotification: "Chỉnh sửa thông báo",
      Settings: "Thêm",
      Stardust: "Stardust",
      People: "Mọi người",
      Followers: "Người theo dõi",
      BlockedUsers: "Người dùng bị chặn",
      Profile: "Hồ sơ",
      Dashboard: "Tổng quan",
      BankAccounts: "Tài khoản ngân hàng",
      BankAccountOrder: "Thứ tự tài khoản",
      FeeCalculator: "Máy tính phí",
      Merchants: "Thương gia",
      Settlement: "Quyết toán",
      Users: "Người dùng",
      ToBeVerified: "Cần xác minh",
      TransactionDetail: "Chi tiết giao dịch",
      Welcome: "Chào mừng",
      User: "Người dùng",
      Withdrawal: "Rút tiền",
      Settlements: "Quyết toán",
      MerchantOpenRegistrations: "Đăng ký đang mở",
      LicenseOrder: "Đặt giấy phép",
      Onboarding: "Thông tin về bạn",
      CompleteSSORegistration: "Hoàn thành đăng ký",
      CompleteCustomerOnboarding: "Hoàn thành đăng ký",
      LeadInvitation: "Mời bạn bè",
      MerchantInitiatePayment: "Chọn tài khoản",
      MerchantAcceptPayment: "Nhận thanh toán",
      MerchantCompleteRegistration: "Đăng ký",
      MerchantNewRegistration: "Thương gia mới",
      LegalDocuments: "Tài liệu",
      Redeem: "Thẻ quà tặng",
      AnonymousDashboard: "Tổng quan",
      BankingAuthQr: "Xác minh tài khoản ngân hàng",
      SystemReport: "Báo cáo hệ thống",
      SystemControl: "Cài đặt hệ thống",
      BankingAuth: "Xác minh tài khoản ngân hàng",
      UserAccount: "{{appName}} của tôi",
      Help: "Trợ giúp",
      ColdWallet: "Ví hệ thống",
      MerchantSettlements: "Quyết toán",
      AnonymousTransactionDetail: "Giao dịch thành công",
      MerchantFeeCalculator: "Máy tính phí",
      RedeemPublic: "Thẻ quà tặng",
      ApplicationError: "Lỗi ứng dụng",
      GoogleCallback: "Đang chuyển hướng",
      AwaitingEmailVerification: "Xác minh e-mail",
      BankIDRedirect: "Đang chuyển hướng",
      Error403: "Truy cập bị từ chối",
      DeactivateUser: "Xóa tài khoản",
      CustomerAnonymousPaymentPay: "Đăng nhập",
      TransactionsHistory: "Giao dịch",
      Contact: "Liên hệ",
      WhereToPay: "Nơi để thanh toán",
      Campaigns: "Chiến dịch",
      Coupons: "Mã giảm giá",
      Terminals: "Thiết bị đầu cuối",
      Raffle: "Quay số trúng thưởng",
      SsoClients: "Ứng dụng SSO",
      SsoAuthorize: "Đăng nhập vào ứng dụng",
      ConnectedApps: "Ứng dụng đã kết nối",
      AdminCampaignCreate: "Tạo chiến dịch",
      AdminCampaignEdit: "Chỉnh sửa chiến dịch",
      Chat: "Chat",
      Devices: "Thiết bị thanh toán",
      PaymentGateways: "Cổng thanh toán",
      RolesPermissions: "Vai trò & Quyền hạn",
      AllMerchants: "Tất cả merchants",
      UnassignedMerchants: "Merchants không có hunter",
      Hunters: "Hunters",
      HunterPortal: "Cổng Hunter",
      Transfer: "Chuyển tiền",
      BatchPayments: "Thanh toán hàng loạt",
      BatchPaymentDetail: "Chi tiết thanh toán hàng loạt",
    },
    Content: {
      WhereToPay: {
        Tabs: {
          Stores: "Cửa hàng",
          EShops: "Cửa hàng trực tuyến",
          Campaigns: "Chiến dịch",
        },
        StoresSection: {
          CategoryLabel: "Danh mục",
          CategoryPlaceholder: "Danh mục",
          CategoryAccessibility: "Lọc theo danh mục",
          MunicipalityLabel: "Thành phố",
          MunicipalityPlaceholder: "Thành phố",
          MunicipalityAccessibility: "Lọc theo thành phố",
          NoStoresFound:
            "Không tìm thấy cửa hàng nào phù hợp với bộ lọc đã chọn.",
        },
        Campaigns: {
          Title: "CHIẾN DỊCH MO.ONE",
          ShareLinkText: "Chia sẻ liên kết với người khác và giúp đỡ",
          CopyLink: "Sao chép liên kết",
          LinkCopied: "Đã sao chép liên kết",
          Description:
            "Hãy thử thanh toán với Mo.one và giúp đỡ một mục đích tốt đẹp. Chọn một trong các quỹ đối tác và quyên góp bất kỳ số tiền nào thông qua Mo.one cho những người cần giúp đỡ.",
        },
        StoreDetail: {
          NotFound: "Không tìm thấy cửa hàng",
          AboutUs: {
            Title: "VỀ CHÚNG TÔI",
            Address: "Địa chỉ",
            Phone: "Điện thoại",
            Email: "E-mail",
          },
          OpeningHours: {
            Title: "GIỜ MỞ CỬA",
          },
        },
      },
      Stardust: {
        PointsLabel: {
          Points: "{{count}} Stardust",
          Points_other: "{{count}} Stardust",
        },
        Participation: {
          Title: "Tham gia chương trình Stardust",
          OptedInStatus: "Bạn đang tham gia Stardust và tích điểm.",
          OptOutButton: "Rời khỏi chương trình",
          OptOutDialogTitle: "Rời khỏi Stardust?",
          OptOutDialogText:
            "Sau khi rời đi, bạn sẽ không nhận được điểm Stardust mới, kể cả cho thanh toán hay giới thiệu bạn bè. Điểm và phần thưởng đã nhận vẫn là của bạn. Bạn có thể tham gia lại bất cứ lúc nào.",
          OptOutDialogConfirm: "Rời khỏi",
          OptedOutToast:
            "Bạn đã rời khỏi chương trình Stardust. Điểm và phần thưởng đã nhận vẫn là của bạn.",
        },
        Consent: {
          Title: "Chương trình khách hàng thân thiết Stardust",
          Description:
            "Bạn tích điểm Stardust cho các thanh toán và hoạt động trong ứng dụng và nhận một phần từ quỹ thưởng hàng tháng. Việc tham gia là tự nguyện và bạn có thể thay đổi bất cứ lúc nào trong mục Stardust.",
          TermsLink: "Điều khoản chương trình Stardust",
          Confirm: "Tôi đồng ý tham gia chương trình",
        },
        PilotDisclaimer:
          "Chương trình khách hàng thân thiết Stardust đang ở chế độ thử nghiệm từ ngày 1 tháng 12 năm 2025. Chúng tôi rất vui nếu bạn thử Stardust và cho chúng tôi phản hồi bằng nút Báo cáo lỗi hoặc gửi email đến info@mo.one.",
        Overview: {
          Points: {
            title: "Stardust",
            explanationHint:
              "Stardust là đơn vị phần thưởng trong {{appName}} mà bạn sẽ nhận được một phần của gói phần thưởng vào cuối mỗi tháng. Gói phần thưởng được tạo thành từ phần trăm nhỏ của tất cả các khoản thanh toán được thực hiện.<newline/><newline/> Mục tiêu của chúng tôi là hoàn lại một phần tiền cho cộng đồng thông qua Stardust và do đó mang đến cơ hội kiếm tiền bằng cách thanh toán qua {{appName}} tương tự như cách ngân hàng và tổ chức thẻ kiếm tiền. <newline/><newline/><bold>Vào cuối mỗi tháng, tất cả Stardust được sử dụng để kiếm một phần của gói phần thưởng. Vào đầu tháng mới, tất cả người dùng bắt đầu với 0 Stardust.</bold>",
          },
          Payout: {
            title: "Thanh toán",
            explanationHint:
              'Vào cuối mỗi tháng, kỳ chương trình khách hàng thân thiết Stardust kết thúc và tiền kiếm được sẽ được ghi vào "Thanh toán" của bạn.<newline/><newline/> Khi bạn đạt 50 CZK trong thanh toán, bạn có thể yêu cầu gửi tiền vào tài khoản của mình.',
          },
          Rewards: {
            title: "Phần thưởng",
            explanationHint:
              "Tổng số phần thưởng từ thanh toán {{appName}} cho chương trình khách hàng thân thiết Stardust trong tháng hiện tại.",
          },
          MyShare: {
            title: "Phần của tôi",
            explanationHint:
              "Phần hàng tháng hiện tại của bạn từ phần thưởng cho Stardust, đây là phần ước tính dựa trên tổng số Stardust và Phần thưởng.<newline/><newline/> Phần thực tế vào cuối tháng có thể khác với phần hiện tại.",
          },
          Rules: {
            Title: "Chương trình khách hàng thân thiết - quy tắc chung",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          CurrentTerms: {
            Title: "Điều khoản Stardust hiện hành",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
        Leaderboard: {
          Title: "Bảng xếp hạng Stardust",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Stardust",
          },
        },
      },
      Valor: {
        PointsLabel: {
          Points: "{{count}} Valor",
          Points_other: "{{count}} Valor",
        },
        Overview: {
          Points: {
            title: "Valor",
            explanationHint:
              "Valor là đơn vị phần thưởng dành cho Hunter trong {{appName}}. Bạn kiếm được bằng cách hoàn thành thử thách – mời người dùng mới, thương nhân và hunter.<newline/><newline/><bold>Vào cuối mỗi tháng, tất cả Valor được sử dụng để kiếm một phần của gói phần thưởng. Vào đầu tháng mới, tất cả Hunter bắt đầu với 0 Valor.</bold>",
          },
          Payout: {
            title: "Thanh toán",
            explanationHint:
              'Vào cuối mỗi tháng, kỳ chương trình khách hàng thân thiết Valor kết thúc và tiền kiếm được sẽ được ghi vào "Thanh toán" của bạn.<newline/><newline/> Khi bạn đạt 50 CZK trong thanh toán, bạn có thể yêu cầu gửi tiền vào tài khoản của mình.',
          },
          Rewards: {
            title: "Phần thưởng",
            explanationHint:
              "Tổng số phần thưởng từ {{appName}} cho chương trình khách hàng thân thiết Valor trong tháng hiện tại.",
          },
          MyShare: {
            title: "Phần của tôi",
            explanationHint:
              "Phần hàng tháng hiện tại của bạn từ phần thưởng cho Valor, đây là phần ước tính dựa trên tổng số Valor và Phần thưởng.<newline/><newline/> Phần thực tế vào cuối tháng có thể khác với phần hiện tại.",
          },
          Rules: {
            Title: "Valor - quy tắc chung",
            Link: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
          },
          CurrentChallenges: {
            Title: "VALOR - thử thách đang hoạt động",
            Link: "{{apiUrl}}/content/terms/legione-valor-monthly-july-2026.pdf",
          },
        },
        TeslaBanner: {
          Title: "Cuộc thi Tesla!",
          Description:
            "Hunter thành công nhất trong tháng (nhiều Valor nhất) có thể giành được Tesla trong cả tháng!",
        },
        Leaderboard: {
          Title: "Bảng xếp hạng Valor",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Valor",
          },
        },
      },
      SetPassword: {
        CreateNewPassword: "Tạo mật khẩu",
        ResetPassword: "Đặt lại mật khẩu",
        Password: "Mật khẩu",
        PasswordConfirmation: "Xác nhận mật khẩu",
        SetPassword: "Đặt mật khẩu",
      },
      AmlUsers: {
        ExportUnderConstruction: "Xuất ra tệp sắp ra mắt.",
        ExportButton: "Xuất",
        Error: "Đã xảy ra lỗi không mong đợi khi tải. Vui lòng thử lại sau.",
        TableHeaders: {
          Verification: "Xác minh",
          ClientIdentifier: "ID",
          Role: "Loại người dùng",
          FirstName: "Tên",
          LastName: "Họ",
          Company: "Công ty",
          PersonalNumber: "Số định danh cá nhân",
          PartyType: "Loại bên",
          RiskProfile: "Hồ sơ rủi ro",
          DateCreated: "Ngày tạo",
        },
        Detail: {
          ConnectedBankAccounts: "Tài khoản ngân hàng đã kết nối",
          RiskProfileSettings: "Cài đặt hồ sơ rủi ro",
          LoadingError: "Lỗi, không thể tải thông tin người dùng",
          RiskProfileUpdateError: "Lỗi khi cập nhật hồ sơ rủi ro",
          RiskProfileUpdateSuccess: "Hồ sơ rủi ro đã được cập nhật thành công.",
          ClientIdentifier: "ID khách hàng",
          CopyClientIdentifier: "Sao chép ID khách hàng",
          CopyClientIdentifierSuccess: "Đã sao chép ID khách hàng",
        },
      },
      LicenseDetail: {
        CancelOrderConfirmation: "Bạn có chắc muốn hủy đơn hàng này?",
        LoadingError: "Đã xảy ra lỗi khi tải dữ liệu giấy phép",
        Type: "Loại giấy phép",
        LicenseNo: "Số giấy phép",
        PaymentStatus: "Trạng thái thanh toán",
        WalletAddress: "Địa chỉ ví",
        Country: "Quốc gia",
        PaymentPendingInfo:
          "Giấy phép sẽ được kích hoạt sau khi thanh toán được ghi nhận. Nếu bạn đã thanh toán, vui lòng đợi thanh toán được ghi nhận.",
        CancelOrder: "Hủy đơn hàng",
        OrderLicense: "Đặt giấy phép",
        AwaitingPayment: "Đang chờ thanh toán",
        LicenseStatus: {
          Initiated: "Thanh toán đã khởi tạo",
          Processing: "Đang xử lý",
          Success: "Đã thanh toán",
          Fail: "Thất bại",
          Cancelled: "Đã hủy",
        },
      },
      LegalDocuments: {
        previousVersions: "Phiên bản trước",
        Documents: {
          Hunter: {
            digitalFranchiseContract: {
              title: "Hợp đồng nhượng quyền kỹ thuật số",
              url: "{{apiUrl}}/content/terms/legione-hunters-franchise-contract.pdf",
            },
            affiliateTerms: {
              title: "Điều khoản liên kết",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms.pdf",
            },
            commissionTable: {
              title: "Bảng hoa hồng",
              url: "{{apiUrl}}/content/terms/legione-provisions.pdf",
            },
            valorVigorPointRules: {
              title: "Quy tắc điểm Valor và Vigor",
              url: "{{apiUrl}}/content/terms/legione-valor-vigor.pdf",
            },
            valorGeneralRules: {
              title: "Valor - quy tắc chung",
              url: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
            },
            nftCollectionRules: {
              title: "Quy tắc bộ sưu tập NFT",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection.pdf",
            },
            generalFranchiseTerms: {
              title: "Điều khoản nhượng quyền chung",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms.pdf",
            },
            dataProtectionPrinciples: {
              title: "Nguyên tắc bảo vệ dữ liệu",
              url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
            },
            satisfactionGuarantee: {
              title: "Bảo đảm hài lòng",
              url: "{{apiUrl}}/content/terms/satisfaction-guarantee.pdf",
            },
            previousAffiliateTerms: {
              title: "Điều khoản liên kết có hiệu lực đến 28. 9. 2025",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-28-9-2025.pdf",
            },
            previousDataProtectionPrinciples: {
              title:
                "Nguyên tắc bảo vệ dữ liệu cá nhân có hiệu lực đến 06. 11. 2025",
              url: "{{apiUrl}}/content/terms/legione-gdpr.pdf",
            },
            previousDataProtectionPrinciples2: {
              title:
                "Nguyên tắc bảo vệ dữ liệu cá nhân có hiệu lực đến 01. 07. 2026",
              url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
            },
            previousAffiliateTerms2: {
              title: "Điều khoản liên kết có hiệu lực đến 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-08-02-2026.pdf",
            },
            previousGeneralFranchiseTerms: {
              title:
                "Điều khoản nhượng quyền chung có hiệu lực đến 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms-08-02-2026.pdf",
            },
            previousNftCollectionRules: {
              title: "Quy tắc bộ sưu tập NFT có hiệu lực đến 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection-08-02-2026.pdf",
            },
            previousCommissionTable: {
              title: "Bảng hoa hồng - phiên bản trước",
              url: "{{apiUrl}}/content/terms/legione-provisions-30-04-2026.pdf",
            },
          },
          mooneLiteTerms: {
            title: "Điều khoản {{appName}} Lite",
            url: "{{apiUrl}}/content/terms/Moone-moone-lite.pdf",
          },
          paymentServicesContract: {
            title: "Hợp đồng dịch vụ thanh toán",
            url: "{{apiUrl}}/content/terms/individual/Moone-payment-services-contract.pdf",
          },
          generalBusinessTerms: {
            title: "Điều khoản kinh doanh chung",
            url: "{{apiUrl}}/content/terms/individual/Moone-general-business-terms.pdf",
          },
          previousGeneralBusinessTerms: {
            title: "Điều khoản kinh doanh chung có hiệu lực đến 28. 10. 2025",
            url: "{{apiUrl}}/content/terms/individual/ZNPay-general-business-terms-28-10-2025.pdf",
          },
          merchantTerms: {
            title: "Điều khoản điểm thanh toán",
            url: "{{apiUrl}}/content/terms/individual/Moone-merchant-terms.pdf",
          },
          aisPisProductTerms: {
            title: "Điều khoản sản phẩm AIS-PIS",
            url: "{{apiUrl}}/content/terms/individual/Moone-ais-pis.pdf",
          },
          settlementManual: {
            title: "Hướng dẫn quyết toán thanh toán trực tiếp",
            url: "{{apiUrl}}/content/terms/individual/Moone-pis-settlement.pdf",
          },
          priceList: {
            Partner: {
              title: "Bảng giá - Partner",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-partner-251201.pdf",
            },
            Prime: {
              title: "Bảng giá - Prime",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-prime-251201.pdf",
            },
            Standard: {
              title: "Bảng giá",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-standard-251201.pdf",
            },
            Individual: {
              title: "Bảng giá - Đặc biệt 0,49%",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-discounted-individual.pdf",
            },
          },
          complaintRules: {
            title: "Quy định khiếu nại",
            url: "{{apiUrl}}/content/terms/individual/Moone-complaint-rules.pdf",
          },
          dataProtectionMemorandum: {
            title: "Nguyên tắc bảo vệ dữ liệu cá nhân",
            url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
          },
          previousDataProtectionMemorandum: {
            title: "Bản ghi nhớ bảo vệ dữ liệu có hiệu lực đến 06. 11. 2025",
            url: "{{apiUrl}}/content/terms/archive/ZNPay-memorandum-06-11-2025.pdf",
          },
          previousDataProtectionMemorandum2: {
            title: "Bản ghi nhớ bảo vệ dữ liệu có hiệu lực đến 01. 07. 2026",
            url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
          },
          precontractInformation: {
            title: "Thông tin tiền hợp đồng",
            url: "{{apiUrl}}/content/terms/individual/Moone-single-precontract-terms.pdf",
          },
          thanksToYou: {
            title: 'Thông báo chương trình "Cảm ơn bạn!"',
            url: "{{apiUrl}}/content/terms/individual/Moone-thanks-to-you.pdf",
          },
          stardust: {
            title: "Thông báo chương trình khách hàng thân thiết Stardust",
            url: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          stardustCurrentTerms: {
            title: "Quy định - thử thách đang hoạt động (Tháng 7 năm 2026)",
            url: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
      },
      Loyalty: {
        Tabs: {
          Challenges: "Thử thách",
          Leaderboard: "Bảng xếp hạng",
          Rewards: "Phần thưởng",
        },
        Challenges: {
          FeaturedChallenges: {
            Title: "Thử thách nổi bật",
            AllChallenges: "Tất cả thử thách",
          },
          WeeklyChallenges: {
            Title: "Thử thách hàng tuần",
            TimeRemaining: "Thời gian còn lại: {{days}} ngày và {{hours}} giờ",
          },
          MonthlyChallenges: {
            Title: "Thử thách hàng tháng",
            TimeRemaining: "Thời gian còn lại: {{days}} ngày và {{hours}} giờ",
          },
          DailyChallenges: {
            Title: "Thử thách hàng ngày",
          },
          LongTermChallenges: {
            Title: "Thử thách dài hạn",
          },
          UnlimitedChallenges: {
            Title: "Thử thách không giới hạn",
          },
          AllChallenges: {
            Title: "Tất cả thử thách",
          },
        },
        Rewards: {
          Title: "Cảm ơn bạn!",
          Columns: {
            Date: "Ngày",
            Activity: "Hoạt động",
          },
        },
        Notification: {
          Completed: "Thử thách đã hoàn thành!",
        },
        Events: {
          [LoyaltyEventCode.HunterDailyAppOpen]: {
            title: "Mở ứng dụng hàng ngày",
            description:
              "Người dùng khởi chạy {{appName}} ít nhất một lần mỗi ngày",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak3]: {
            title: "Chuỗi mở ứng dụng 3 ngày",
            description: "Đăng nhập vào ứng dụng 3 ngày liên tiếp",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak5]: {
            title: "Chuỗi mở ứng dụng 5 ngày",
            description: "Đăng nhập vào ứng dụng 5 ngày liên tiếp",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak10]: {
            title: "Chuỗi mở ứng dụng 10 ngày",
            description: "Đăng nhập vào ứng dụng 10 ngày liên tiếp",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak30]: {
            title: "Chuỗi mở ứng dụng 30 ngày",
            description: "Đăng nhập vào ứng dụng 30 ngày liên tiếp",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak180]: {
            title: "Chuỗi mở ứng dụng 180 ngày",
            description: "Đăng nhập vào ứng dụng 180 ngày liên tiếp",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak365]: {
            title: "Chuỗi mở ứng dụng 365 ngày",
            description: "Đăng nhập vào ứng dụng 365 ngày liên tiếp",
          },
          [LoyaltyEventCode.Anniversary]: {
            title: "Kỷ niệm",
            description: "Kỷ niệm ngày bạn tham gia {{appName}}",
          },
          [LoyaltyEventCode.HunterReferUser]: {
            title: "Nhờ bạn!",
            description: "Mời và đăng ký người dùng mới",
          },
          [LoyaltyEventCode.HunterRefer10]: {
            title: "Nhờ bạn 10!",
            description: "Mời và đăng ký 10 người dùng",
          },
          [LoyaltyEventCode.HunterRefer50]: {
            title: "Nhờ bạn 50!",
            description: "Mời và đăng ký 50 người dùng",
          },
          [LoyaltyEventCode.HunterRefer100]: {
            title: "Nhờ bạn 100!",
            description: "Mời và đăng ký 100 người dùng",
          },
          [LoyaltyEventCode.HunterMerchantOnboarded]: {
            title: "Thành viên mới!",
            description: "Onboard Merchant mới",
          },
          [LoyaltyEventCode.HunterMerchant1]: {
            title: "Hunter mới bắt đầu",
            description: "Đăng ký Merchant đầu tiên",
          },
          [LoyaltyEventCode.HunterMerchant10]: {
            title: "Hunter có kinh nghiệm",
            description: "Đăng ký 10 Merchant",
          },
          [LoyaltyEventCode.HunterMerchant50]: {
            title: "Hunter chuyên gia",
            description: "Đăng ký 50 Merchant",
          },
          [LoyaltyEventCode.HunterRecruitHunter]: {
            title: "Tuyển Hunter",
            description: "Mời Hunter mới",
          },
          [LoyaltyEventCode.HunterRecruit3]: {
            title: "Thợ săn Hunter",
            description: "Mời 3 Hunter mới",
          },
          [LoyaltyEventCode.HunterRecruit10]: {
            title: "Thợ săn Hunter kỳ cựu",
            description: "Mời 10 Hunter mới",
          },
          [LoyaltyEventCode.HunterMerchantNetwork]: {
            title: "Mở rộng mạng lưới",
            description: "Đối tác của bạn đã giới thiệu người dùng mới",
          },
          [LoyaltyEventCode.HunterWeeklyMerchant]: {
            title: "Nhiệm vụ tuần",
            description: "Merchant Active đầu tiên trong tuần",
          },
          [LoyaltyEventCode.HunterMonthlyMerchant]: {
            title: "Nhiệm vụ tháng",
            description: "Merchant Active đầu tiên trong tháng",
          },
          [LoyaltyEventCode.HunterTerminalPlaced]: {
            title: "Lắp đặt thiết bị",
            description: "Lắp đặt thiết bị tại cửa hàng",
          },
          [LoyaltyEventCode.HunterTerminalPlaced3]: {
            title: "Lắp đặt 3 thiết bị",
            description: "Lắp đặt 3 thiết bị tại các cửa hàng",
          },
          [LoyaltyEventCode.HunterTerminalPlaced10]: {
            title: "Lắp đặt 10 thiết bị",
            description: "Lắp đặt 10 thiết bị tại các cửa hàng",
          },
          [LoyaltyEventCode.HunterTerminalOfTheWeek]: {
            title: "Thiết bị tuần",
            description: "Thiết bị đầu tiên trong tuần",
          },
          [LoyaltyEventCode.HunterTerminalOfTheMonth]: {
            title: "Thiết bị tháng",
            description: "Thiết bị đầu tiên trong tháng",
          },
          [LoyaltyEventCode.HunterClosedHunter]: {
            title: "Kết thúc Hunter",
            description: "Hunter được mời đã mua giấy phép",
          },
          [LoyaltyEventCode.CustomerReferCustomer]: {
            title: "Giới thiệu liên kết",
            description: "Mời và đăng ký người dùng mới",
          },
          [LoyaltyEventCode.CustomerReferCustomer10]: {
            title: "Cảm ơn bạn 10!",
            description: "Mời và đăng ký 10 người dùng qua Cảm ơn bạn!",
          },
          [LoyaltyEventCode.CustomerReferCustomer50]: {
            title: "Cảm ơn bạn 50!",
            description: "Mời và đăng ký 50 người dùng qua Cảm ơn bạn!",
          },
          [LoyaltyEventCode.CustomerReferCustomer100]: {
            title: "Cảm ơn bạn 100!",
            description: "Mời và đăng ký 100 người dùng qua Cảm ơn bạn!",
          },
          [LoyaltyEventCode.CustomerDailyAppOpen]: {
            title: "Mở ứng dụng hàng ngày",
            description: "Khởi chạy {{appName}} ít nhất một lần mỗi ngày",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak3]: {
            title: "Chuỗi mở ứng dụng 3 ngày",
            description: "Đăng nhập vào ứng dụng 3 ngày liên tiếp",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak5]: {
            title: "Chuỗi mở ứng dụng 5 ngày",
            description: "Đăng nhập vào ứng dụng 5 ngày liên tiếp",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak10]: {
            title: "Chuỗi mở ứng dụng 10 ngày",
            description: "Đăng nhập vào ứng dụng 10 ngày liên tiếp",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak30]: {
            title: "Chuỗi mở ứng dụng 30 ngày",
            description: "Đăng nhập vào ứng dụng 30 ngày liên tiếp",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak180]: {
            title: "Chuỗi mở ứng dụng 180 ngày",
            description: "Đăng nhập vào ứng dụng 180 ngày liên tiếp",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak365]: {
            title: "Chuỗi mở ứng dụng 365 ngày",
            description: "Đăng nhập vào ứng dụng 365 ngày liên tiếp",
          },
          [LoyaltyEventCode.Payment]: {
            title: "Thanh toán {{appName}}",
            description: "Giao dịch được thực hiện qua {{appName}}",
          },
          [LoyaltyEventCode.PaymentStreak3]: {
            title: "Chuỗi thanh toán 3 ngày",
            description: "Thanh toán mỗi ngày trong 3 ngày",
          },
          [LoyaltyEventCode.PaymentStreak5]: {
            title: "Chuỗi thanh toán 5 ngày",
            description: "Thanh toán mỗi ngày trong 5 ngày",
          },
          [LoyaltyEventCode.PaymentStreak10]: {
            title: "Chuỗi thanh toán 10 ngày",
            description: "Thanh toán mỗi ngày trong 10 ngày",
          },
          [LoyaltyEventCode.PaymentStreak30]: {
            title: "Chuỗi thanh toán 30 ngày",
            description: "Thanh toán mỗi ngày trong 30 ngày",
          },
          [LoyaltyEventCode.PaymentStreak180]: {
            title: "Chuỗi thanh toán 180 ngày",
            description: "Thanh toán mỗi ngày trong 180 ngày",
          },
          [LoyaltyEventCode.CustomerCompleteRegistration]: {
            title: "Hoàn thành đăng ký",
            description: "Hoàn thành đăng ký người dùng của bạn",
          },
          [LoyaltyEventCode.TenPayments]: {
            title: "Mười lần",
            description: "Đạt 10 thanh toán {{appName}}",
          },
          [LoyaltyEventCode.FiftyPayments]: {
            title: "Năm mươi lần",
            description: "Đạt 50 thanh toán {{appName}}",
          },
          [LoyaltyEventCode.HundredPayments]: {
            title: "Một trăm lần",
            description: "Đạt 100 thanh toán {{appName}}",
          },
          [LoyaltyEventCode.ThousandPayments]: {
            title: "Một nghìn lần {{appName}}",
            description: "Đạt 1.000 thanh toán {{appName}}",
          },
          [LoyaltyEventCode.Explorer]: {
            title: "Nhà thám hiểm",
            description: "Thanh toán tại 5 điểm thanh toán khác nhau",
          },
          [LoyaltyEventCode.Discoverer]: {
            title: "Người khám phá",
            description: "Thanh toán tại 10 điểm thanh toán khác nhau",
          },
          [LoyaltyEventCode.Traveler]: {
            title: "Du khách",
            description: "Thanh toán tại 50 điểm thanh toán khác nhau",
          },
          [LoyaltyEventCode.FriendPayment]: {
            title: "Thanh toán cho bạn bè",
            description:
              "Lần thanh toán trực tiếp đầu tiên qua {{appName}} cho bạn bè",
          },
          [LoyaltyEventCode.LargePayment]: {
            title: "Thanh toán lớn",
            description:
              "Lần thanh toán đầu tiên với {{appName}} trên 1000 CZK",
          },
          [LoyaltyEventCode.BankConnection]: {
            title: "Kết nối ngân hàng",
            description: "Lần kết nối tài khoản ngân hàng đầu tiên",
          },
          [LoyaltyEventCode.FirstSpending]: {
            title: "Chi tiêu đầu tiên",
            description:
              "Lần thanh toán trực tiếp đầu tiên qua {{appName}} tại điểm thanh toán",
          },
          [LoyaltyEventCode.EngineIgnition]: {
            title: "Khởi động động cơ",
            description:
              "Thanh toán đầu tiên trong ngày (từ tất cả người dùng)",
          },
          [LoyaltyEventCode.WeeklyMissionStart]: {
            title: "Bắt đầu nhiệm vụ tuần",
            description:
              "Thanh toán đầu tiên trong tuần (từ tất cả người dùng)",
          },
          [LoyaltyEventCode.RepeatedUsage]: {
            title: "Sử dụng lặp lại",
            description: "Thực hiện 10 thanh toán trong một tháng",
          },
          [LoyaltyEventCode.MonthlyMissionStart]: {
            title: "Bắt đầu nhiệm vụ tháng",
            description:
              "Thanh toán đầu tiên trong tháng (từ tất cả người dùng)",
          },
        },
      },
      UserDetailPageContent: {
        SaveSuccess: "Dữ liệu người dùng đã được lưu thành công",
        SaveError: "Đã xảy ra lỗi khi lưu dữ liệu người dùng",
        DuplicateLoginError:
          "Tên đăng nhập này đã được sử dụng bởi người dùng khác",
        AddressFields: {
          Legend: "Địa chỉ",
          Type: "Loại địa chỉ",
          Street: "Đường",
          StreetNumber: "Số nhà",
          OrientationNumber: "Số định hướng",
          PostalCode: "Mã bưu chính",
          Municipality: "Thành phố/Xã",
          Remove: {
            Button: "Xóa địa chỉ",
            ConfirmTitle: "Xóa địa chỉ",
            ConfirmContent: "Bạn có chắc chắn muốn xóa địa chỉ này không?",
            SuccessMessage: "Đã xóa địa chỉ",
            ErrorMessage: "Đã xảy ra lỗi khi xóa địa chỉ",
          },
        },
        Tabs: {
          User: {
            Title: "Người dùng",
            Form: {
              Login: "Đăng nhập",
              Status: "Trạng thái",
              VerificationAdditionalInfoStatus: "Trạng thái thông tin bổ sung",
              VerificationIdentityVerificationStatus:
                "Trạng thái xác minh danh tính",
              VerificationRiskProfile: "Hồ sơ rủi ro",
              VerificationBankVerificationStatus:
                "Trạng thái xác minh ngân hàng",
              BankVerificationSource: "Nguồn xác minh ngân hàng",
              BankAccountNumber:
                "Tài khoản ngân hàng xác minh đã sử dụng để xác minh",
              VerificationDailyBuyLimit: "Giới hạn hàng ngày",
              VerificationMonthlyBuyLimit: "Giới hạn hàng tháng",
              Stardust: {
                Legend: "Chương trình khách hàng thân thiết Stardust",
                NotAsked: "Chưa hỏi",
                OptedIn: "Đã tham gia",
                OptedOut: "Đã rời",
                Withdrawn: "Đã rời vĩnh viễn",
                ChangedAt: "Từ {{date}} ({{source}})",
                Source: {
                  Registration: "đăng ký",
                  ConsentDialog: "hộp thoại Stardust",
                  ProgramSection: "mục Stardust",
                },
              },
              ThanksToYou: {
                Legend: "Chương trình giới thiệu Cảm ơn bạn!",
                NotAsked: "Đã tham gia (chưa trả lời)",
                OptedIn: "Đã tham gia",
                OptedOut: "Đã từ chối",
                Withdrawn: "Đã rời vĩnh viễn",
                ChangedAt: "Từ {{date}} ({{source}})",
                Source: {
                  Registration: "đăng ký",
                  ConsentDialog: "hộp thoại",
                  ProgramSection: "mục Cảm ơn bạn!",
                },
              },
              Legend: {
                Account: "Tài khoản",
                Verification: "Xác minh",
                Bank: "Ngân hàng",
                Limits: "Giới hạn",
              },
            },
          },
          Party: {
            Title: "Bên",
            SetVerified: "Xác minh danh tính",
            CancelVerification: "Hủy xác minh danh tính",
            NoDocumentsUploaded: "Bên này chưa tải lên tài liệu nào",
            NoActingPersonLinked:
              "Chưa có người đại diện được liên kết — tài liệu không khả dụng",
            IdentityVerificationLegend: "Xác minh danh tính",
            IdentityVerified: "Danh tính người dùng đã được xác minh",
            IdentityNotVerified: "Xác minh danh tính người dùng đã bị hủy",
            Form: {
              SubmitSuccess: "Dữ liệu bên đã được lưu",
              SubmitError: "Đã xảy ra lỗi khi lưu dữ liệu bên",
              Save: "Lưu",
              ClientIdentifier: "ID khách hàng",
              CopyClientIdentifier: "Sao chép ID khách hàng",
              CopyClientIdentifierSuccess: "Đã sao chép ID khách hàng",

              NaturalPerson: {
                Type: "Loại bên",
                FirstName: "Tên",
                LastName: "Họ",
                PersonalNumber: "Số CMND/CCCD",
                BirthDate: "Ngày sinh",
                Gender: "Giới tính",
                BirthPlace: "Nơi sinh",
                Nationality: "Quốc tịch",
                Phone: "Điện thoại",
                VerifiedPhone: "Điện thoại đã xác minh",
                Email: "E-mail",
                Legend: {
                  PersonalData: "Dữ liệu cá nhân",
                  Contact: "Liên hệ",
                  Documents: "Tài liệu",
                },
              },
              PartyIdentification: {
                Identification: "Loại giấy tờ",
                IdentificationNumber: "Số giấy tờ",
                IdentificationValidFrom: "Có hiệu lực từ",
                IdentificationValidTo: "Có hiệu lực đến",
                IdentificationIssuer: "Nơi cấp",
                NoIdentificationsUploaded:
                  "Không tìm thấy tài liệu đã tải lên cho bên này.",
                IdentificationsDownloadPrefix: "identifications_",
                SecondDocumentTitle: "Tài liệu thứ hai",
                AutomatedCheck: {
                  Title: "Kiểm tra giấy tờ tự động",
                  NoChecks: "Chưa có kiểm tra tự động nào.",
                  LoadingError: "Không thể tải kết quả kiểm tra tự động.",
                  Document: "Giấy tờ",
                  Documents: {
                    Primary: "Giấy tờ chính",
                    Secondary: "Giấy tờ thứ hai",
                  },
                  Verdict: "Kết quả",
                  Date: "Ngày",
                  DocumentType: "Loại (theo Didit)",
                  RequestID: "Didit request ID",
                  Warnings: "Cảnh báo",
                  Error: "Lỗi",
                },
              },
              LegalEntity: {
                Type: "Loại bên",
                CompanyName: "Tên công ty",
                CompanyNumber: "Mã số doanh nghiệp",
                TaxNumber: "Mã số thuế",
                Phone: "Điện thoại",
                Email: "E-mail",
                Legend: {
                  Company: "Công ty",
                  Contact: "Liên hệ",
                },
                RegistryLinks: {
                  Or: "Đăng ký kinh doanh",
                  Isir: "Đăng ký phá sản",
                  Esm: "Đăng ký chủ sở hữu",
                },
              },
              SelfEmployed: {
                Legend: {
                  Company: "Doanh nghiệp",
                  Contact: "Liên hệ",
                  Documents: "Tài liệu",
                },
                Type: "Loại bên",
                CompanyName: "Tên công ty",
                FirstName: "Tên",
                LastName: "Họ",
                CompanyNumber: "Mã số doanh nghiệp",
                TaxNumber: "Mã số thuế",
                PersonalNumber: "Số CMND/CCCD",
                BirthDate: "Ngày sinh",
                Gender: "Giới tính",
                BirthPlace: "Nơi sinh",
                Nationality: "Quốc tịch",
                Phone: "Điện thoại",
                VerifiedPhone: "Điện thoại đã xác minh",
                Email: "E-mail",
              },
            },
          },
          BankAccounts: {
            Title: "Tài khoản ngân hàng",
            Subtitle: "Tài khoản ngân hàng đã kết nối",
          },
          Licenses: {
            Title: "Giấy phép",
            Empty: "Người dùng không có giấy phép đang hoạt động nào.",
            Transfer: {
              Button: "Chuyển giấy phép",
              Title: "Chuyển giấy phép {{licenseNo}}",
              Description:
                "Hunter mới tiếp quản các merchant đăng ký trên giấy phép, toàn bộ mạng lưới affiliate của hunter trước đó (khách hàng và hunter được giới thiệu) và mọi khoản thưởng trong tương lai từ họ. Các khoản thưởng đã tích lũy và đã trả, hóa đơn mua và lịch sử đã đóng vẫn thuộc về hunter trước đó (họ vẫn xem được nhưng không còn hưởng lợi). Địa chỉ ví của giấy phép không thay đổi.",
              TargetLabel: "Chủ sở hữu giấy phép mới",
              Submit: "Chuyển giấy phép",
              Success: "Giấy phép đã được chuyển",
              Error: "Đã xảy ra lỗi khi chuyển giấy phép",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Dữ liệu giấy phép đã được lưu",
                SubmitError: "Đã xảy ra lỗi khi lưu dữ liệu giấy phép",
                Save: "Lưu",
                SendInvoice: "Gửi hóa đơn",
                SendingInvoice: "Đang gửi hóa đơn...",
                SendInvoiceSuccess: "Hóa đơn đã được gửi thành công",
                SendInvoiceError: "Đã xảy ra lỗi khi gửi hóa đơn",
                InvoiceSent: "Hóa đơn đã gửi",
                RegenerateInvoice: "Tạo lại hóa đơn",
                RegeneratingInvoice: "Đang tạo lại hóa đơn...",
                RegenerateInvoiceSuccess: "Hóa đơn đã được tạo lại",
                RegenerateInvoiceError: "Đã xảy ra lỗi khi tạo lại hóa đơn",
              },
              Fields: {
                Code: "Loại giấy phép",
                LicenseNo: "Số giấy phép",
                PaymentDate: "Ngày thanh toán",
                PaymentStatus: {
                  label: "Trạng thái thanh toán",
                  options: {
                    Initiated: "Đã khởi tạo thanh toán",
                    Processing: "Đang xử lý",
                    Success: "Đã thanh toán",
                    Fail: "Thất bại",
                    Cancelled: "Đã hủy",
                  },
                },
                WalletAddress: "Địa chỉ ví",
              },
            },
          },
          Verification: {
            Title: "Xác minh",
            Form: {
              Controls: {
                SubmitSuccess: "Dữ liệu xác minh đã được lưu",
                SubmitError: "Đã xảy ra lỗi khi lưu dữ liệu xác minh",
                Save: "Lưu",
              },
              Fields: {
                TaxResidencyCountryID: "Quốc gia cư trú thuế",
                BusinessActivity: "Hoạt động kinh doanh",
                OtherBusinessActivityDetails: "Mô tả hoạt động kinh doanh",
                SourceOfIncome: "Nguồn thu nhập",
                OtherSourceOfIncomeDetails: "Mô tả nguồn thu nhập",
                LegacySourceOfIncome: "Nguồn thu nhập trước đây",
                ExpectedMonthlyRevenue: "Doanh thu hàng tháng dự kiến",
                AverageTransactionValue: "Giá trị giao dịch trung bình",
                IsPoliticallyExposedPerson: "Người có ảnh hưởng chính trị",
                HasNonEUResidence:
                  "Cư trú ngoài EU hơn 12 tháng (tính đến ngày đăng ký)",
                HasNonEUNationality: "Quốc tịch ngoài EU",
              },
            },
          },
          Settlement: {
            Title: "Quyết toán",
          },
          HunterPrerequisites: {
            Title: "Các bước đầu tiên của Hunter",
            SelectAll: "Chọn tất cả",
            DeselectAll: "Bỏ chọn tất cả",
            LoadingError: "Đã xảy ra lỗi khi tải điều kiện tiên quyết.",
            SaveSuccess: "Đã lưu thay đổi thành công.",
            SaveError: "Đã xảy ra lỗi khi lưu thay đổi.",
            Note: "Ghi chú",
            NotePlaceholder: "Ghi chú tùy chọn...",
            AutoVerified: "Tự động xác minh",
            Items: {
              RegisterAsMerchant:
                "Đã đăng ký làm Thương gia và khám phá ứng dụng",
              InviteUserViaAffiliate: "Đã mời người dùng mới qua Cảm ơn bạn!",
              BanksAndPayments:
                "Đã kết nối ít nhất 3 ngân hàng và thực hiện 30 thanh toán",
              OfflineTraining: "Đã tham dự đào tạo Mo.one ngoại tuyến",
              BringMerchantsWithHunter:
                "Đã mang 3 Thương gia hợp tác với Hunter có kinh nghiệm",
            },
          },
          RelatedParties: {
            Title: "Các bên liên quan",
            NoRelatedParties: "Không tìm thấy bên liên quan nào cho bên này.",
            Add: {
              Button: "Thêm bên liên quan",
              Title: "Thêm bên liên quan",
              RelationTypeLabel: "Loại quan hệ",
              BeneficialOwnerOption: "Chủ sở hữu hưởng lợi",
              Submit: "Thêm",
              AddSuccess: "Đã thêm bên liên quan",
              AddError: "Đã xảy ra lỗi khi thêm bên liên quan",
              LinkError:
                "Đã tạo người nhưng không thể liên kết với công ty. Vui lòng thử lại — sẽ không tạo người trùng lặp.",
              DocumentsTitle: "Giấy tờ tùy thân",
              DocumentsIncomplete:
                "Vui lòng đính kèm cả hai mặt của giấy tờ thứ nhất và giấy tờ thứ hai đầy đủ.",
            },
            Delete: {
              Button: "Xóa bên liên quan",
              ConfirmTitle: "Xóa bên liên quan",
              ConfirmContent:
                "Bạn có chắc chắn muốn xóa bên liên quan {{name}} không? Thao tác này chỉ xóa vai trò này.",
              SuccessMessage: "Đã xóa bên liên quan",
              ErrorMessage: "Đã xảy ra lỗi khi xóa bên liên quan",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Dữ liệu bên liên quan đã được lưu",
                SubmitError: "Đã xảy ra lỗi khi lưu dữ liệu bên liên quan",
                LoadingError: "Đã xảy ra lỗi khi tải dữ liệu bên liên quan",
                Save: "Lưu",
              },
              Fields: {
                RelationType: "Loại quan hệ",
                IsOwner: "Là chủ sở hữu công ty",
                BeneficialOwnerFields: {
                  Legend: {
                    PersonalData: "Dữ liệu cá nhân",
                  },
                  FirstName: "Tên",
                  LastName: "Họ",
                  BirthDate: "Ngày sinh",
                  Nationality: "Quốc tịch",
                },
                RelatedPartyFields: {
                  Legend: {
                    PersonalData: "Dữ liệu cá nhân",
                    Contact: "Liên hệ",
                    Documents: "Tài liệu",
                    FirstDocument: "Tài liệu đầu tiên",
                  },
                  DocumentsExpiringSoon: "Tài liệu sắp hết hạn",
                  DocumentsExpired: "Tài liệu đã hết hạn",
                  DocumentsValidityMissing: "Thiếu thời hạn tài liệu",
                  FirstName: "Tên",
                  LastName: "Họ",
                  PersonalNumber: "Số CMND/CCCD",
                  BirthDate: "Ngày sinh",
                  Gender: "Giới tính",
                  BirthPlace: "Nơi sinh",
                  Nationality: "Quốc tịch",
                  Phone: "Điện thoại",
                  Email: "E-mail",
                },
              },
            },
          },
        },
      },
      Contact: {
        HunterDiscord: {
          Description: "Để liên lạc nhanh, hãy tham gia ",
          Link: "Legi.one trên Discord!",
        },
        Phone: "Điện thoại",
        Email: "E-mail",
        PhoneDescription:
          "Bạn có thể liên hệ với chúng tôi qua điện thoại từ 9:00 đến 16:00.",
        CompanyInfo: {
          title: "Nhà cung cấp",
          description: "Mo.one a.s.",
          CompanyNumber: "Mã số đăng ký: 02013517",
          TaxNumber: "Mã số thuế: CZ02013517",
          CompanyAddress:
            "Đăng ký tại Palackého třída 3048/124, Královo Pole, 612 00 Brno, đăng ký trong Sổ đăng ký thương mại tại Tòa án khu vực Brno, số hồ sơ B 9099",
        },
        HunterCompanyInfo: {
          Title: "Nhà cung cấp",
          CompanyName: "LEGI.ONE LTD.",
          CompanyInfoLine1: "Đăng ký tại Vương quốc Anh với số 15846883",
          CompanyInfoLine2:
            "với trụ sở đăng ký tại 20 Wenlock Road, London, England, N1 7GU",
          CompanyInfoLine3:
            "liên kết và thông qua công ty con tại Cộng hòa Séc:",
        },
        BankInfo: {
          Title: "Kết nối ngân hàng",
          CZKAccount: {
            Customer: "Fio bank: 2103087398/2010",
            Hunter: "Tài khoản ngân hàng CZK: 1741535007/2700",
            Merchant: "Fio bank: 2103087398/2010",
            Admin: "Fio bank: 2103087398/2010",
            Aml: "Fio bank: 2103087398/2010",
            Employee: "Fio bank: 2103087398/2010",
            CustomerOnboarding: "Fio bank: 2103087398/2010",
            HunterPlus: "Tài khoản ngân hàng CZK: 1741535007/2700",
            AdminLite: "Fio bank: 2103087398/2010",
            Disponent: "Fio bank: 2103087398/2010",
            Child: "Fio bank: 2103087398/2010",
          },
          EURAccount: {
            Customer: "",
            Hunter: "Tài khoản ngân hàng EUR: 1741535015/2700",
            Merchant: "",
            Admin: "",
            Aml: "",
            Employee: "",
            CustomerOnboarding: "",
            HunterPlus: "Tài khoản ngân hàng EUR: 1741535015/2700",
            AdminLite: "",
            Disponent: "",
            Child: "",
          },
        },
      },
      BankAccounts: {
        ConnectedBankAccounts: "Tất cả tài khoản đã kết nối",
        CurrencyGroupTitle: "Tài khoản bằng {{currency}}",
        BankIdentityVerificationAccount: "Tài khoản xác minh danh tính",
        InvalidTokenChip: "Quyền truy cập đã hết hạn",
        AccountMenu: {
          Renew: "Gia hạn quyền truy cập",
          RenewPayments: "Gia hạn thanh toán",
          Remove: "Ngắt kết nối tài khoản",
        },
        EditOrder: "Chỉnh sửa thứ tự",
        PrimaryAccount: "Tài khoản chính",
        PrimaryAccountDescription:
          "Bạn đặt tài khoản chính bằng biểu tượng ngôi sao, riêng cho từng loại tiền tệ — đó là tài khoản mặc định để nhận và gửi thanh toán bằng loại tiền tệ đó. Không thể đặt tài khoản ở trạng thái <limitedChip /> hoặc <awaitingVerificationChip /> làm tài khoản chính.",
        HunterPrimaryAccountDescription:
          "Bạn đặt tài khoản chính bằng biểu tượng ngôi sao, riêng cho từng loại tiền tệ — chúng tôi sẽ gửi phần thưởng của bạn đến tài khoản chính của loại tiền tệ tương ứng.",
        MissingLicenseHolderBankAccount:
          "Để nhận thưởng, hãy kết nối tài khoản ngân hàng thuộc sở hữu của chủ giấy phép nhượng quyền.",
        VerificationStatusesTitle: "Trạng thái xác minh tài khoản",
        QuickPayment: {
          Label: "Thanh toán nhanh",
          Description:
            "Sau khi tải giao dịch, bạn sẽ được tự động chuyển hướng đến ngân hàng của bạn để ủy quyền thanh toán với tài khoản chính, bỏ qua các bước chi tiết giao dịch và chọn ngân hàng.",
        },
        EditAccountOrderDescription:
          "Bạn có thể thay đổi thứ tự tài khoản của mình bằng cách kéo chúng đến vị trí mong muốn.",
        NoBankAccounts: "Không có tài khoản ngân hàng nào được kết nối",
        Error:
          "Đã xảy ra lỗi không mong muốn khi tải tài khoản ngân hàng. Vui lòng thử lại sau.",
        NoAccountSet: "Chưa đặt tài khoản",
        DeleteAccount: {
          Title: "Xóa tài khoản",
          Prompt: "Bạn có chắc chắn muốn xóa tài khoản này không?",
          ReplacementPrimaryAccount: "Tài khoản chính mới",
          PrimaryAccountWarning:
            "Bạn sắp xóa <bold>tài khoản chính</bold> của mình. Vui lòng chọn tài khoản chính mới.",
        },
        ManualBankAccountVerificationPrompt: {
          ManualVerificationNecessary:
            "Tài khoản này cần được xác minh thủ công",
          ActivateConfirmationPrompt:
            "Bạn có chắc chắn muốn kích hoạt tài khoản này không? Hành động này không thể hoàn tác.",
          RejectConfirmationPrompt:
            "Bạn có chắc chắn muốn từ chối tài khoản này không? Hành động này không thể hoàn tác.",
          Activate: "Kích hoạt",
          Reject: "Từ chối",
        },
        ConnectedBankAccount: {
          Owner: "Chủ tài khoản",
          DateCreated: "Ngày tạo",
          Status: "Trạng thái",
          BankVerificationSource: "Nguồn xác minh ngân hàng",
        },
        DeletedVerificationAccount: {
          Error: "Không thể tải tài khoản xác minh.",
        },
        Detail: {
          IBAN: "IBAN",
          AccountOwners: "Chủ tài khoản",
          DateConnected: "Ngày kết nối",
          AccountNotFound: "Không tìm thấy tài khoản ngân hàng này.",
          BackToList: "Quay lại tài khoản ngân hàng",
          IsPrimaryNote: "Đây là tài khoản ngân hàng chính của bạn.",
          Actions: {
            SetAsPrimary: "Đặt làm tài khoản chính",
            PrimaryAccountDescription:
              "Tài khoản chính là mặc định để nhận và gửi thanh toán.",
            AuthorizeAccess: "Ủy quyền truy cập {{bankName}}",
            AuthorizePayments: "Ủy quyền thanh toán {{bankName}}",
            AuthorizationValidUntil: "Ủy quyền có hiệu lực đến {{date}}",
          },
          IbanCopySuccess: "Đã sao chép IBAN",
          Alerts: {
            Rejected: {
              Title: "Tài khoản đã bị từ chối",
              Description:
                "Tài khoản này đã bị từ chối và không thể sử dụng trong ứng dụng.",
            },
            Inactive: {
              Title: "Tài khoản không hoạt động",
              Description:
                "Tài khoản này không hoạt động. Liên hệ bộ phận hỗ trợ nếu bạn muốn sử dụng lại.",
            },
            Restricted: {
              Title: "Hoàn tất xác minh danh tính",
              Description:
                "Để sử dụng đầy đủ tài khoản này, vui lòng hoàn tất xác minh danh tính.",
              Action: "Hoàn tất xác minh",
            },
            AwaitingVerification: {
              Title: "Xác minh kết nối tài khoản",
              Description:
                "Thông tin của tài khoản này cần được xác minh bởi một thành viên trong nhóm {{appName}}. Điều này thường xảy ra khi tên chủ tài khoản không thể được tự động đối chiếu với tên của bạn.",
            },
            PreApproved: {
              Title: "Tài khoản của bạn đã được phê duyệt trước",
              Description:
                "Bạn có thể nhận thanh toán tài khoản đến tài khoản tối đa {{limit}} trước khi tài khoản được xác minh đầy đủ — còn lại {{remaining}}. Các giới hạn sẽ tự động được gỡ bỏ sau khi hoàn tất xác minh.",
            },
            TokenInvalidAis: {
              Title: "Quyền truy cập tài khoản đã hết hạn",
              Description:
                "Quyền truy cập thông tin tài khoản đã hết hạn. Gia hạn kết nối để chúng tôi có thể tải số dư và giao dịch.",
              Action: "Gia hạn quyền truy cập",
            },
            TokenExpiringAis: {
              Title: "Quyền truy cập tài khoản sắp hết hạn",
              Description:
                "Quyền truy cập thông tin tài khoản sắp hết hạn. Gia hạn để chúng tôi có thể tiếp tục tải số dư.",
              Action: "Gia hạn quyền truy cập",
            },
            TokenInvalidPisp: {
              Title: "Ủy quyền thanh toán đã hết hạn",
              Description:
                "Ủy quyền khởi tạo thanh toán từ tài khoản này đã hết hạn. Gia hạn để tiếp tục gửi thanh toán.",
              Action: "Gia hạn thanh toán",
            },
            TokenExpiringPisp: {
              Title: "Ủy quyền thanh toán sắp hết hạn",
              Description:
                "Ủy quyền khởi tạo thanh toán từ tài khoản này sắp hết hạn. Gia hạn để tiếp tục gửi thanh toán.",
              Action: "Gia hạn thanh toán",
            },
          },
        },
      },
      Help: {
        HelpInPreparation: "Trang trợ giúp đang được xây dựng.",
        ContactEmail:
          "Nếu bạn có bất kỳ câu hỏi nào, bạn có thể liên hệ với chúng tôi qua e-mail tại",
      },
      MerchantFeeCalculator: {
        YearlySavingsWidget: {
          PotentialYearlySavings: "Tiết kiệm hàng năm tiềm năng",
          WithLegione: "Với Legi.one lên đến:",
          WithMoone: "Với {{appName}} lên đến:",
        },
        CurrentTotalFee: "Tổng phí hiện tại",
        ProposedTotalFee: "Tổng phí đề xuất",
        HideFeeTable: "Ẩn bảng phí chi tiết",
        ShowFeeTable: "Hiển thị bảng phí chi tiết",
        MonthlyTurnover: "Doanh thu hàng tháng",
        AverageTransactionValue: "Giá trị giao dịch trung bình",
        MooneDirectPayShare: "Tỷ lệ thanh toán trực tiếp {{appName}}",
        Currency: "CZK",
        FeeSettings: {
          CurrentFees: "Phí hiện tại",
          ProposedFee: "Phí đề xuất",
          DirectPaymentWithMoone: "Thanh toán trực tiếp với {{appName}}",
          ProviderFee: "Phí nhà cung cấp",
          Acquiring: "(Acquiring)",
          FixedTransactionCost: "Chi phí giao dịch cố định",
          MooneFee: "Phí {{appName}}",
        },
        CardTypeRatioSlider: {
          Title: "Tỷ lệ loại thẻ",
          ToggleButtons: {
            MostlyPersonal: "Chủ yếu cá nhân",
            SomeCommercial: "Tỷ lệ thương mại cao hơn",
            MostlyCommercial: "Chủ yếu thương mại",
          },
          CardTypeRatios: {
            Personal: "Cá nhân",
            Commercial: "Thương mại",
          },
        },
        CardRatesTable: {
          Expand: "Hiển thị bảng phí chi tiết",
          Collapse: "Ẩn bảng phí chi tiết",
          Headers: {
            CardType: "Loại thẻ",
            Interchange: "Interchange",
            SchemeFee: "Phí scheme",
            CurrentTotalRate: "Tỷ lệ tổng hiện tại",
            ProposedTotalRate: "Tỷ lệ tổng đề xuất",
          },
        },
        CostsChart: {
          Title: "Chi phí giao dịch",
          HighContrast: "Độ tương phản cao",
          AnnualTransactionCosts: "Chi phí giao dịch hàng năm",
          TickLabels: {
            CurrentCosts: {
              Mobile: "Hiện tại",
              Full: "Chi phí hiện tại",
              Description: "Phí trung bình",
            },
            LegioneCosts: {
              Mobile: "Legi.one",
              Full: "Chi phí với Legi.one",
              Description: "Phí trung bình",
            },
            MooneCosts: {
              Mobile: "{{appName}}",
              Full: "Chi phí với {{appName}}",
              Description: "Phí",
            },
          },
        },
      },
      Merchants: {
        StatusWidgets: {
          OpenRegistrations: "Đăng ký mở",
          InvitationsSent: "Lời mời đã gửi",
          InOnboarding: "Đang đăng ký",
          Completed: "Hoàn thành",
        },
        Error:
          "Đã xảy ra lỗi không mong muốn khi tải danh sách điểm thanh toán. Vui lòng thử lại sau.",
        TableHeaders: {
          Status: "Trạng thái",
          CompanyName: "Tên công ty",
          CompanyNumber: "Mã số doanh nghiệp",
          LicenseType: "Loại giấy phép",
          LicenseOwner: "Chủ giấy phép",
          LicenseNumber: "Số giấy phép",
          DateCreated: "Ngày tạo",
          TransactionsCount: "Số lượng giao dịch",
        },
        OrbitLOnboarding: {
          Title: "OrbitL Onboarding",
          ActionRequiredBadge: "Cần hành động",
          LoadingError: "Không thể tải dữ liệu OrbitL onboarding",
          Table: {
            CompanyNumber: "IČO",
            CompanyName: "Tên công ty",
            Hunter: "Hunter",
            ActivatedAt: "Ngày kích hoạt OrbitL",
            Phase: "Giai đoạn",
            ComgateStatus: "Trạng thái Comgate",
            ComgateMID: "MID",
            TimeSinceSubmit: "Thời gian kể từ gửi",
            LastStatusChange: "Thay đổi trạng thái gần nhất",
            FinancingModel: "Tài trợ",
            Hours: "{{count}}h",
            Days: "{{count}}d",
            TerminalCount: "Terminal",
            TerminalCountRequest: "Yêu cầu đổi số lượng",
            OnlyOpenRequests: "Chỉ có yêu cầu đang mở",
          },
          TerminalCountChange: {
            SectionTitle: "Số lượng terminal",
            OpenRequestHeading: "Yêu cầu thay đổi đang mở",
            RequestedBy: "Yêu cầu bởi {{user}}",
            SystemActor: "hệ thống",
            ContractTotal: "Số lượng theo hợp đồng: {{count}}",
            ContractSoftPosTotal: "SoftPOS: {{count}}",
            ContractLevelChange: "Tổng số lượng",
            SoftPosChange: "SoftPOS {{from}} → {{to}}",
            SoftPosTotal: "SoftPOS: {{from}} → {{to}}",
            HistoryHeading: "Lịch sử thay đổi",
            NoHistory: "Chưa có thay đổi số lượng terminal",
            ResolveButton: "Đã xử lý",
            DismissButton: "Từ chối",
            ResolveHint:
              "Xử lý chỉ đóng yêu cầu — hãy đổi số lượng thực tế qua phần chỉnh sửa cơ sở.",
            DismissDialogTitle: "Từ chối yêu cầu",
            DismissNoteLabel: "Lý do từ chối",
            DismissNoteRequired: "Hãy nhập lý do từ chối",
            DismissConfirm: "Từ chối yêu cầu",
            Cancel: "Hủy",
            ResolveSuccess: "Yêu cầu đã được đánh dấu là đã xử lý",
            DismissSuccess: "Yêu cầu đã bị từ chối",
            Error: "Không thể xử lý yêu cầu",
            Source: {
              MerchantSelfService: "Đại lý",
              Admin: "Hỗ trợ",
              InitialOrder: "Đơn hàng",
            },
            Status: {
              Applied: "Đã áp dụng",
              Pending: "Đang chờ hỗ trợ",
              Resolved: "Đã xử lý",
              Dismissed: "Đã từ chối",
            },
          },
          Detail: {
            Title: "Chi tiết OrbitL Onboarding",
            CloseButton: "Đóng",
            ChecklistSection: "Danh sách kiểm tra",
            RejectionSection: "Lỗi Comgate",
            TerminalsSection: "Phân bổ thiết bị đầu cuối",
            CommentsSection: "Bình luận Comgate",
            NoTerminals: "Chưa có thiết bị đầu cuối nào được phân bổ",
            NoComments: "Chưa có bình luận nào",
            SendNoteLabel: "Gửi ghi chú đến Comgate",
            SendNoteButton: "Gửi",
            SendNotePlaceholder: "Nhập tin nhắn của bạn...",
            SendNoteSuccess: "Gửi bình luận thành công",
            SendNoteError: "Gửi bình luận thất bại",
            ResubmitButton: "Gửi lại cho Comgate",
            ResubmitConfirmTitle: "Xác nhận gửi lại",
            ResubmitConfirmText:
              "Thao tác này sẽ gửi lại dữ liệu và tài liệu của merchant đến Comgate. Hãy đảm bảo tất cả vấn đề đã được giải quyết trước khi tiếp tục. Trạng thái sẽ được đặt thành REQUESTED.",
            ResubmitConfirmButton: "Gửi lại",
            ResubmitCancelButton: "Hủy",
            ResubmitSuccess: "Gửi lại cho Comgate thành công",
            ResubmitError: "Gửi lại cho Comgate thất bại",
            CommentAuthor: "Tác giả",
            CommentDate: "Ngày",
            SwapTerminal: "Đổi",
            SwapTerminalTitle: "Đổi thiết bị đầu cuối",
            SwapTerminalSearch: "Tìm theo số sê-ri...",
            SwapTerminalConfirm: "Đổi thiết bị đầu cuối",
            SwapTerminalCancel: "Hủy",
            SwapTerminalSuccess: "Đổi thiết bị đầu cuối thành công",
            SwapTerminalSuccessWithCode:
              "Đã đổi thiết bị. Mã kích hoạt {{code}} sẵn sàng cho thiết bị mới",
            SwapTerminalError: "Không thể đổi thiết bị đầu cuối",
            SwapTerminalNoResults: "Không có thiết bị đầu cuối khả dụng",
            SwapTerminalTmsUpdateWarning:
              "Thiết bị đầu cuối đã được đăng ký trong Switchio TMS. Việc đổi số sê-ri cũng sẽ được áp dụng trong TMS.",
            TerminalStatusDeployed: "Đã đăng ký trong TMS",
            Tid: "TID",
            TidTypesSection: "Loại terminal (TID từ Comgate)",
            TidTypesHint:
              "Không xác định được loại của các TID này. Hãy chọn loại; các TID khác vẫn được đăng ký. TID vượt quá đơn hàng không thể chọn loại cho đến khi tăng số lượng terminal hoặc SoftPOS trong hợp đồng.",
            TidTypePhysical: "Terminal vật lý",
            TidTypeSoftPos: "SoftPOS",
            TidTypeUnknown: "Chưa xác định",
            TidTypeManual: "Thủ công",
            SaveTidTypes: "Lưu loại",
            SaveTidTypesSuccess: "Đã lưu loại TID",
            SaveTidTypesError: "Không lưu được loại TID",
            SaveTidTypesExceedError:
              "Loại đã chọn vượt quá số lượng trong hợp đồng (vật lý / SoftPOS). Hãy tăng số lượng trong hợp đồng trước.",
            RegisterTmsButton: "Chạy đăng ký TMS",
            RegisterTmsSuccess:
              "Đăng ký TMS: {{registered}}/{{expected}} terminal",
            RegisterTmsError: "Đăng ký TMS thất bại",
            ActivationCode: "Mã kích hoạt",
            ReactivateCodeButton: "Giải phóng mã cho thiết bị mới",
            ReactivateCodeSuccess:
              "Đã hủy liên kết thiết bị, mã kích hoạt có thể dùng lại",
            ReactivateCodeError: "Không thể hủy liên kết thiết bị",
          },
          FindByTerminal: {
            Button: "Tìm thiết bị đầu cuối",
            Title: "Tìm merchant theo thiết bị đầu cuối",
            SearchLabel: "Tìm theo TID hoặc số sê-ri...",
            NoResults: "Không tìm thấy thiết bị đầu cuối",
            Close: "Đóng",
          },
        },
      },
      Users: {
        VerificationCell: {
          AdditionalInfo: "Thông tin bổ sung",
          IdentityVerification: "Xác minh danh tính",
          RiskProfile: "Hồ sơ rủi ro",
          BankVerification: "Xác minh ngân hàng",
        },
        ExcludeAnonymous: "Loại trừ người dùng ẩn danh",
        Error:
          "Đã xảy ra lỗi không mong muốn khi tải danh sách người dùng. Vui lòng thử lại sau.",
        TableHeaders: {
          Verification: "Xác minh",
          Login: "Đăng nhập",
          Role: "Vai trò",
          Status: "Trạng thái",
          FirstName: "Tên",
          LastName: "Họ",
          Company: "Công ty",
          ClientIdentifier: "ID",
          DateCreated: "Ngày tạo",
          PaymentReference: "Mã thanh toán giấy phép",
          Version: "Phiên bản {{appName}}",
          DocumentExpiration: "Hạn giấy tờ",
          Settlement: "Quyết toán",
          Admin: "Quản trị",
        },
        Filters: {
          ExpiringWithin30Days: "Hết hạn trong 30 ngày",
          Expired: "Đã hết hạn",
        },
        ConnectedBankAccounts: {
          LoadingError: "Lỗi khi tải tài khoản ngân hàng đã kết nối.",
          NoBankAccounts: "Người dùng không có tài khoản ngân hàng đã kết nối.",
          UnassignedContext: "Chưa gán cho vai trò (kết nối cũ)",
        },
        ToBeVerified: {
          Subtitles: {
            UserVerification: "Người dùng cần xác minh",
            BankVerification: "Người dùng có tài khoản ngân hàng cần phê duyệt",
          },
          AdditionalInfo: "Thông tin bổ sung",
          RiskProfile: "Hồ sơ rủi ro",
          BankVerification: "Xác minh ngân hàng",
          IdentityVerification: "Xác minh danh tính",
        },
        RolesPermissions: {
          TableHeaders: {
            RoleName: "Tên vai trò",
            RoleCode: "Mã vai trò",
            AccessRightCode: "Quyền truy cập",
            CanRead: "Đọc",
            CanCreate: "Tạo",
            CanUpdate: "Cập nhật",
            CanDelete: "Xóa",
            CanExport: "Xuất",
          },
          NoAccessRights: "Không có quyền truy cập",
          AccessRightSingular: "quyền truy cập",
          AccessRightPlural: "quyền truy cập",
        },
      },
      Dashboard: {
        BankAccountsWidget: {
          Title: "Tài khoản đã kết nối",
          ConnectionFailed: "Không thể tải tài khoản đã kết nối.",
          NoActiveAccounts: "Không có tài khoản hoạt động để hiển thị.",
        },
        PreApprovalWidget: {
          Title: "Hạn mức phê duyệt trước",
          Description:
            "Cho đến khi chúng tôi xác minh đầy đủ tài khoản của bạn, các giới hạn sau sẽ được áp dụng:",
          LimitPerTransaction:
            "số tiền tối đa của một giao dịch <amount>{{amount}}</amount>",
          LimitTotal: "tổng hạn mức <amount>{{amount}}</amount>",
          Remaining: "Còn lại {{remaining}}",
        },
        TransactionFees: {
          Admin: {
            allTime: "Tổng thu nhập từ giao dịch",
            currentMonth: "Thu nhập tháng này",
            lastMonth: "Thu nhập tháng trước",
          },
        },
      },
      Welcome: {
        RegistrationSuccess:
          "Chúng tôi đã tạo tài khoản người dùng của bạn. Dưới đây bạn có thể đọc cách bắt đầu nhận lương bằng bitcoin.",
        UnverifiedAccountLimits:
          "Vì tài khoản của bạn chưa được xác minh, bạn có giới hạn giao dịch thấp. Có thể xác minh bổ sung sau trong hồ sơ của bạn.",
        TransactionLimitsLink: "Giới hạn giao dịch",
        Complete: "Hoàn thành",
      },
      AnonymousDashboard: {
        RegistrationRequired:
          "Vui lòng đăng ký để truy cập phiên bản đầy đủ của ứng dụng",
        Register: "Đăng ký",
      },
      Redeem: {
        Step1: "1. Cạo lớp phủ bằng đồng xu",
        Step2: "2. Sao chép mã 16 chữ số từ thẻ",
        NoCardYet: "Bạn chưa có thẻ? Bạn có thể mua",
      },
      RedeemPublic: {
        Step1: "1. Cạo lớp phủ bằng đồng xu",
        Step2: "2. Sao chép mã 16 chữ số từ thẻ",
      },
      LeadInvitation: {
        Description:
          "Nhập e-mail của bạn bè mà bạn muốn mời. Nếu bạn bè của bạn sử dụng tài khoản tích cực, bạn sẽ nhận được phần thưởng cho họ!",
      },
      ColdWallet: {
        WithdrawalTitle: "Rút tiền từ ví hệ thống:",
        DepositTitle: "Nạp tiền vào ví hệ thống:",
        GenerateAddress: "Tạo địa chỉ hệ thống mới",
      },
      SystemReport: {
        HotWallet: "+ Đến Hot Wallet",
        ColdWallet: "+ Đến Cold Wallet",
        ExchangeWithdrawal: " + Đến rút tiền sàn ",
        UserAccounts: "- Đến tài khoản người dùng",
        ControlSum: "Tổng kiểm soát",
        SystemWalletWithdrawal: "Rút tiền từ ví hệ thống",
        ExchangeWithdrawalFee: "Phí rút tiền sàn",
        BalanceOnExchange: "Số dư {{currencyCode}} trên sàn",
        TradingVolume: "Khối lượng giao dịch",
        PerMonth: "Mỗi tháng",
        PerWeek: "Mỗi tuần",
        PurchasedBTC: "BTC đã mua",
        WithdrawnOrPending: "Đã rút hoặc đang chờ",
        BTCLedgerSum: "Tổng sổ cái BTC",
        CZKLedgerSum: "Tổng sổ cái CZK",
        SystemVersion: "Phiên bản hệ thống: {{version}}",
      },
      BankingAuth: {
        BankListTitle: "Danh sách ngân hàng",
        BanksInPreparation: "Ngân hàng đang chuẩn bị",
      },
      Account: {
        ProfileError:
          "Chúng tôi xin lỗi, đã xảy ra lỗi không mong muốn khi hiển thị hồ sơ của bạn, vui lòng thử lại sau.",
      },
      Error403: {
        Logout: "Đăng xuất",
      },
      CustomerAnonymousPaymentPay: {
        SignIn: "Đăng nhập.",
        ConfirmBox: {
          Title: "Biên lai đã được gửi đến e-mail của bạn",
          Description:
            "Bạn muốn thanh toán chỉ với một chạm lần sau và có tất cả thanh toán ở một nơi? Tạo tài khoản {{appName}} của riêng bạn, sẽ rất dễ dàng! 🚀",
          CreateAccountButton: "Tạo tài khoản",
          CloseButton: "Đóng",
        },
        TermsAgreement: {
          text: "Bằng cách nhấp vào nút thanh toán, bạn đồng ý với",
          link: "{{apiUrl}}/content/terms/1-one-time-payment-docs.pdf",
          linkText: "Điều khoản dịch vụ AIS và PIS",
        },
        Steps: {
          detail: "Chào mừng đến với {{appName}}",
          bank: "Kết nối ngân hàng",
          account: "Thanh toán với {{appName}}",
        },
        BankSelection: {
          InfoBox:
            'Chọn ngân hàng để thanh toán qua {{appName}} theo "Đánh giá ngân hàng" của chúng tôi.',
          WarningBox:
            "Cảnh báo: Chất lượng kết nối phụ thuộc vào ngân hàng. Nếu bạn gặp vấn đề với đăng nhập hoặc thanh toán, hãy liên hệ ngân hàng của bạn.",
        },
        AccountSelection: {
          InfoBox:
            "Ủy quyền thanh toán với ngân hàng của bạn. Trong trường hợp gặp vấn đề ủy quyền, hãy liên hệ ngân hàng của bạn.",
        },
      },
      NotificationsManagement: {
        NewNotification: "Thông báo mới",
        PlannedNotifications: "Thông báo đã lên lịch",
        SentNotifications: "Thông báo đã gửi",
        DisabledNotifications: "Thông báo đã tắt",
        NoNotifications: "Không có thông báo",
      },
      NotificationForm: {
        Name: "Tên",
        Description: "Mô tả",
        NotificationType: "Loại thông báo",
        Duration: {
          FromDate: "Ngày đăng",
          FromTime: "Thời gian đăng",
          ToDate: "Ngày ẩn",
          ToTime: "Thời gian ẩn",
        },
        DurationType: {
          Dismiss: "Cho đến khi người dùng tắt",
          Period: "Trong một khoảng thời gian",
        },
        DurationPrompt: "Thông báo nên hiển thị trong bao lâu?",
        Filters: {
          Banks: "Chỉ cho ngân hàng:",
          UserTypes: "Chỉ cho người dùng:",
          BanksPlaceholder: "Không lọc ngân hàng",
          UserTypesPlaceholder: "Không lọc người dùng",
        },
        Link: "Liên kết",
        Create: "tạo",
        Preview: "Xem trước",
      },
      Settlements: {
        Error:
          "Đã xảy ra lỗi không mong muốn khi tải danh sách quyết toán. Vui lòng thử lại sau.",
        SettlementTrigger: "Bắt đầu quyết toán phí cho kỳ hiện tại.",
        SettlementTriggerError:
          "Đã xảy ra lỗi khi kích hoạt quyết toán. Vui lòng thử lại sau.",
        SettlementTriggerSuccess: "Quyết toán đã được kích hoạt thành công.",
        SettlementTriggerLoading: "Đang bắt đầu quyết toán...",
        SettlementTriggerButtonText: "Bắt đầu quyết toán",
      },
    },
  },
  Sentry: {
    FormTitle: "Báo cáo lỗi",
    NameLabel: "Tên",
    EmailLabel: "E-mail",
    MessageLabel: "Mô tả lỗi",
    MessageCharCount: "{{count}} / {{maxCount}}",
    CancelButtonLabel: "Hủy",
    SubmitButtonLabel: "Gửi",
    NamePlaceholder: "Tên của bạn",
    EmailPlaceholder: "E-mail của bạn",
    MessagePlaceholder: "Mô tả lỗi",
    SuccessMessageText: "Cảm ơn bạn đã báo cáo lỗi.",
    ErrorMessageText: "Không thể gửi báo cáo. Vui lòng thử lại.",
    Validation: {
      MessageRequired: "Vui lòng mô tả lỗi.",
      MessageTooShort: "Mô tả phải có ít nhất {{minLength}} ký tự.",
      EmailInvalid: "Hãy nhập e-mail hợp lệ.",
    },
  },
  Support: {
    ButtonLabel: "Hỗ trợ",
    Contact: {
      PhoneNumber: "+420 226 633 296",
      Email: "info@mo.one",
      HunterEmail: "info@legi.one",
    },
    Choice: {
      Title: "Liên hệ với chúng tôi",
      Description:
        "Vui lòng mô tả yêu cầu hoặc sự cố của bạn càng chính xác càng tốt, điều đó giúp chúng tôi phản hồi bạn sớm hơn.",
      TechnicalProblemButton: "Sự cố kỹ thuật",
      TechnicalProblemDescription:
        "Ứng dụng bị lỗi, thanh toán thất bại, trang không tải được. Được chuyển tới bộ phận kỹ thuật.",
      TechnicalProblemUnavailable:
        "Báo cáo lỗi hiện không khả dụng. Vui lòng gửi yêu cầu hỗ trợ.",
      SupportRequestButton: "Yêu cầu hỗ trợ",
      SupportRequestDescription:
        "Thanh toán, tài khoản, đơn hàng, cách một tính năng hoạt động. Được bộ phận hỗ trợ khách hàng trả lời.",
      UrgentHelp: "Bạn đang gấp?",
      CallPhone: "Gọi {{phoneNumber}}",
    },
    Request: {
      Title: "Yêu cầu hỗ trợ",
      CategoryLabel: "Loại yêu cầu",
      CategoryPlaceholder: "Chọn loại yêu cầu",
      SubjectLabel: "Tiêu đề yêu cầu",
      DescriptionLabel: "Mô tả",
      DescriptionCharCount: "{{count}} / {{maxCount}}",
      AttachmentLabel: "Tệp đính kèm",
      AttachmentPlaceholder: "Tải tệp lên",
      AttachmentRemove: "Xóa tệp đính kèm",
      NameLabel: "Họ và tên",
      EmailLabel: "E-mail",
      SubmitButton: "Gửi",
      CancelButton: "Hủy",
      Categories: {
        ClientOnboarding: "Tiếp nhận khách hàng",
        CommissionsAndPayouts: "Hoa hồng và chi trả",
        ValorPoints: "Điểm Valor",
        TechnicalIssues: "Sự cố kỹ thuật (đăng nhập / ứng dụng)",
        StardustPoints: "Điểm Stardust",
        PaymentIssues: "Vấn đề thanh toán",
        AccountAndSignIn: "Đăng nhập và quản lý tài khoản",
        TransactionComplaints: "Khiếu nại giao dịch",
        HardwareAndConnectivity: "Thiết bị và kết nối",
        FinanceAndSettlement: "Tài chính và quyết toán",
        AccountAdministration: "Hành chính và quản lý tài khoản",
        Other: "Khác",
      },
      Validation: {
        CategoryRequired: "Hãy chọn loại yêu cầu.",
        SubjectRequired: "Hãy nhập tiêu đề yêu cầu.",
        DescriptionRequired: "Hãy nhập mô tả.",
        DescriptionTooShort: "Mô tả phải có ít nhất {{minLength}} ký tự.",
        NameRequired: "Hãy nhập họ và tên.",
        EmailRequired: "Hãy nhập e-mail.",
        EmailInvalid: "Hãy nhập e-mail hợp lệ.",
        AttachmentTooLarge: "Tệp có kích thước tối đa {{maxSizeMb}} MB.",
        AttachmentTypeNotSupported: "Định dạng hỗ trợ là PNG, JPG và PDF.",
      },
      SuccessMessage:
        "Yêu cầu của bạn đã được gửi. Chúng tôi sẽ phản hồi sớm nhất có thể.",
      ErrorMessage: "Không thể gửi yêu cầu. Vui lòng thử lại.",
      RateLimitedMessage:
        "Bạn đã gửi quá nhiều yêu cầu. Vui lòng thử lại sau ít phút.",
    },
    ContentReport: {
      Title: "Báo cáo nội dung",
      PickerButton: "Báo cáo hồ sơ hoặc tin nhắn",
      PickerDescription:
        "Hồ sơ hoặc tin nhắn vi phạm pháp luật hoặc điều khoản của chúng tôi. Được đội ngũ Mo.one xem xét theo Đạo luật Dịch vụ Kỹ thuật số (DSA).",
      TargetProfile: "Bạn đang báo cáo hồ sơ {{user}}.",
      TargetMessage: "Bạn đang báo cáo một tin nhắn từ {{user}}.",
      HandleLabel: "Tên người dùng của hồ sơ bạn báo cáo",
      HandlePlaceholder: "ví dụ: nguyen.van.a",
      MessageHint:
        "Để báo cáo một tin nhắn trong trò chuyện, hãy mở menu của tin nhắn đó và chọn Báo cáo.",
      CategoryLabel: "Lý do báo cáo",
      CategoryPlaceholder: "Chọn lý do",
      ExplanationLabel: "Giải thích",
      ExplanationHelper:
        "Hãy mô tả càng chính xác càng tốt nội dung này có vấn đề gì – nội dung chứa gì và, nếu bạn cho rằng nó bất hợp pháp, vi phạm luật nào.",
      NameLabel: "Họ và tên",
      EmailLabel: "E-mail",
      ContactOptionalNote:
        "Báo cáo về lạm dụng tình dục trẻ em có thể được gửi ẩn danh. Nếu không có e-mail, chúng tôi không thể thông báo kết quả cho bạn.",
      BonaFideLabel:
        "Tôi xác nhận rằng, theo hiểu biết tốt nhất của mình, thông tin và cáo buộc trong báo cáo này là chính xác và đầy đủ.",
      LegalNote:
        "Bạn sẽ nhận được xác nhận đã tiếp nhận và quyết định của chúng tôi qua e-mail. Báo cáo được xử lý theo Điều 16 Quy định (EU) 2022/2065 (DSA).",
      SubmitButton: "Gửi báo cáo",
      CancelButton: "Hủy",
      Categories: {
        ChildSexualAbuse: "Lạm dụng tình dục trẻ em",
        ThreatsOrViolence: "Đe dọa, bạo lực hoặc khủng bố",
        HateSpeech: "Phát ngôn thù hận",
        FraudOrScam: "Lừa đảo hoặc gian lận",
        Impersonation: "Mạo danh",
        PersonalDataOrPrivacy: "Lạm dụng dữ liệu cá nhân hoặc quyền riêng tư",
        IntellectualProperty: "Vi phạm bản quyền hoặc nhãn hiệu",
        OtherIllegal: "Nội dung bất hợp pháp khác",
        HarassmentOrBullying: "Quấy rối hoặc bắt nạt",
        SpamOrUnwantedContact: "Spam hoặc liên hệ không mong muốn",
        OtherTermsViolation: "Vi phạm điều khoản khác",
      },
      Validation: {
        CategoryRequired: "Hãy chọn lý do báo cáo.",
        HandleRequired: "Nhập tên người dùng của hồ sơ bạn báo cáo.",
        ExplanationRequired: "Nhập phần giải thích.",
        ExplanationTooShort:
          "Phần giải thích phải có ít nhất {{minLength}} ký tự.",
        NameRequired: "Nhập họ và tên của bạn.",
        EmailRequired: "Nhập e-mail của bạn.",
        EmailInvalid: "Nhập e-mail hợp lệ.",
        BonaFideRequired: "Không thể gửi báo cáo nếu thiếu xác nhận này.",
      },
      SuccessMessage:
        "Báo cáo của bạn đã được tiếp nhận. Chúng tôi sẽ xem xét không chậm trễ và thông báo kết quả cho bạn qua e-mail.",
      SuccessMessageWithReference:
        "Báo cáo của bạn đã được tiếp nhận với mã tham chiếu {{referenceNumber}}. Xác nhận đang được gửi tới e-mail của bạn; chúng tôi sẽ thông báo kết quả.",
      ErrorMessage: "Không thể gửi báo cáo. Vui lòng thử lại.",
      NotFoundMessage:
        "Chúng tôi không tìm thấy hồ sơ này. Hãy kiểm tra lại tên người dùng.",
      SelfReportMessage: "Bạn không thể báo cáo nội dung của chính mình.",
      RateLimitedMessage:
        "Bạn đã gửi quá nhiều báo cáo. Vui lòng thử lại sau ít phút.",
    },
    Result: {
      ErrorTitle: "Đã xảy ra lỗi",
    },
  },
  Employee: {
    Create: {
      Title: "Thêm nhân viên",
      CreateButton: "Thêm nhân viên",
      CreateError: "Đã xảy ra lỗi khi tạo nhân viên.",
      CreateSuccess: "Nhân viên đã được tạo",
      MissingMerchantID: "Lỗi - Mã điểm thanh toán không khả dụng.",
      Legend: "Nhân viên mới",
    },
    EmployeeStatus: {
      Inactive: "Không hoạt động",
      InvitedWaitingForConfirmation: "Đã mời, đang chờ xác nhận",
      Active: "Hoạt động",
      Created: "Đã tạo",
    },
    Detail: {
      Title: "Chi tiết nhân viên",
      NoEmployeeSelectedError:
        "Lỗi - Nhân viên chưa được chọn hoặc không tồn tại",
      EmployeeNotFoundError: "Lỗi - Nhân viên không tồn tại",
      SendAccess: "Gửi quyền truy cập",
      CancelInvitation: "Hủy lời mời",
      CancelInvitationConfirmText:
        "Lời mời sẽ bị thu hồi và nhân viên sẽ không thể chấp nhận nữa. Bạn có thể gửi lời mời mới bất cứ lúc nào.",
      RemoveEmployee: "Xóa nhân viên",
      RemoveEmployeeConfirmText:
        "Nhân viên sẽ mất quyền truy cập vào công ty của bạn và không thể chuyển sang ngữ cảnh nhân viên nữa. Hồ sơ vẫn nằm trong danh sách ở trạng thái không hoạt động và bạn có thể gửi lại quyền truy cập bất cứ lúc nào.",
      RemovedInfo: "Nhân viên này đã bị xóa. Gửi quyền truy cập để mời lại.",
      SaveError: "Đã xảy ra lỗi khi lưu nhân viên.",
      SaveSuccess: "Nhân viên đã được lưu thành công.",
      AccessSent: "Quyền truy cập đã được gửi",
    },
    List: {
      LoadingError: "Không thể tải danh sách nhân viên.",
      AddEmployee: "Thêm nhân viên",
      FilterLabels: {
        Created: "Đã tạo",
        InvitedWaitingForConfirmation: "Đã gửi quyền truy cập",
        Active: "Hoạt động",
        Inactive: "Không hoạt động",
      },
    },
    Dashboard: {
      Title: "Bảng điều khiển",
    },
    KeypadPayment: {
      Title: "Thanh toán bàn phím",
      ComingSoon: "Chúng tôi đang chuẩn bị thanh toán bàn phím.",
    },
  },
  TransactionErrors: {
    UnknownError: "Đã xảy ra lỗi không xác định khi xử lý giao dịch",
    UnknownPaymentError: "Lỗi không xác định trong quá trình thanh toán",
    TransactionNotFound: "Giao dịch không tồn tại hoặc không khả dụng",
    BankTemporarilyUnavailable:
      "Ngân hàng tạm thời không khả dụng, vui lòng thử lại sau ít phút.",
    BankConnectionExpired:
      "Kết nối với ngân hàng đã hết hạn, vui lòng kết nối lại tài khoản.",
    InsufficientBalance: "Số dư tài khoản không đủ",
    BalanceVerificationFailed: "Không thể xác minh số dư tài khoản",
    SameAccountError: "Tài khoản người gửi và người nhận không thể giống nhau",
    InvalidAccountCurrency: "Loại tiền tài khoản không hợp lệ",
    InvalidTransactionCurrency: "Loại tiền giao dịch không hợp lệ",
    TransactionTypeNotAllowed:
      "Giao dịch cho loại tài khoản này không được phép",
    TransactionLimitExceeded: "Vượt quá giới hạn giao dịch",
    UnspecifiedError: "Đã xảy ra lỗi không xác định.",
    TransactionProcessingFailed:
      "Không thể xử lý giao dịch, hoặc giao dịch đã được thanh toán",
    UnspecifiedPaymentError: "Đã xảy ra lỗi không xác định",
    BankAccount: "Chưa đặt tài khoản ngân hàng chính",
    User: "Người dùng {{appName}} Lite chỉ có thể gửi thanh toán cho điểm thanh toán",
    InvalidBankAccountForReceivingPayment:
      "Tài khoản ngân hàng được chọn không thể nhận thanh toán",
    ActiveTransactionExists:
      "Đã có giao dịch đang hoạt động trên điểm thanh toán này. Vui lòng đợi giao dịch hoàn thành trước khi khởi tạo giao dịch mới.",
    AuthLimitExceeded: "Vượt quá giới hạn ủy quyền",
    InvalidJsonFormat: "Định dạng JSON không hợp lệ",
    GeneralRejection: "Từ chối chung",
    NotUniqueTransactionReference: "Mã tham chiếu giao dịch không duy nhất",
    InvalidCharacterSet: "Bộ ký tự không hợp lệ",
    InvalidAccountNumber: "Số tài khoản không hợp lệ",
    FieldInvalid: "Giá trị trường không hợp lệ",
    FieldMissing: "Thiếu trường bắt buộc",
    TransactionAmountForbidden: "Số tiền giao dịch bị cấm",
    AccountInvalid: "Tài khoản người nhận hoặc người gửi không hợp lệ",
    TransactionDecimalNumbersForbidden: "Số chữ số thập phân bị cấm",
    InvalidDate: "Ngày không hợp lệ",
    TransactionInvalidIBAN: "IBAN người nhận không hợp lệ",
    InstantPaymentsNotAvailable: "Thanh toán tức thì không khả dụng",
    TransactionNotSignable: "Giao dịch không thể được ủy quyền",
    DebtorBankAccountForbidden:
      "Tài khoản người gửi không được phép cho giao dịch này.",
    PaymentLimitExceeded:
      "Thanh toán không thành công – đã vượt quá hạn mức của tài khoản.",
    PaymentRejectedByBank: "Ngân hàng đã từ chối thanh toán.",
    PaymentCancelledByUser: "Thanh toán chưa được xác nhận tại ngân hàng.",
    PaymentExpired: "Thanh toán không được hoàn tất kịp thời và đã bị hủy.",
    PaymentUnauthorized:
      "Ngân hàng không ủy quyền thanh toán. Vui lòng kết nối lại tài khoản và thử lại.",
    PaymentTechnicalError:
      "Thanh toán không thành công do lỗi kỹ thuật. Vui lòng thử lại hoặc liên hệ bộ phận hỗ trợ.",
    DebtorCreditorAccountIdentical:
      "Tài khoản người nhận và người trả là cùng một tài khoản",
    TransactionLimits: {
      generatedTransactionLimitExceeded:
        "Thanh toán được tạo vượt quá giới hạn cho 1 giao dịch.",
      oneTimeSendLimitExceeded: "Số tiền vượt quá giới hạn cho 1 giao dịch.",
      dailySendLimitExceeded: "Số tiền giao dịch vượt quá giới hạn hàng ngày.",
      generatedDailySendLimitExceeded:
        "Số tiền giao dịch được tạo vượt quá giới hạn hàng ngày.",
      monthlySendLimitExceeded:
        "Số tiền giao dịch vượt quá tổng giới hạn hàng tháng.",
      generatedMonthlySendLimitExceeded:
        "Số tiền giao dịch được tạo vượt quá giới hạn hàng tháng.",
      generatedTransactionLimitExceededIncompleteRegistration:
        "Thanh toán được tạo vượt quá giới hạn cho 1 giao dịch. Vui lòng hoàn thành đăng ký.",
      oneTimeSendLimitExceededIncompleteRegistration:
        "Số tiền vượt quá giới hạn cho 1 giao dịch. Vui lòng hoàn thành đăng ký.",
      dailySendLimitExceededIncompleteRegistration:
        "Số tiền giao dịch vượt quá giới hạn hàng ngày. Vui lòng hoàn thành đăng ký.",
      generatedDailySendLimitExceededIncompleteRegistration:
        "Số tiền giao dịch được tạo vượt quá giới hạn hàng ngày. Vui lòng hoàn thành đăng ký.",
      monthlySendLimitExceededIncompleteRegistration:
        "Số tiền giao dịch vượt quá giới hạn hàng tháng. Vui lòng hoàn thành đăng ký.",
      generatedMonthlySendLimitExceededIncompleteRegistration:
        "Số tiền giao dịch được tạo vượt quá giới hạn hàng tháng. Vui lòng hoàn thành đăng ký.",
      oneTimeReceiveLimitExceededPreApproval:
        "Khoản thanh toán vượt quá giới hạn cho mỗi lần thanh toán trong thời gian phê duyệt trước.",
      cumulativeReceiveLimitExceededPreApproval:
        "Khoản thanh toán sẽ vượt quá tổng số tiền bạn có thể nhận trong thời gian phê duyệt trước. Bạn sẽ có thể nhận thêm sau khi tài khoản ngân hàng của bạn được xác minh.",
      currencyNotSupportedPreApproval:
        "Trong thời gian phê duyệt trước, bạn chỉ có thể nhận thanh toán bằng CZK. Bạn sẽ có thể nhận các loại tiền tệ khác sau khi tài khoản ngân hàng của bạn được xác minh.",
      unspecifiedError: "Đã xảy ra lỗi không xác định.",
    },
    Status: "Giao dịch đã bị hủy.",
    TransactionAlreadyCompleted: "Giao dịch này đã được hoàn thành.",
    TransactionCancelled: "Giao dịch này đã bị hủy.",
    TransactionExpired:
      "Thanh toán đã hết hạn. Vui lòng yêu cầu người nhận tạo thanh toán mới.",
    TransactionNotFoundOrNotAccessible:
      "Giao dịch {{transactionPublicID}} không tồn tại hoặc không khả dụng.",
  },
  Campaigns: {
    Campaign: {
      DefaultHeader: "Ủng hộ chiến dịch này",
      DefaultLearnMore: "Tìm hiểu thêm",
      DonationForm: {
        AmountLabel: "Nhập số tiền quyên góp",
        AmountRequired: "Nhập số tiền",
        AmountMin: "Số tiền phải tối thiểu {{minAmount}} {{currencySymbol}}",
        SubmitButton: "Quyên góp",
        TransactionError: "Không thể tạo giao dịch. Vui lòng thử lại.",
      },
      Page: {
        Loading: "Đang tải...",
        CampaignNotFound: "Không tìm thấy chiến dịch",
        CampaignNotFoundMessage:
          "Chiến dịch không tìm thấy hoặc không còn khả dụng.",
        StatusNotStarted: "Chiến dịch chưa bắt đầu",
        StatusNotStartedWithDate:
          "Chiến dịch này sẽ bắt đầu vào {{date}}. Vui lòng quay lại để quyên góp.",
        StatusNotStartedWithoutDate: "Chiến dịch này chưa bắt đầu.",
        StatusFinished: "Chiến dịch đã kết thúc",
        StatusFinishedWithDate:
          "Chiến dịch này đã kết thúc vào {{date}}. Cảm ơn bạn đã quan tâm!",
        StatusFinishedWithoutDate:
          "Chiến dịch này đã kết thúc. Cảm ơn bạn đã quan tâm!",
        EndsOn: "Kết thúc vào {{date}}",
        DonationsNotAvailable: "Quyên góp không khả dụng tại thời điểm này.",
      },
      CreateAccountButton: "TẠO TÀI KHOẢN CHỈ VỚI MỘT CLICK",
      InfoCards: {
        HelpingNeedy: {
          Title: "Giúp đỡ những người cần",
          Description:
            "Chúng tôi đang dần bổ sung các tổ chức mà chúng tôi hỗ trợ với {{appName}}.",
        },
        TestingPayment: {
          Title: "Thử nghiệm phương thức thanh toán",
          Description:
            "Bạn sẽ giúp thử nghiệm phương thức thanh toán mới của công ty Séc {{appName}}, giúp giữ tiền ở Cộng hòa Séc.",
        },
        CreateAccountAndHelp: {
          Title: "Tạo tài khoản và giúp đỡ",
          Description:
            "Tạo tài khoản, thanh toán với {{appName}} và chúng tôi sẽ đóng góp cho tổ chức bạn chọn cho mỗi khoản thanh toán của bạn.",
        },
      },
      TimelineSteps: {
        Donate: {
          Title: "Quyên góp bất kỳ số tiền nào cho tổ chức đã chọn",
        },
        JoinTeam: {
          Title: "Tạo tài khoản và tham gia đội {{campaignName}}!",
          Description:
            "Bằng cách tạo tài khoản, bạn có thể thanh toán với {{appName}}, tham gia cuộc thi Stardust và giúp đội {{campaignName}}.",
        },
        PayAtCafe: {
          Title: "Thanh toán với {{appName}} tại quán cà phê yêu thích của bạn",
          Description: "THÊM VĂN BẢN SAU",
        },
        AnyMethod: {
          Title: "Tiền mặt, thẻ? Chỉ với {{appName}}!",
          Description: "THÊM VĂN BẢN SAU",
        },
      },
    },
  },
  Notifications: {
    Variants: {
      Critical: "Cảnh báo nghiêm trọng",
      Error: "Lỗi",
      Announcement: "Thông báo",
      Completed: "Hoàn thành",
      Stardust: "Stardust/Valor",
      Raffle: "Quay số trúng thưởng",
    },
  },
  UserMenu: {
    MooneLiteInfo:
      "Nếu bạn đã đăng ký, {{appName}} sẽ thanh toán cho các khoản thanh toán của bạn.",
    ManageAccount: "Quản lý tài khoản {{appName}}",
    Invitations: "Lời mời",
    Logout: "Đăng xuất",
    Rewards: {
      TotalRewards: "Tổng phần thưởng",
      TotalStardust: "Tổng Stardust",
      TotalValor: "Tổng Valor",
      MyShare: "Phần của tôi",
      OpenRewardsDetails: "Mở chi tiết phần thưởng",
    },
    Notifications: {
      Title: "Thông báo",
      NoNewNotifications: "Không có thông báo mới",
      NoNotifications: "Không có thông báo",
      Today: "Hôm nay",
      Yesterday: "Hôm qua",
      Older: "Cũ hơn",
      ShowAll: "Tất cả thông báo",
      DeleteAll: "Bỏ qua tất cả",
    },
  },
  Raffle: {
    Notifications: {
      Title: "Quay số trúng thưởng",
      Registration: "Bạn nhận được {{count}} vé quay số vì hoàn tất đăng ký.",
      Registration_other:
        "Bạn nhận được {{count}} vé quay số vì hoàn tất đăng ký.",
      Referral:
        "Bạn nhận được {{count}} vé quay số — người bạn mời đã hoàn tất đăng ký.",
      Referral_other:
        "Bạn nhận được {{count}} vé quay số — người bạn mời đã hoàn tất đăng ký.",
      Payment:
        "Bạn nhận được {{count}} vé quay số cho một giao dịch tại cửa hàng.",
      Payment_other:
        "Bạn nhận được {{count}} vé quay số cho một giao dịch tại cửa hàng.",
    },
    Dashboard: {
      Title: "Quay số trúng thưởng",
      TicketCount: "Vé số của bạn",
      DrawDate: "Quay số",
      DateToBeAnnounced: "Ngày sẽ được thông báo",
      ShowDetail: "Xem chi tiết",
      CompetitionsRunning: "Đang diễn ra {{count}} cuộc thi",
      CompetitionsRunning_other: "Đang diễn ra {{count}} cuộc thi",
    },
    Page: {
      Title: "Quay số trúng thưởng",
      NotRunning: "Hiện không có đợt quay số nào diễn ra.",
      LoadError: "Không thể tải thông tin quay số.",
      MainDraw: "Quay số chính",
      MyTickets: "Vé của bạn",
      MoveTickets: "Chuyển vé",
      DrawDate: "Ngày quay số",
      Rewards: "Giải thưởng",
      History: "Các đợt quay số trước",
      HistoryEmpty: "Bạn chưa tham gia đợt quay số nào.",
      HistoryTickets: "{{count}} vé",
      HistoryTickets_other: "{{count}} vé",
      Drawn: "Đã quay số",
    },
    MoveDialog: {
      Title: "Chuyển vé",
      TargetLabel: "Vào cuộc thi",
      CountLabel: "Số lượng vé",
      CountHelper: "Nhập số từ 1 đến {{max}}",
      Submit: "Chuyển",
      MovedToast: "Đã chuyển {{count}} vé",
      MovedToast_other: "Đã chuyển {{count}} vé",
      MoveError: "Chuyển vé không thành công",
      NothingMoved:
        "Không có vé nào được chuyển — vé của bạn đã thay đổi trong lúc đó.",
      CompetitionsChanged:
        "Các cuộc thi đã thay đổi trong lúc đó — không có vé nào được chuyển. Hãy kiểm tra trạng thái hiện tại.",
    },
  },
  Chat: {
    Title: "{{appName}} Chat",
    FindPeople: "Tìm người",
    ReadBy: "Đã xem: {{count}}",
    SelectConversation: "Chọn cuộc trò chuyện",
    ClosedConversation: "Cuộc trò chuyện này đã đóng.",
    Unavailable: "Trò chuyện hiện chưa khả dụng cho tài khoản của bạn.",
    DisclosedNamesUnavailable:
      "Không thể tải tên – một số người có thể tạm thời hiển thị dưới dạng @handle.",
    BackToDashboard: "Quay lại {{appName}}",
    PushNotifications: {
      DeviceToggleLabel: "Thông báo trò chuyện trên thiết bị này",
      DeviceToggleDescription:
        "Nhận thông báo về tin nhắn mới ngay cả khi ứng dụng đã đóng.",
      DeniedHint:
        "Thông báo cho {{appName}} đang tắt. Hãy bật trong cài đặt hệ thống.",
    },
    Thread: {
      Title: "Chuỗi trả lời",
    },
    FindInConversation: {
      MenuItem: "Tìm trong cuộc trò chuyện",
      Placeholder: "Tìm trong cuộc trò chuyện này",
      Counter: "{{current}} / {{total}}",
      NoMatches: "Không có kết quả",
      Older: "Kết quả cũ hơn",
      Newer: "Kết quả mới hơn",
      Close: "Đóng tìm kiếm",
      JumpError: "Không thể chuyển đến tin nhắn, vui lòng thử lại",
      SearchError: "Tìm kiếm không thành công",
    },
    HandleGate: {
      Title: "Chọn biệt danh",
      Description:
        "Người khác trong Trò chuyện sẽ tìm và nhắn tin cho bạn qua biệt danh này.",
    },
    Reactions: {
      Title: "Cảm xúc",
    },
    PhoneGate: {
      Title: "Xác minh số điện thoại",
      DescriptionVerify:
        "Để sử dụng trò chuyện, vui lòng xác minh số điện thoại của bạn. Điều này giúp bảo vệ trò chuyện khỏi thư rác và tài khoản giả.",
      DescriptionAdd:
        "Để sử dụng trò chuyện, vui lòng thêm và xác minh số điện thoại của bạn. Điều này giúp bảo vệ trò chuyện khỏi thư rác và tài khoản giả.",
      PhoneLabel: "Số điện thoại",
      SendCode: "Gửi mã",
      CodeSent: "Mã đã gửi đến {{phone}}",
      Verify: "Xác minh",
      EditPhone: "Đổi số điện thoại",
      ResendCode: "Gửi lại mã",
      SmsFailed: "Không thể gửi mã xác minh",
      TooManyAttempts: "Quá nhiều lần thử, vui lòng thử lại sau",
      WrongCode: "Mã sai. Vui lòng yêu cầu mã mới.",
      VerifySuccess: "Số điện thoại đã được xác minh thành công",
    },
    Layout: {
      SearchPlaceholder: "Tìm kiếm...",
    },
    Categories: {
      All: "Tất cả",
      Mutual: "Lẫn nhau",
      Shopping: "Mua sắm",
      Merchants: "Người bán",
      Groups: "Nhóm",
      Requests: "Yêu cầu",
    },
    NoChannels: "Chưa có gì ở đây",
    NoSearchResults: "Không có cuộc trò chuyện nào khớp với tìm kiếm của bạn",
    NewChat: {
      Title: "Cuộc trò chuyện mới",
      DirectTitle: "Trò chuyện mới",
      CreateGroupWith: "Tạo cuộc trò chuyện nhóm với {{name}}",
      GroupTitle: "Cuộc trò chuyện nhóm mới",
      OpenError: "Không thể mở cuộc trò chuyện. Vui lòng thử lại.",
      PrivateSenderNotice:
        "Hồ sơ của bạn ở chế độ riêng tư – người bạn nhắn tin sẽ thấy tên của bạn.",
      RemoveMember: "Xóa {{name}}",
      SearchPlaceholder: "Tìm theo @handle hoặc tên",
      MembersLabel: "Thành viên",
      SuggestionsLabel: "Gợi ý",
      ResultsLabel: "Kết quả tìm kiếm",
      EligibilityLabel: "Ai có thể tham gia",
      EligibilityAnyone: "Bất kỳ ai (Moone Lite và Full Moone)",
      EligibilityFullMooneOnly: "Chỉ người dùng đã xác minh (Full Moone)",
      FullMooneOnlyBadge: "Chỉ người dùng đã xác minh",
      CreateError: "Không thể tạo nhóm. Vui lòng thử lại.",
      CreateIneligibleMemberError:
        "Một người bạn đã chọn chưa phải là người dùng đã xác minh (Full Moone) và không thể tham gia nhóm chỉ dành cho người đã xác minh.",
      CreateNoHandleMemberError:
        "Một người bạn đã chọn không sử dụng Chat (chưa có biệt danh) nên không thể thêm vào nhóm.",
      IneligibleSelectedWarning:
        "Những người bị làm mờ chưa phải là người dùng đã xác minh (Full Moone) và không thể tham gia nhóm chỉ dành cho người đã xác minh. Hãy xóa họ hoặc cho phép bất kỳ ai tham gia.",
      CustomerSelectedWarning:
        "Những người bị làm mờ là khách hàng. Người bán và hunter không thể bắt đầu trò chuyện với khách hàng hoặc thêm họ vào nhóm; khách hàng cần liên hệ với bạn trước. Hãy xóa họ để tiếp tục.",
      NoHandleSelectedWarning:
        "Những người bị làm mờ chưa sử dụng Chat (chưa có biệt danh), nên không thể thêm họ vào cuộc trò chuyện. Hãy xóa họ để tiếp tục.",
      GroupNameLabel: "Tên nhóm",
      ChannelNamePlaceholder: "Tên cuộc trò chuyện (tùy chọn)",
      NoResults: "Không tìm thấy kết quả",
      UnknownUser: "Người dùng không xác định",
      Cancel: "Hủy",
      Create: "Tạo",
    },
    Members: {
      Title: "Thành viên",
      You: "Bạn",
      AddTitle: "Thêm thành viên",
      Add: "Thêm",
      Cancel: "Hủy",
      AddError: "Không thể thêm thành viên",
      Remove: "Xóa",
      RemoveError: "Không thể xóa thành viên",
      Owner: "Chủ sở hữu",
      AlreadyMember: "Đã là thành viên",
      NotFullMoone: "Chưa xác minh",
      CustomerWritesFirst: "Khách hàng liên hệ trước",
      NoHandle: "Chưa sử dụng Chat",
      LeaveChannel: "Rời kênh",
      LeaveConfirmTitle: "Rời kênh?",
      LeaveConfirmMessage:
        "Bạn có chắc chắn muốn rời khỏi kênh này? Bạn sẽ không còn nhận được tin nhắn từ cuộc trò chuyện này.",
      Leave: "Rời",
      LeaveError: "Không thể rời kênh",
    },
    Roles: {
      Customer: "Người dùng",
      Merchant: "Thương nhân",
      Hunter: "Hunter",
      HunterPlus: "Hunter",
      Admin: "Quản trị viên",
      CustomerOnboarding: "Hỗ trợ khách hàng",
    },
    Rename: {
      Title: "Đổi tên cuộc trò chuyện",
      Save: "Lưu",
      Cancel: "Hủy",
      Error: "Không thể đổi tên cuộc trò chuyện",
    },
    Requests: {
      Accept: "Chấp nhận",
      Reject: "Từ chối",
      RequestMessage: "{{name}} muốn trò chuyện với bạn",
      AcceptError: "Không thể chấp nhận yêu cầu trò chuyện",
      RejectError: "Không thể từ chối yêu cầu trò chuyện",
      ShowRejected: "Lời mời bị từ chối",
      ShowPending: "Quay lại yêu cầu",
      Join: "Tham gia",
      JoinError: "Không thể tham gia kênh",
      RejectedMessage: "Bạn đã từ chối lời mời này",
    },
    PaymentRequest: {
      Pending: "Chờ thanh toán",
      Pay: "Thanh toán",
      Drawer: {
        Title: "Yêu cầu thanh toán",
        BankAccount: "Tài khoản ngân hàng",
        Amount: "Số tiền",
        Note: "Thêm ghi chú",
        NotePlaceholder: "Nội dung ghi chú",
        Submit: "Gửi yêu cầu",
        Error: "Không thể tạo yêu cầu",
        InvalidCurrency:
          "Tài khoản đã chọn dùng loại tiền tệ khác với loại tiền tệ của yêu cầu",
        Validation: {
          SelectBankAccount: "Chọn tài khoản ngân hàng",
          EnterAmount: "Nhập số tiền",
          AmountMustBePositive: "Số tiền phải là số dương",
        },
      },
    },
    DirectPayment: {
      Sent: "Thanh toán đã gửi",
      Received: "Thanh toán đã nhận",
      Drawer: {
        Title: "Thanh toán trực tiếp",
        BankAccount: "Tài khoản ngân hàng",
        Amount: "Số tiền",
        Note: "Thêm ghi chú",
        NotePlaceholder: "Nội dung ghi chú",
        Submit: "Gửi thanh toán",
        Error: "Không thể gửi thanh toán",
        RecipientNoPrimaryAccount:
          "Người nhận không có tài khoản ngân hàng chính đang hoạt động",
        InvalidCurrency: "Tài khoản của người nhận dùng loại tiền tệ khác",
        RecipientCurrencyNotSupported:
          "Hiện tại người nhận chỉ có thể nhận thanh toán bằng CZK",
        RecipientLimitExceeded:
          "Thanh toán này sẽ vượt quá hạn mức nhận tiền của người nhận",
        NotChannelMember:
          "Bạn chỉ có thể gửi thanh toán cho thành viên của cuộc trò chuyện này",
        MessageNotPosted:
          "Thanh toán đã được gửi nhưng không thể đăng vào cuộc trò chuyện",
      },
    },
    MultiPayerRequest: {
      Description: "Yêu cầu thanh toán cho mọi người",
      ThreadTitle: "Thanh toán nhóm",
      Pay: "Thanh toán",
      Close: "Đóng",
      CloseError: "Không thể đóng yêu cầu",
      Closed: "Đã đóng",
      Unavailable: "Không khả dụng",
      Payments: {
        Count: "{{count}} thanh toán",
        Count_one: "{{count}} thanh toán",
        Count_other: "{{count}} thanh toán",
      },
      Drawer: {
        Title: "Yêu cầu thanh toán",
        Amount: "Số tiền mỗi người",
        Hint: "Mọi thành viên trong nhóm đều có thể thanh toán số tiền này vào tài khoản chính của bạn, nhiều lần tùy ý. Các khoản thanh toán sẽ hiển thị bên dưới yêu cầu.",
        Submit: "Gửi yêu cầu",
        Error: "Không thể gửi yêu cầu",
      },
    },
    PaymentMenu: {
      DirectPayment: "Gửi thanh toán",
      PaymentRequest: "Trả tiền cho tôi",
      LiteRestriction:
        "Thanh toán trong trò chuyện sẽ khả dụng sau khi bạn hoàn tất đăng ký.",
      LiteBankRestriction:
        "Chúng tôi đã có dữ liệu cá nhân và giấy tờ tùy thân của bạn. Thanh toán trong trò chuyện sẽ khả dụng sau khi tài khoản ngân hàng của bạn được kết nối và xác minh.",
      LitePayUnavailable: "Hoàn tất đăng ký để thanh toán",
      RecipientNotFullMoone:
        "Người dùng này chưa hoàn tất đăng ký nên chưa thể nhận thanh toán.",
    },
    TransactionStatus: {
      Created: "Đã tạo",
      Initiated: "Đã khởi tạo",
      Processing: "Đang xử lý",
      Success: "Thành công",
      Fail: "Thất bại",
      Cancelled: "Đã hủy",
      Unknown: "Không xác định",
    },
    Preview: {
      PaymentRequest: "Yêu cầu thanh toán",
      DirectPayment: "Thanh toán trực tiếp",
    },
    PushCaption: {
      PaymentRequest: "Yêu cầu thanh toán",
      DirectPaymentSent: "Đã gửi",
    },
  },
  Admin: {
    Terminals: {
      PageTitle: "Thiết bị đầu cuối",
      Table: {
        SerialNumber: "Số sê-ri",
        Tid: "TID",
        Mid: "MID",
        HardwareModel: "Loại thiết bị",
        Status: "Trạng thái",
        Financing: "Tài trợ",
        Hunter: "Hunter",
        Merchant: "Người bán",
        Facility: "Cơ sở",
        PurchasePrice: "Giá mua",
        LastChangedAt: "Thay đổi gần nhất",
        Ship: "Gửi đi",
      },
      Status: {
        InStock: "Trong kho",
        AssignedToHunter: "Ở Hunter",
        AssignedToMerchant: "Đã gán",
        Shipped: "Đã gửi",
        WithMerchant: "Ở người bán",
        Deployed: "Đã triển khai",
        Returned: "Đã trả lại",
      },
      Financing: {
        Moone: "Mo.one",
        Hunter: "Hunter",
      },
      Form: {
        SerialNumber: "Số sê-ri",
        HardwareModel: "Loại thiết bị",
        PurchasePrice: "Giá mua",
        Currency: "Tiền tệ",
        Status: "Trạng thái",
        AddTitle: "Thêm thiết bị",
        Save: "Lưu",
        Cancel: "Hủy",
        Delete: "Xóa",
      },
      AssignHunter: {
        HunterLabel: "Hunter",
        SearchHint: "Tên, công ty hoặc e-mail",
        NoOptions: "Không tìm thấy hunter nào",
      },
      Validation: {
        SerialNumberRequired: "Số sê-ri là bắt buộc",
        HardwareModelRequired: "Loại thiết bị đầu cuối là bắt buộc",
      },
      Audit: {
        Title: "Lịch sử thay đổi",
        Empty: "Chưa có thay đổi nào",
        When: "Khi nào",
        Field: "Trường",
        Change: "Thay đổi",
        Who: "Ai",
      },
      Messages: {
        LoadError: "Không thể tải danh sách thiết bị",
        UpdateSuccess: "Đã lưu thiết bị",
        CreateSuccess: "Đã thêm thiết bị",
        UpdateError: "Lưu thiết bị thất bại",
        DuplicateSerialNumber: "Thiết bị với số sê-ri này đã tồn tại",
        DeleteSuccess: "Đã xóa thiết bị",
        DeleteError: "Xóa thiết bị thất bại",
        DeleteConfirm:
          "Bạn có chắc muốn xóa thiết bị {{serialNumber}}? Chỉ dùng cho bản ghi được tạo nhầm.",
        ShipSuccess: "Thiết bị đã được đánh dấu là đã gửi",
        ShipError: "Không thể đánh dấu thiết bị là đã gửi",
      },
    },
    SsoClients: {
      PageTitle: "Ứng dụng SSO",
      CreateButton: "Đăng ký ứng dụng",
      Table: {
        ClientId: "Client ID",
        DisplayName: "Tên",
        Type: "Loại",
        Confidential: "Có backend",
        Public: "Công khai (PKCE)",
        RedirectUris: "Redirect URI",
        AllowedRoles: "Được hành động với vai trò",
        AllowedScopes: "Phạm vi API",
        Actions: "Thao tác",
        RotateSecret: "Tạo secret mới",
        Delete: "Xóa",
      },
      Form: {
        CreateTitle: "Đăng ký ứng dụng",
        EditTitle: "Chỉnh sửa ứng dụng {{clientId}}",
        ClientId: "Client ID",
        DisplayName: "Tên (hiển thị cho người dùng khi đồng ý)",
        IsConfidential: "Ứng dụng có backend riêng (nhận client secret)",
        IsConfidentialHint:
          "Không có backend (SPA, di động) thì ứng dụng là công khai: chỉ PKCE, không có secret, không thể hành động thay người dùng. Loại không thể đổi sau này.",
        RedirectUris: "Redirect URI",
        RedirectUrisHint:
          "Khớp chính xác, https (http chỉ cho localhost). Nhấn Enter để thêm.",
        PostLogoutRedirectUris: "Redirect URI sau khi đăng xuất",
        AllowedRoles: "Vai trò được phép hành động",
        AllowedRolesHint:
          "Để trống = ứng dụng chỉ đăng nhập. Có vai trò thì được đổi lấy context token.",
        AllowedScopes: "Phạm vi API (scopes)",
        AllowedScopesHint:
          "Ứng dụng được gọi gì. Các scope “Ứng dụng: …” dành cho backend không có người dùng (client_credentials), còn lại để hành động thay người dùng đã đăng nhập. Để trống = chỉ đăng nhập và ngữ cảnh.",
        ListPlaceholder: "Nhập giá trị và nhấn Enter",
        Submit: "Đăng ký",
        Save: "Lưu",
        Cancel: "Hủy",
      },
      Validation: {
        ClientIdInvalid: "3–64 ký tự: chữ thường, chữ số và dấu gạch ngang",
        DisplayNameRequired: "Tên là bắt buộc",
        RedirectUriRequired: "Cần ít nhất một redirect URI",
        RedirectUriInvalid:
          "Redirect URI phải là địa chỉ https tuyệt đối không có fragment (http chỉ cho localhost)",
        ScopeRequiresRole:
          "Phạm vi API cần ít nhất một vai trò mà ứng dụng hành động",
      },
      Scopes: {
        Payments: "Thanh toán (API thanh toán)",
        Merchant:
          "Người bán (nhân viên, điểm thanh toán, mã PIN, hồ sơ công ty)",
        Hunter: "Hunter (thiết bị, điểm, liên kết affiliate của mình)",
        TerminalsManage: "Ứng dụng: kho thiết bị đầu cuối (đọc và ghi)",
        DirectoryRead:
          "Ứng dụng: danh sách người dùng và hunter, merchant của hunter",
        CouponsCreate: "Ứng dụng: phát hành mã giảm giá",
        LoyaltyRead:
          "Ứng dụng: chương trình khách hàng thân thiết (kỳ, bảng xếp hạng)",
      },
      Secret: {
        Title: "Client secret cho {{clientId}}",
        Warning:
          "Secret chỉ hiển thị lúc này. Hãy lưu vào kho mật khẩu và bàn giao an toàn; không thể hiển thị lại, chỉ có thể tạo mới.",
        Label: "Client secret",
        Copy: "Sao chép secret",
        Copied: "Đã sao chép!",
        Close: "Tôi đã lưu",
      },
      Messages: {
        LoadError: "Không tải được danh sách ứng dụng",
        CreateSuccess: "Đã đăng ký ứng dụng",
        CreateError: "Không đăng ký được ứng dụng",
        ClientIdTaken: "Client ID này đã tồn tại",
        UpdateSuccess: "Đã lưu ứng dụng",
        UpdateError: "Không lưu được ứng dụng",
        DeleteConfirmTitle: "Xóa ứng dụng",
        DeleteConfirm:
          "Xóa ứng dụng {{clientId}}? Mọi đồng ý và token của nó sẽ mất, người dùng sẽ bị đăng xuất khỏi ứng dụng.",
        DeleteSuccess: "Đã xóa ứng dụng",
        DeleteError: "Không xóa được ứng dụng",
        RotateConfirmTitle: "Client secret mới",
        RotateConfirm:
          "Tạo secret mới cho {{clientId}}? Secret cũ hết hiệu lực ngay, ứng dụng không đăng nhập được nếu thiếu secret mới.",
        RotateError: "Không tạo được secret mới",
      },
    },
    Coupons: {
      PageTitle: "Mã giảm giá",
      CreateButton: "Tạo mã giảm giá",
      Table: {
        Code: "Mã",
        Region: "Quốc gia",
        Discount: "Giảm giá",
        DiscountType: "Loại giảm giá",
        Expiration: "Hết hạn",
        Usage: "Đã sử dụng",
        Status: "Trạng thái",
        Delete: "Xóa",
        CopyCode: "Sao chép mã",
        CodeCopied: "Đã sao chép!",
      },
      Status: {
        Active: "Hoạt động",
        Expired: "Đã hết hạn",
        OutOfStock: "Đã hết",
      },
      Form: {
        DialogTitle: "Tạo mã giảm giá mới",
        Code: "Mã giảm giá",
        Region: "Quốc gia",
        AutoGenerate: "Tự động tạo mã",
        Discount: "Giảm giá",
        DiscountType: "Loại giảm giá",
        Percentage: "Phần trăm (%)",
        FixedAmount: "Số tiền cố định",
        Expiration: "Ngày hết hạn",
        Stock: "Số lần sử dụng",
        StockHelp: "Tối thiểu: {{min}} (đã sử dụng)",
        Submit: "Tạo",
        Save: "Lưu",
        Cancel: "Hủy",
        EditTitle: "Chỉnh sửa mã giảm giá",
        EditTitleWithCode: "Chỉnh sửa mã giảm giá {{code}}",
      },
      Validation: {
        CodeRequired: "Mã giảm giá là bắt buộc",
        DiscountRequired: "Giảm giá là bắt buộc",
        DiscountPositive: "Giảm giá phải là số dương",
        DiscountMax100: "Giảm giá phần trăm không được vượt quá 100%",
        ExpirationRequired: "Ngày hết hạn là bắt buộc",
        StockRequired: "Số lần sử dụng là bắt buộc",
        StockMin: "Số lần sử dụng phải ít nhất là 1",
      },
      Messages: {
        CreateSuccess: "Đã tạo mã giảm giá",
        CreateError: "Không thể tạo mã giảm giá",
        LoadError: "Lỗi khi tải mã giảm giá",
        DeleteSuccess: "Đã xóa mã giảm giá",
        DeleteError: "Không thể xóa mã giảm giá",
        DeleteConfirmTitle: "Xóa mã giảm giá",
        DeleteConfirm: "Bạn có chắc chắn muốn xóa mã giảm giá {{code}}?",
        UpdateSuccess: "Đã cập nhật mã giảm giá",
        UpdateError: "Không thể cập nhật mã giảm giá",
      },
    },
    Raffle: {
      PageTitle: "Quay số trúng thưởng",
      CreateButton: "Vòng mới",
      Table: {
        Region: "Thị trường",
        Name: "Tên",
        Type: "Loại",
        TypeDefault: "Vòng chính",
        TypeCompetition: "Cuộc thi",
        Status: "Trạng thái",
        DrawDate: "Ngày quay số",
        Tickets: "Vé số",
        Participants: "Người tham gia",
        Checksum: "Dấu vân tay bảng quay số (SHA-256)",
        ChecksumHelp:
          "Được tạo khi đóng vòng từ danh sách số đã sinh (không có thông tin người giữ vé). Bảng quay số tải về được đối chiếu với nó và cùng dấu vân tay này được ghi vào biên bản quay số — chứng minh việc quay số diễn ra trên đúng tệp do hệ thống tạo.",
        ChecksumCopied: "Đã sao chép dấu vân tay",
        AllocationChecksum: "Dấu vân tay phân bổ số (SHA-256)",
        AllocationChecksumHelp:
          "Được tạo khi đóng vòng, niêm phong việc ai giữ những số nào. Ghi vào biên bản quay số cạnh dấu vân tay bảng quay số. Mỗi lần tra cứu người trúng thưởng đều đối chiếu với nó — nếu việc phân bổ không còn khớp, việc tra cứu sẽ bị từ chối.",
        AllocationChecksumCopied: "Đã sao chép dấu vân tay",
        Empty: "Chưa có vòng nào — vòng đầu tiên sẽ bắt đầu tích lũy vé.",
        Unscheduled: "Chưa có ngày quay số",
      },
      Status: {
        Draft: "Bản nháp",
        Announced: "Đã công bố",
        Closed: "Đã đóng",
        Drawn: "Đã quay số",
        Cancelled: "Đã hủy",
      },
      Actions: {
        Edit: "Chỉnh sửa",
        View: "Xem chi tiết",
        Announce: "Công bố",
        Close: "Đóng vòng",
        Complete: "Đánh dấu đã quay",
        Export: "Tải bảng quay số",
        FindHolder: "Tra cứu người trúng",
        Cancel: "Hủy cuộc thi",
        SetDefault: "Đặt làm vòng chính",
      },
      Form: {
        CreateTitle: "Vòng quay số mới",
        EditTitle: "Chỉnh sửa vòng",
        Region: "Thị trường",
        Name: "Tên vòng",
        DrawDate: "Ngày quay số",
        Rewards: "Giải thưởng",
        AddReward: "Thêm giải thưởng",
        RewardTitle: "Tên giải thưởng",
        RewardDescription: "Mô tả",
        RewardQuantity: "Số lượng",
        RemoveReward: "Xóa",
        Submit: "Lưu",
        Cancel: "Hủy",
        MainRoundWarning:
          "Thị trường này chưa có vòng chính nào đang mở. Vòng này sẽ trở thành vòng chính của thị trường và bắt đầu tích lũy vé ngay. Không thể hủy vòng chính.",
      },
      Validation: {
        NameRequired: "Nhập tên vòng",
        RewardTitleRequired: "Nhập tên giải thưởng",
        RegionRequired: "Chọn thị trường",
        RewardQuantityInvalid:
          "Số lượng giải thưởng phải là số nguyên không âm",
        TicketNumberInvalid: "Nhập số vé là số nguyên từ 1 trở lên",
        TicketNumberRange: "Nhập số vé từ 1 đến {{max}}",
      },
      Messages: {
        LoadError: "Không thể tải các vòng quay số",
        CreateSuccess: "Đã tạo vòng",
        CreateError: "Không thể tạo vòng",
        UpdateSuccess: "Đã lưu vòng",
        UpdateError: "Không thể lưu vòng",
        UpdateConflict:
          "Vòng đã được công bố hoặc bị hủy trong lúc đó và không thể chỉnh sửa nữa.",
        AnnounceSuccess: "Đã công bố vòng",
        AnnounceError: "Không thể công bố vòng",
        AnnounceConfirmTitle: "Công bố vòng “{{name}}” ({{region}})?",
        AnnounceConfirm:
          "Khi công bố, ngày quay số và danh sách giải thưởng trở thành cam kết công khai và không thể thay đổi nữa. Thay đổi chỉ có thể áp dụng cho vòng tiếp theo.",
        AnnounceRequirements:
          "Thêm ngày quay số sắp tới, ít nhất một giải thưởng và tên vòng thật trước khi công bố",
        CloseSuccess: "Đã đóng vòng",
        CloseError: "Không thể đóng vòng",
        CloseConfirmTitle: "Đóng vòng “{{name}}” ({{region}})?",
        CloseConfirm:
          "Việc đóng vòng không thể hoàn tác: vé số được đánh số, bảng quay số được tạo và việc tích lũy tiếp tục sang vòng sau. Vé nhận sau khi đóng thuộc về vòng tiếp theo.",
        CloseCompetitionConfirm:
          "Việc đóng vòng không thể hoàn tác: vé số được đánh số và bảng quay số được tạo.",
        CompleteSuccess: "Vòng được đánh dấu là đã quay số",
        CompleteError: "Không thể đánh dấu vòng",
        CompleteConfirmTitle:
          "Đánh dấu vòng “{{name}}” ({{region}}) là đã quay số?",
        CompleteConfirm:
          "Bạn xác nhận việc quay số đã diễn ra theo quy trình được ghi nhận và kết quả đã được lưu hồ sơ.",
        CancelSuccess: "Đã hủy cuộc thi",
        CancelError: "Không thể hủy cuộc thi",
        CancelConfirmTitle: "Hủy cuộc thi “{{name}}” ({{region}})?",
        CancelConfirm:
          "Cuộc thi nháp sẽ bị hủy và được lưu lại trong hệ thống với trạng thái đã hủy. Không thể hủy cuộc thi đã công bố.",
        SetDefaultSuccess: "Vòng này hiện là vòng chính của thị trường",
        SetDefaultError: "Không thể đặt vòng chính",
        SetDefaultConfirmTitle:
          "Đặt vòng “{{name}}” ({{region}}) làm vòng chính?",
        SetDefaultConfirm:
          "Từ giờ vé mới sẽ được cộng vào vòng này. Vòng chính hiện tại sẽ trở thành cuộc thi thông thường: nếu đã công bố thì vé trong đó vẫn được giữ nguyên; vòng chưa công bố (bản nháp) sẽ chuyển vé của mình sang vòng chính mới.",
        ExportError: "Không thể tải bảng quay số",
        ExportIntegrityError:
          "Bảng quay số không vượt qua kiểm tra toàn vẹn — đừng quay số từ bảng này và hãy liên hệ đội phát triển.",
      },
      HolderLookup: {
        Title: "Tra cứu người trúng thưởng",
        TicketNumber: "Số vé",
        Search: "Tra cứu",
        HolderName: "Người giữ vé",
        Email: "E-mail",
        TicketCount: "Số vé trong vòng",
        Range: "Khoảng số",
        NotFound: "Không tìm thấy số vé",
        SealMismatch:
          "Việc phân bổ số không khớp với trạng thái khi đóng vòng — yêu cầu tra cứu đã bị từ chối. Hãy liên hệ đội phát triển.",
        Error: "Tra cứu thất bại — hãy thử lại",
      },
    },
    Campaigns: {
      PageTitle: "Quản lý chiến dịch",
      CreatePageTitle: "Tạo chiến dịch",
      CreateButton: "Tạo chiến dịch mới",
      DraftCampaigns: "Bản nháp",
      PublishedCampaigns: "Chiến dịch đã xuất bản",
      ArchivedCampaigns: "Chiến dịch đã lưu trữ",
      Table: {
        CampaignName: "Tên chiến dịch",
        Code: "Mã",
        Receiver: "Người nhận",
        NoReceiverAssigned: "Chưa gán người nhận",
        Affiliate: "Liên kết",
        Enabled: "Đã bật",
        Disabled: "Đã tắt",
        Status: "Trạng thái",
        StatusOnRestore: "Trạng thái khi khôi phục",
        StartDate: "Ngày bắt đầu",
        EndDate: "Ngày kết thúc",
        Unlimited: "Không giới hạn",
        Created: "Đã tạo",
        Deleted: "Đã xóa",
        Actions: "Hành động",
        ViewCampaign: "Xem chiến dịch",
        Edit: "Chỉnh sửa",
        Delete: "Xóa",
        Restore: "Khôi phục",
        CopyUrl: "Sao chép URL chiến dịch",
        UrlCopied: "Đã sao chép URL",
      },
      Status: {
        Draft: "Bản nháp",
        DraftDescription: "Chiến dịch này là bản nháp",
        Archived: "Đã lưu trữ",
        ArchivedDescription: "Chiến dịch này đã được lưu trữ",
        ActiveUnlimited: "Đang hoạt động (Không giới hạn)",
        UnlimitedDescription: "Chiến dịch này chạy vô thời hạn",
        StartsToday: "Bắt đầu hôm nay",
        StartsTomorrow: "Bắt đầu ngày mai",
        StartsInDays: "Bắt đầu sau {{days}} ngày",
        StartsOn: "Bắt đầu vào {{date}}",
        Finished: "Đã kết thúc",
        EndedOn: "Kết thúc vào {{date}}",
        EndsToday: "Kết thúc hôm nay",
        DayLeft: "Còn 1 ngày",
        DaysLeft: "Còn {{days}} ngày",
        EndsOn: "Kết thúc vào {{date}}",
        Active: "Đang hoạt động",
        CurrentlyRunning: "Đang chạy",
        NotStarted: "Sắp tới",
      },
      Form: {
        BasicInformation: "Thông tin cơ bản",
        CampaignName: "Tên chiến dịch",
        CampaignNamePlaceholder: "ví dụ: Quỹ từ thiện ABC",
        CampaignCode: "Mã chiến dịch (đường dẫn URL)",
        CampaignCodePlaceholder: "ví dụ: quy-tu-thien-abc",
        CampaignCodeHelperCreate:
          "Chỉ sử dụng chữ thường không dấu, số và dấu gạch ngang.",
        CampaignCodeHelperEdit: "Không thể thay đổi mã sau khi tạo",
        Description: "Mô tả",
        DescriptionPlaceholder: "Mô tả ngắn về chiến dịch",
        DescriptionCharCount: "{{count}}/500",
        EnableAffiliateProgram: "Bật chương trình liên kết",
        CampaignValidity: "Thời hạn chiến dịch",
        DateModeUnlimited: "Không giới hạn",
        DateModeUnlimitedDescription:
          "Chiến dịch không có ngày bắt đầu hoặc kết thúc",
        DateModeFromTo: "Từ - Đến",
        DateModeFromToDescription:
          "Chiến dịch chạy trong khoảng thời gian cụ thể",
        StartDate: "Ngày bắt đầu",
        EndDate: "Ngày kết thúc",
        ThankYouSection: "Phần cảm ơn",
        Color: "Màu chiến dịch",
        ColorHelp:
          "Màu chính của chiến dịch (định dạng hex, ví dụ: #FF9400). Màu hover sẽ tự động tối hơn. Để trống để sử dụng màu mặc định.",
        PaymentInstructionsText: "Hướng dẫn thanh toán",
        PaymentInstructionsTextPlaceholder:
          "Thanh toán cà phê với Mo.one. Chúng tôi sẽ đóng góp cho các gia đình có con bị bệnh nặng để họ có chỗ ở gần bệnh viện. Để họ có thể ở bên nhau.",
        PaymentInstructionsTextHelper:
          "Văn bản hiển thị trong bước timeline 'Thanh toán tại quán'. Mô tả cách thanh toán giúp chiến dịch. Tối đa 500 ký tự.",
        OnlyWithMooneText: "Văn bản chỉ với Mo.one",
        OnlyWithMooneTextPlaceholder:
          "Bất cứ nơi nào bạn thanh toán với Mo.one, chúng tôi sẽ gửi tiền hỗ trợ các gia đình có con bị bệnh nặng để họ có chỗ ở gần bệnh viện. Để họ có thể ở bên nhau.<newline/><newline/>Chỉ cần tạo tài khoản và bắt đầu!",
        OnlyWithMooneTextHelper:
          "Văn bản hiển thị trong bước timeline 'Bất kỳ phương thức'. Khuyến khích sử dụng Mo.one để thanh toán. Tối đa 500 ký tự.",
        UnlimitedDateInfo:
          "Chiến dịch này sẽ chạy vô thời hạn không có ngày bắt đầu hoặc kết thúc.",
        PaymentReceiver: "Người nhận thanh toán",
        PaymentReceiverDescription:
          "Chọn người dùng thương nhân sẽ nhận thanh toán từ chiến dịch này",
        MerchantUser: "Người dùng thương nhân",
        CampaignContent: "Nội dung trang đích",
        HeaderTitle: "Tiêu đề header",
        HeaderTitlePlaceholder: "ví dụ: Hỗ trợ đào tạo chó dẫn đường",
        FoundationLinkName: "Tên liên kết quỹ",
        FoundationLinkNamePlaceholder: "ví dụ: Tìm hiểu thêm",
        FoundationLinkNameHelper: "Văn bản cho liên kết đến trang web quỹ",
        FoundationLinkUrl: "URL liên kết quỹ",
        FoundationLinkUrlPlaceholder: "https://example.org",
        FoundationLinkUrlHelper: "URL đến trang web quỹ",
        SuccessfulPaymentText: "Văn bản cảm ơn sau thanh toán thành công",
        SuccessfulPaymentTextPlaceholder: "Cảm ơn bạn đã đóng góp!",
        SuccessfulPaymentTextHelper:
          "Văn bản hiển thị sau khi thanh toán thành công ({{count}}/1000)",
        Images: "Hình ảnh (Sắp ra mắt)",
        Logo: "Logo",
        LogoHelper: "Logo chiến dịch (PNG/SVG)",
        LandingImage: "Hình trang đích",
        LandingImageHelper: "Hình xem trước trang đích (PNG/JPG)",
        Icon: "Biểu tượng (Tùy chọn)",
        IconHelper: "Biểu tượng chiến dịch (PNG/SVG)",
        ThankYouImage: "Hình thanh toán thành công",
        ThankYouImageHelper: "Hình ảnh hiển thị sau khi thanh toán thành công",
        ImageUploadSuccess: "Hình ảnh đã được tải lên",
        ImageUploadError: "Không thể tải lên hình ảnh",
        UploadError: {
          invalidFileType:
            "Loại tệp không được hỗ trợ. Định dạng cho phép: PNG, JPEG, SVG.",
          fileSizeExceeded: "Tệp quá lớn.",
          fileContentMismatch: "Nội dung tệp không khớp với loại tệp.",
        },
        StepBasicInfo: "Thông tin cơ bản",
        StepLandingPage: "Trang đích",
        StepThankYouPage: "Trang cảm ơn",
        StepValidity: "Hiệu lực",
        PreviewCampaignPage: "Xem trước trang chiến dịch",
        PreviewThankYouPage: "Xem trước trang cảm ơn",
        ImageDeleteSuccess: "Đã xóa hình ảnh",
        ImageDeleteError: "Không thể xóa hình ảnh",
        CreateButton: "Tạo chiến dịch",
        UpdateLandingPageButton: "Cập nhật trang đích",
        UpdateThankYouPageButton: "Cập nhật trang cảm ơn",
        NextStepButton: "Bước tiếp theo",
        PreviousStepButton: "Bước trước",
        SaveChangesButton: "Lưu thay đổi",
        SaveButton: "Lưu",
        CloseButton: "Đóng",
        PublishButton: "Xuất bản",
        PublishRequiresReceiver:
          "Để xuất bản chiến dịch, bạn phải chọn người nhận thanh toán.",
        ArchiveButton: "Lưu trữ",
        UnpublishButton: "Hủy xuất bản",
        CampaignIsLive: "Chiến dịch đang hoạt động",
        UpdateButton: "Cập nhật chiến dịch",
        Validation: {
          NameRequired: "Tên chiến dịch là bắt buộc",
          CodeRequired: "Mã chiến dịch là bắt buộc",
          CodeInvalidFormat:
            "Mã chỉ được chứa chữ thường, số và dấu gạch ngang. Không cho phép ký tự đặc biệt.",
          DescriptionRequired: "Mô tả là bắt buộc",
          InvalidUrl: "Phải là URL hợp lệ",
          InvalidColor:
            "Phải là màu hợp lệ ở định dạng hex (ví dụ: #FF9400 hoặc #FF940080)",
          MaxLength: "Độ dài tối đa là {{max}} ký tự",
          DateRangeRequired:
            "Ngày bắt đầu và ngày kết thúc là bắt buộc khi chọn khoảng thời gian",
          EndDateAfterStartDate:
            "Ngày kết thúc phải sau hoặc bằng ngày bắt đầu",
        },
      },
      Messages: {
        CreateSuccess: "Tạo chiến dịch thành công! URL: /campaign/{{code}}",
        CreateError: "Không thể tạo chiến dịch",
        UpdateSuccess: "Cập nhật chiến dịch thành công!",
        UpdateError: "Không thể cập nhật chiến dịch",
        PublishSuccess: "Đã xuất bản chiến dịch",
        ArchiveSuccess: "Đã lưu trữ chiến dịch",
        UnpublishSuccess: "Đã hủy xuất bản chiến dịch",
        CodeExistsError: "Mã chiến dịch đã tồn tại hoặc không hợp lệ",
        DeleteConfirm: "Bạn có chắc chắn muốn xóa chiến dịch này không?",
        DeleteSuccess: "Xóa chiến dịch thành công",
        DeleteError: "Không thể xóa chiến dịch",
        RestoreConfirm: "Bạn có chắc chắn muốn khôi phục chiến dịch này không?",
        RestoreSuccess: "Khôi phục chiến dịch thành công",
        RestoreError: "Không thể khôi phục chiến dịch",
        LoadCampaignsError: "Không thể tải danh sách chiến dịch",
        EditCampaignTitle: "Chỉnh sửa chiến dịch: {{name}}",
      },
    },
    SettlementPoolBoosts: {
      StardustBoost: "Stardust Boost",
      ValorBoost: "Valor Boost",
      Regions: {
        CZ: "Cộng hòa Séc",
        SK: "Slovakia",
      },
      BoostAmount: "Số tiền tăng cường ({{currency}})",
      DistributionRatio: "Tỷ lệ phân phối",
      HunterPoolRatio: "Giấy phép",
      ValorPoolRatio: "Điểm Valor",
      CurrentPoolTotal: "Tổng pool hiện tại ({{currency}})",
      PoolTotalLoadError: "Không thể tải pool hiện tại",
      SaveButton: "Lưu",
      SaveSuccess: "Cập nhật tăng cường thành công",
      LoadingError: "Không thể tải cấu hình tăng cường",
      Validation: {
        BoostAmountNonNegative: "Số tiền tăng cường không được âm",
        RatioSumMustBe100: "Tổng tỷ lệ phải bằng 100",
      },
    },
    VatStatusRefresh: {
      Title: "Sổ đăng ký VAT",
      Description:
        "Kiểm tra lại trạng thái đăng ký VAT của tất cả công ty và hộ kinh doanh trong các sổ đăng ký (CZ: sổ đăng ký người nộp VAT, SK: VIES). Chạy ở chế độ nền; kết quả nằm trong nhật ký Worker.",
      Button: "Cập nhật trạng thái VAT",
      Loading: "Đang khởi chạy...",
      Success: "Đã bắt đầu cập nhật trạng thái VAT.",
      Error: "Không thể bắt đầu cập nhật trạng thái VAT.",
    },
    PaymentSimulation: {
      Title: "Mô phỏng thanh toán (sandbox)",
      Description:
        "Đánh dấu một khoản thanh toán sandbox là đã thanh toán, như thể ngân hàng đã báo đã quyết toán. Chỉ dành cho giao dịch loại Thanh toán với ngân hàng sandbox ở trạng thái Đã khởi tạo, Đang xử lý hoặc Cần điều tra. Chỉ khả dụng trên môi trường test và staging.",
      PublicIDLabel: "Mã giao dịch",
      Button: "Đánh dấu đã thanh toán",
      Loading: "Đang đánh dấu...",
      ConfirmTitle: "Mô phỏng thanh toán?",
      ConfirmText:
        "Giao dịch {{publicID}} sẽ được đánh dấu là đã thanh toán. Các bước tiếp theo sẽ chạy giống như với thanh toán thật (thông báo, webhook, quyết toán).",
      Success: "Giao dịch {{publicID}} đã được đánh dấu là đã thanh toán.",
      Errors: {
        NotFound:
          "Không tìm thấy giao dịch, hoặc mô phỏng đã bị tắt trên môi trường này.",
        Forbidden: "Chỉ quản trị viên mới có thể chạy mô phỏng.",
        NotPayment: "Chỉ có thể mô phỏng giao dịch loại Thanh toán.",
        NotSandbox:
          "Giao dịch không có thanh toán sandbox. Hãy thanh toán bằng ngân hàng sandbox trước.",
        StatusNotAllowed:
          "Giao dịch không ở trạng thái cho phép mô phỏng thanh toán.",
        Generic: "Không thể thực hiện mô phỏng thanh toán.",
      },
    },
  },
  Devices: {
    List: {
      LoadingError: "Lỗi khi tải thiết bị",
      Name: "Tên",
      PayPoint: "Paypoint",
      DateCreated: "Đã tạo",
      LastUsedAt: "Sử dụng lần cuối",
      RevokeConfirm: "Bạn có chắc chắn muốn thu hồi thiết bị này không?",
      RevokeSuccess: "Đã thu hồi thiết bị",
      RevokeError: "Không thể thu hồi thiết bị",
      RegenerateConfirm:
        "Bạn có chắc chắn muốn tạo lại khóa? Khóa hiện tại sẽ ngừng hoạt động.",
      RegenerateSuccess: "Đã tạo khóa mới",
      RegenerateError: "Không thể tạo lại khóa",
      NewDeviceSecret: "Khóa thiết bị mới",
      CopyDeviceSecret: "Sao chép khóa",
      DeviceSecretCopied: "Đã sao chép khóa vào clipboard",
      AddDevice: "Thêm thiết bị",
      DeviceName: "Tên thiết bị",
      SelectPayPoint: "Chọn paypoint",
      LinkSuccess: "Đã kết nối thiết bị",
      LinkError: "Không thể kết nối thiết bị",
      NoTerminalPayPoints:
        "Bạn không có paypoint terminal nào khả dụng. Vui lòng tạo paypoint loại Terminal trước.",
      DeviceSecretWarning:
        "Khóa này chỉ hiển thị một lần. Vui lòng sao chép và lưu trữ an toàn — sau này không thể lấy lại.",
    },
  },
  PaymentGateways: {
    Legend: "Cổng thanh toán",
    Description:
      "Thông tin xác thực để tích hợp cổng thanh toán Mo.one vào e-shop của bạn. Client secret chỉ hiển thị một lần khi tạo.",
    ClientID: "Client ID",
    CopyClientID: "Sao chép Client ID",
    ClientIDCopied: "Đã sao chép Client ID",
    LastUsedAt: "Sử dụng lần cuối",
    NoCredential: "Thông tin xác thực chưa được tạo.",
    Generate: "Tạo thông tin xác thực",
    Regenerate: "Client secret mới",
    Revoke: "Thu hồi thông tin xác thực",
    Secret: {
      CreatedTitle: "Đã tạo thông tin xác thực",
      RegeneratedTitle: "Đã tạo client secret mới",
      Warning:
        "Client secret chỉ hiển thị một lần. Vui lòng sao chép và lưu trữ an toàn — sau này không thể lấy lại.",
      ClientID: "Client ID",
      ClientSecret: "Client secret",
      Copied: "Đã sao chép vào clipboard",
      Close: "Đóng",
    },
    Messages: {
      GenerateError: "Không thể tạo thông tin xác thực",
      RegenerateConfirmTitle: "Tạo client secret mới",
      RegenerateConfirm:
        "Bạn có chắc chắn muốn tạo client secret mới không? Cái hiện tại sẽ ngừng hoạt động ngay lập tức và phải được cập nhật trong e-shop.",
      RegenerateError: "Không thể tạo client secret mới",
      RevokeConfirmTitle: "Thu hồi thông tin xác thực",
      RevokeConfirm:
        "Bạn có chắc chắn muốn thu hồi thông tin xác thực không? E-shop sẽ ngừng nhận thanh toán ngay lập tức cho đến khi bạn tạo mới.",
      RevokeSuccess: "Đã thu hồi thông tin xác thực",
      RevokeError: "Không thể thu hồi thông tin xác thực",
    },
  },
  TerminalPin: {
    Title: "Mã PIN terminal",
    Description:
      "Nhập mã PIN 4 chữ số này trên terminal khi đăng nhập. Dùng để xác định ai đang vận hành thiết bị.",
    NoPinYet:
      "Chưa có mã PIN. Mã sẽ được tạo khi merchant gán bạn vào paypoint terminal.",
    Reveal: "Hiển thị",
    Hide: "Ẩn",
    Regenerate: "Tạo mã PIN mới",
    RegenerateConfirm:
      "Bạn có chắc chắn muốn tạo mã PIN mới? Mã PIN hiện tại sẽ ngừng hoạt động.",
    RegenerateSuccess: "Đã tạo mã PIN mới",
    RegenerateError: "Không thể tạo mã PIN mới",
  },
  UserSettings: {
    BalanceVisibility: {
      Title: "Hiển thị số dư",
      Label: "Hiển thị số dư trên màn hình chính",
      Description:
        "Khi tắt, số dư bị ẩn và chỉ hiển thị sau khi nhấn vào biểu tượng con mắt.",
    },
    QuickPayment: {
      Title: "Thanh toán nhanh",
    },
  },
  Sso: {
    Consent: {
      Intro:
        "Ứng dụng {{app}} yêu cầu quyền truy cập vào tài khoản {{appName}} của bạn.",
      PermissionsHeading: "Ứng dụng sẽ nhận được:",
      RevokeHint:
        "Bạn có thể thu hồi quyền truy cập bất cứ lúc nào trong Cài đặt → Ứng dụng đã kết nối.",
      Allow: "Cho phép",
      Deny: "Từ chối",
      Redirecting: "Đang chuyển đến ứng dụng…",
      ReauthTitle: "Đăng nhập lại",
      ReauthText:
        "Ứng dụng {{app}} yêu cầu đăng nhập mới. Sau khi đăng nhập lại, bạn sẽ được đưa trở lại đây.",
      ReauthButton: "Đăng nhập lại",
      SignedInAs: "Đã đăng nhập với {{who}}",
      UseAnotherAccount: "Dùng tài khoản khác",
      MissingRequest:
        "Thiếu thông tin yêu cầu đăng nhập. Vui lòng bắt đầu lại từ ứng dụng bạn đang đăng nhập.",
    },
    ConnectedApps: {
      Empty: "Bạn chưa đăng nhập vào ứng dụng nào bằng {{appName}}.",
      ConnectedAt: "Đã kết nối {{date}}",
      Disconnect: "Ngắt kết nối",
      DisconnectConfirmTitle: "Ngắt kết nối ứng dụng",
      DisconnectConfirm:
        "Ứng dụng {{app}} sẽ mất quyền truy cập vào tài khoản của bạn và sẽ hỏi lại sự đồng ý khi đăng nhập lần sau.",
      DisconnectSuccess: "Đã ngắt kết nối ứng dụng.",
      DisconnectError: "Không thể ngắt kết nối ứng dụng.",
      LoadError: "Không thể tải danh sách ứng dụng đã kết nối.",
    },
    Scopes: {
      OpenId: "Đăng nhập",
      Profile: "Tên của bạn",
      Email: "Địa chỉ e-mail của bạn",
      OfflineAccess: "Duy trì đăng nhập (không cần đăng nhập lại)",
      Contexts: "Hành động thay cho các vai trò của bạn trong {{appName}}",
      Payments: "Nhận thanh toán cho công ty của bạn",
      Merchant: "Quản lý nhân viên, điểm thanh toán và mã PIN của công ty bạn",
      Hunter: "Thiết bị đầu cuối, điểm và liên kết affiliate của bạn",
      TerminalsManage: "Kho thiết bị đầu cuối",
      DirectoryRead: "Danh sách người dùng và hunter",
      CouponsCreate: "Phát hành mã giảm giá",
      LoyaltyRead: "Chương trình khách hàng thân thiết",
    },
    Errors: {
      RequestNotFound:
        "Yêu cầu đăng nhập không tồn tại. Vui lòng bắt đầu lại từ ứng dụng.",
      RequestExpired:
        "Yêu cầu đăng nhập đã hết hạn. Vui lòng bắt đầu lại từ ứng dụng.",
      RequestNotPending:
        "Yêu cầu này đã được xử lý. Vui lòng bắt đầu lại từ ứng dụng.",
      IdentityRequired:
        "Tài khoản của bạn cần được hoàn tất trước. Hãy đăng nhập vào {{appName}} và thử lại.",
      IdentityNotActive:
        "Tài khoản của bạn không hoạt động, không thể đăng nhập vào ứng dụng.",
      BackOfficeNotAllowed:
        "Tài khoản quản trị không thể đăng nhập vào ứng dụng đối tác.",
      ConsentNotFound:
        "Sự đồng ý không còn hiệu lực. Vui lòng bắt đầu lại từ ứng dụng.",
      ClientNotFound: "Ứng dụng chưa được đăng ký.",
      Unknown: "Đăng nhập vào ứng dụng không thành công.",
    },
  },
  Beta: {
    Badge: "Beta",
    RoadmapUrl: "https://mo.one/roadmap",
    AuthCard: {
      Title: "Chào mừng đến với Beta của {{appName}}!",
      Body: "Chúng tôi đang cải tiến. Xem kế hoạch trong <roadmap>Roadmap</roadmap>.",
    },
    Drawer: {
      Title: "Chào mừng đến với Beta của {{appName}}!",
      BodyFirst:
        "Chúng tôi vẫn đang phát triển ứng dụng và cải tiến mỗi ngày. Nếu bạn gặp lỗi hoặc bất kỳ vấn đề nào, vui lòng cho chúng tôi biết qua nút <reportButton /> ở phía trên màn hình.",
      BodySecond:
        "Nếu bạn muốn biết {{appName}} đang đi về đâu, hãy xem <roadmap>Roadmap của chúng tôi</roadmap>.",
      BodyThird: "Cảm ơn bạn đã giúp chúng tôi phát triển.",
      Continue: "Tiếp tục",
      Close: "Đóng",
    },
    MenuItem: "{{appName}} Beta",
  },
};
